export interface Keys {
	locale: never;
	"btn.cancel": never;
	"btn.delete": never;
	"btn.edit": never;
	"btn.sign_in": never;
	"btn.submit": never;
	"btn.submit_filters": never;
	"btn.clear_filters": never;
	"btn.reset_password": never;
	"btn.new_reset_password": never;
	"btn.continue": never;
	"label.already_have_account": never;
	"account.signup.new.password": never;
	"account.signup.new.password.instruction": never;
	"account.signup.label.password": never;
	"account.reset_password.expired": never;
	"profile.height.unit": never;
	"profile.weight.unit": never;
	"label.user.gender": never;
	"label.user.id": never;
	"label.user.first_name": never;
	"label.user.last_name": never;
	"label.user.email": never;
	"label.user.phone": never;
	"label.user.postal_code": never;
	"label.user.city": never;
	"label.user.country": never;
	"label.user.status": never;
	"label.user.plain_password.zero": never;
	"label.user.plain_password.first": never;
	"label.user.plain_password.second": never;
	"label.player.birthday": never;
	"label.player.birthday_short": never;
	"label.player.nationality": never;
	"label.player.nationality1": never;
	"label.player.nationality2": never;
	"label.player.position": never;
	"label.player.position1": never;
	"label.player.position2": never;
	"label.player.strongest_foot": never;
	"label.player.strongest_foot.left": never;
	"label.player.strongest_foot.right": never;
	"player.strongest_foot.left": never;
	"player.strongest_foot.right": never;
	"label.player.strongest_foot.left.letter": never;
	"label.player.strongest_foot.right.letter": never;
	"label.player.height": never;
	"label.player.weight": never;
	"label.player.photo": never;
	"label.player.team": never;
	"label.player.notes": never;
	"label.player.vip": never;
	"player.vip.success": never;
	"label.match.date": never;
	"label.match.time": never;
	"label.match.homeTeam": never;
	"label.match.awayTeam": never;
	"label.match.awayClub": never;
	"label.team.category": never;
	"label.match.pole_id": never;
	"label.level": never;
	"label.coach": never;
	"label.admin": never;
	"label.user": never;
	"label.create_account.admin": never;
	"label.create_account.coach": never;
	"label.update": never;
	"label.coach.empty_select": never;
	"label.select_team_category": never;
	"label.team_name": never;
	"label.team_name_error": never;
	"label.edit": never;
	"label.not_my_player": never;
	"label.add_player.photo_infos": never;
	"label.remove_player.cancel": never;
	"form.club.add_team.success": never;
	"form.club.assign_coach.coach_unassign": never;
	"form.club.assign_coach.success": never;
	"form.club.level_update.success": never;
	"form.club.match_sheet.edit.success": never;
	"enum.colors.black": never;
	"enum.colors.white": never;
	"enum.colors.red": never;
	"enum.colors.orange": never;
	"enum.colors.yellow": never;
	"enum.colors.green": never;
	"enum.colors.blue": never;
	"enum.colors.gray": never;
	"enum.colors.brown": never;
	"enum.colors.purple": never;
	"enum.position.G": never;
	"enum.position.DD": never;
	"enum.position.DC": never;
	"enum.position.DG": never;
	"enum.position.MDC": never;
	"enum.position.MC": never;
	"enum.position.MOC": never;
	"enum.position.MG": never;
	"enum.position.MD": never;
	"enum.position.MR": never;
	"enum.position.ATT": never;
	"enum.position.AG": never;
	"enum.position.AD": never;
	"enum.position.G.key": never;
	"enum.position.DD.key": never;
	"enum.position.DC.key": never;
	"enum.position.DG.key": never;
	"enum.position.MDC.key": never;
	"enum.position.MC.key": never;
	"enum.position.MOC.key": never;
	"enum.position.MG.key": never;
	"enum.position.MD.key": never;
	"enum.position.ATT.key": never;
	"enum.position.AG.key": never;
	"enum.position.AD.key": never;
	"mail.user.password.reset": never;
	"mail.user.sign.up": never;
	"message.reset_password.success": never;
	"message.reset_password.back_to_login": never;
	"message.request_password.success.msg": never;
	"message.request_password.fail.mail.msg": never;
	"message.request_password.fail.notfound.msg": never;
	"message.remove_user.success": never;
	"message.searching_player.none": never;
	"message.add_team.warning": never;
	"message.add_player_club.success": {
		lastname: string;
		firstname: string;
	};
	"message.remove_player_club.success": {
		lastname: string;
		firstname: string;
	};
	"message.edit_player_club": {
		lastname: string;
		firstname: string;
		br: (text: string) => any;
	};
	"error.invalid_email": never;
	"error.invalid_credentials": never;
	"error.bad_credentials": never;
	"error.invalid_permission": never;
	"error.not_active_account": {
		a: (text: string) => any;
	};
	"error.reset_password.invalid_token": never;
	"club.page_and_account": never;
	"club.planing_match": never;
	"club.teams": never;
	"club.users": never;
	"club.players": never;
	"club.games": never;
	"club.former_players": never;
	"club.non_partner_club": never;
	"count.club.amat": never;
	"count.club.pro": never;
	"filter.alphabetic_asc": never;
	"filter.alphabetic_desc": never;
	"filter.date_asc": never;
	"filter.date_desc": never;
	"filter.installation": never;
	"filter.search_placeholder": never;
	"filter.add_club": never;
	"filter.add_match": never;
	"filter.add_player": never;
	"filter.add_team": never;
	"filter.delete_team": never;
	"filter.add_recruiter": never;
	"filter.edit_recruiter": never;
	"form_add_club_amateur.label.logo": {
		br: (text: string) => any;
	};
	"form_add_club_amateur.label.name": never;
	"form_add_club_amateur.placeholder.name": never;
	"form_add_club_amateur.label.country": never;
	"form_add_club_amateur.placeholder.country": never;
	"form_add_club_amateur.label.address": never;
	"form_add_club_amateur.placeholder.address": never;
	"form_add_club_amateur.label.zipcode": never;
	"form_add_club_amateur.placeholder.zipcode": never;
	"form_add_club_amateur.label.city": never;
	"form_add_club_amateur.placeholder.city": never;
	"form_add_club_amateur.label.region": never;
	"form_add_club_amateur.placeholder.region": never;
	"form_add_club_amateur.placeholder.geographicalArea": never;
	"form_add_club_amateur.label.description": never;
	"form_add_club_amateur.placeholder.description": never;
	"form_add_club_amateur.label.idClub": never;
	"form_add_club_amateur.placeholder.idClub": never;
	"form_add_club_amateur.label.email": never;
	"form_add_club_amateur.placeholder.email": never;
	"form_add_club_amateur.label.phoneNumber": never;
	"form_add_club_amateur.placeholder.phoneNumber": never;
	"form_add_club_amateur.label.contactLastName": never;
	"form_add_club_amateur.placeholder.contactLastName": never;
	"form_add_club_amateur.label.contactFirstName": never;
	"form_add_club_amateur.placeholder.contactFirstName": never;
	"form_add_club_amateur.label.sent": never;
	"form_add_club_amateur.label.geographicalArea": never;
	"form_add_club_amateur.label.documents": never;
	"form_add_club_amateur.label.documents.add": never;
	"form_edit_club_amateur.label.edit": never;
	"form_edit_club_amateur.label.valid_edit": never;
	"form_edit_club_amateur.label.cancel_edit": never;
	"form_add_club_amateur.title": never;
	"form_add_club_amateur.header": never;
	"form_add_club_amateur.documents.mimeTypesMessage": never;
	"form_add_club_pro.placeholder.idClub": never;
	"form_add_club_pro.label.is_active": never;
	"form_add_club_pro.label.is_active.true": never;
	"form_add_club_pro.label.is_active.false": never;
	"form_add_club_pro.header": never;
	"form_edit_player.title": never;
	"form_search_player_pro.birthmonth": never;
	"form_search_player_pro.birthyear": never;
	"form_search_player_pro.category": never;
	"form_search_pro_club_amateur.region": never;
	"form_search_pro_club_amateur.category": never;
	"form_search_pro_club_amateur.level": never;
	"breadcrumb.casual_club": never;
	"breadcrumb.casual_club_pro": never;
	"breadcrumb.casual_club_add": never;
	"breadcrumb.casual_club_infos": never;
	"breadcrumb.casual_club_users": never;
	"breadcrumb.casual_club_teams": never;
	"breadcrumb.casual_club_videos": never;
	"breadcrumb.casual_club_plan_matches": never;
	"breadcrumb.video_list": never;
	"breadcrumb.search_club": never;
	"breadcrumb.search_player": never;
	"clubInfos.pole": never;
	"bool.yes": never;
	"bool.no": never;
	"clubAmateur.users.clubManagerTable.title": never;
	"clubAmateur.users.clubManagerTable.add_button": never;
	"clubAmateur.users.clubManagerTable.modal.add_admin.title": never;
	"clubAmateur.users.clubManagerTable.modal.edit_admin.title": never;
	"clubAmateur.users.clubCoachesTable.title": never;
	"clubAmateur.users.clubCoachesTable.add_button": never;
	"clubAmateur.users.clubCoachesTable.modal.add_coach.title": never;
	"clubAmateur.users.clubCoachesTable.modal.edit_coach.title": never;
	"clubAmateur.users.clubManagerTable.colTitle.id": never;
	"clubAmateur.users.clubManagerTable.colTitle.firstname": never;
	"clubAmateur.users.clubManagerTable.colTitle.lastname": never;
	"clubAmateur.users.clubManagerTable.colTitle.email": never;
	"clubAmateur.users.clubManagerTable.colTitle.phone_number": never;
	"clubAmateur.users.clubManagerTable.colTitle.password": never;
	"clubAmateur.users.clubManagerTable.colTitle.team": never;
	"clubAmateur.users.modal.delete_text": {
		user_name: string;
		br: (text: string) => any;
		user_type: string;
	};
	"clubAmateur.users.modal.delete_button": never;
	"clubAmateur.teams.sectionTitle.teams": never;
	"clubAmateur.teams.sectionTitle.my_teams": never;
	"clubAmateur.teams.button.remove_team": {
		remove_link: string;
		a: (text: string) => any;
	};
	"clubAmateur.videos.title": never;
	"matchList.filter.team": never;
	"matchList.filter.range_date": never;
	"match.maillot": never;
	"match.short": never;
	"match.replacementteam": never;
	"match.score.edit.success": never;
	"match.aside.tab.teams": never;
	"match.highlight.btn.new": never;
	"match.highlight.btn.submit": never;
	"match.highlight.btn.reset": never;
	"match.highlight.required": never;
	"match.highlight.error.highlight_title_max_exceed": never;
	"match.highlight.edit": never;
	"match.highlight.delete.yes": never;
	"match.highlight.add": never;
	"match.highlight.empty": never;
	"match.highlight.error.unauthorized": never;
	"match.reported": never;
	"highlight.placeholder.timestamp": never;
	"highlight.placeholder.title": never;
	"highlight.placeholder.note": never;
	"match.team.position": never;
	"match.team.yob": never;
	"match.team.num": never;
	"match.team.goals": never;
	"match.edit_matchsheet": never;
	"match.add_matchsheet": never;
	"matchSheet.placeholder.position": never;
	"matchSheet.placeholder.playerName": never;
	"matchSheet.placeholder.numberSign": never;
	"matchSheet.placeholder.goal": never;
	"matchSheet.table.position": never;
	"matchSheet.table.playerName": never;
	"matchSheet.table.numberSign": never;
	"matchSheet.table.numberSign_mobile": never;
	"matchSheet.table.goal": never;
	"matchSheet.title": never;
	"matchSheet.composition": never;
	"matchSheet.jersey_color": never;
	"matchSheet.color_shorts": never;
	"matchSheet.title.workforce": never;
	"matchSheet.title.replacements": never;
	"matchSheet.button.add.replacement": never;
	"matchSheet.button.add.loadteam": never;
	"matchSheet.title.changes": never;
	"matchSheet.label.edit": never;
	"matchSheet.label.cancel_edit": never;
	"matchSheet.label.valid_edit": never;
	"form.add_match.success": never;
	"form.edit_match.success": never;
	"filter.daterange.placeholder": never;
	"filter.button.finished": never;
	"filter.button.coming": never;
	"videos.table.th.club": never;
	"videos.table.th.date": never;
	"videos.table.th.opponent": never;
	"videos.table.th.score": never;
	"videos.table.th.upload": never;
	"videos.table.th.vip": never;
	"videos.table.score.add": never;
	"videos.vip.success": never;
	"videos.hidden.success": never;
	"videos.modal.add_score.submit": never;
	"videos.modal.add_score.title": never;
	"videos.modal.edit_match.title": never;
	"videos.modal.add_match.title": never;
	"videos.modal.add_match.cancel": never;
	"videos.modal.filter.title": never;
	"players.modal.filter.title": never;
	"teams.modal.filter.title": never;
	"datatables.search": never;
	"datatables.aria.sort_ascending": never;
	"datatables.aria.sort_descending": never;
	"datatables.paginate.first": never;
	"datatables.paginate.previous": never;
	"datatables.paginate.next": never;
	"datatables.paginate.last": never;
	"datatables.processing": never;
	"datatables.lenght_menu": never;
	"datatables.info": never;
	"datatables.info_empty": never;
	"datatables.info_filtered": never;
	"datatables.loading_records": never;
	"datatables.zero_records": never;
	"datatables.empty_table": never;
	"form.club.add_club_manager.success": never;
	"form.club.edit_club_manager.success": never;
	"form.club.add_coach.success": never;
	"form.club.edit_coach.success": never;
	"form.club.add_recruiter.success": never;
	"form.club.edit_recruiter.success": never;
	"highlight.add.success": never;
	"highlight.edit.success": never;
	"highlight.delete.success": never;
	"daterange.applyLabel": never;
	"daterange.cancelLabel": never;
	"datepicker.closeText": never;
	"datepicker.days.sunday": never;
	"datepicker.days.monday": never;
	"datepicker.days.tuesday": never;
	"datepicker.days.wednesday": never;
	"datepicker.days.thursday": never;
	"datepicker.days.friday": never;
	"datepicker.days.saturday": never;
	"datepicker.days_short.sunday": never;
	"datepicker.days_short.monday": never;
	"datepicker.days_short.tuesday": never;
	"datepicker.days_short.wednesday": never;
	"datepicker.days_short.thursday": never;
	"datepicker.days_short.friday": never;
	"datepicker.days_short.saturday": never;
	"global.days_min.sunday": never;
	"global.days_min.monday": never;
	"global.days_min.tuesday": never;
	"global.days_min.wednesday": never;
	"global.days_min.thursday": never;
	"global.days_min.friday": never;
	"global.days_min.saturday": never;
	"datepicker.months.january": never;
	"datepicker.months.february": never;
	"datepicker.months.march": never;
	"datepicker.months.april": never;
	"datepicker.months.may": never;
	"datepicker.months.june": never;
	"datepicker.months.july": never;
	"datepicker.months.august": never;
	"datepicker.months.september": never;
	"datepicker.months.october": never;
	"datepicker.months.november": never;
	"datepicker.months.december": never;
	"datepicker.months_short.january": never;
	"datepicker.months_short.february": never;
	"datepicker.months_short.march": never;
	"datepicker.months_short.april": never;
	"datepicker.months_short.may": never;
	"datepicker.months_short.june": never;
	"datepicker.months_short.july": never;
	"datepicker.months_short.august": never;
	"datepicker.months_short.september": never;
	"datepicker.months_short.october": never;
	"datepicker.months_short.november": never;
	"datepicker.months_short.december": never;
	"player.birthday": never;
	"player.nationality": never;
	"front.login.title": never;
	"admin.login.title": never;
	"admin.login.forgot_password": never;
	"admin.login.remember_me": never;
	"admin.login.email.placeholder": never;
	"admin.login.password.placeholder": never;
	"admin.login.email.required": never;
	"admin.login.password.required": never;
	"forgot_password.title": never;
	"forgot_password.subtitle": never;
	"forgot_password.email": never;
	"forgot_password.sent": never;
	"email.see_on_site.text": never;
	"email.see_on_site.text.click_here": never;
	"email.copyright": never;
	"email.hello": never;
	"email.new_password.please_click": never;
	"email.new_account.please_click": never;
	"email.new_password.link_choose": never;
	"email.new_account.link_choose": never;
	"header.not_loged.contact": never;
	"header.not_loged.login": never;
	"header.admin.club_amat": never;
	"header.admin.upload_video": never;
	"header.admin.club_pro": never;
	"header.club_amat.my_club": never;
	"header.club_amat.team": never;
	"header.club_amat.planing": never;
	"header.club_pro.search_club": never;
	"header.club_pro.search_player": never;
	"header.club_pro.search_match": never;
	"header.club_pro.my_eyeball": never;
	"header.club_pro.search": never;
	"header.open_mobile_menu": never;
	"header.account.options": never;
	"header.account.options.close": never;
	"header.change_password": never;
	"header.logout": never;
	"error.password.not_matching": never;
	"error.password.incorrect": never;
	"error.email.not_unique": never;
	"error.password.old": never;
	FR: never;
	"players.goals": never;
	"players.defenders": never;
	"players.strikers": never;
	"subheader.clubPro.video_matchs": never;
	"subheader.clubPro.team": never;
	"clubProCalendar.calendar.match.championship": never;
	"clubProCalendar.calendar.match.cup": never;
	"clubProCalendar.calendar.ranking.cup": never;
	"clubPro.plyers.modal.filter": never;
	"clubPro.player.matchsTitle": never;
	"subheader.my_eyeball": never;
	"subheader.my_eyeball.matchs": never;
	"subheader.my_eyeball.clubs": never;
	"subheader.my_eyeball.teams": never;
	"subheader.my_eyeball.players": never;
	"subheader.my_eyeball.my_account": never;
	"regionMap.title": never;
	"regionMap.label.nord_ouest": never;
	"regionMap.label.nord_est": never;
	"regionMap.label.idf": never;
	"regionMap.label.centre": never;
	"regionMap.label.sud_ouest": never;
	"regionMap.label.sud_est": never;
	"my_eyeball.title": never;
	"my_eyeball.title.teams": never;
	"my_eyeball.title.matchs": never;
	"my_eyeball.title.players": never;
	"my_eyeball.title.clubs": never;
	match: never;
	clubs: never;
	teams: never;
	players: never;
	"label.player.type": never;
	amical: never;
	coupe: never;
	championnat: never;
	eightaside: never;
	poletest: never;
	"search.filter.content_type": never;
	"search.filter.content_type.matchs": never;
	"search.filter.content_type.clubs": never;
	"search.filter.content_type.joueurs": never;
	"clubHeader.contact.modal.btn": never;
	"clubHeader.contact.modal.title": never;
	"form_add_club_amateur.label.contactPosition": never;
	"form_add_club_amateur.placeholder.contactPosition": never;
	"form_add_club_amateur.placeholder.comments": never;
	"form_add_club_amateur.label.comments": never;
	"form_add_club_amateur.label.contractStartDate": never;
	"form_add_club_amateur.placeholder.contractStartDate": never;
	"formDocuments.empty": never;
	"formDocuments.remove": never;
	"formDocuments.see": never;
	"formDocuments.modal.remove.title": {
		file: string;
	};
	"formDocuments.modal.confirm_remove": never;
	"search.placeholder": never;
	"search_no_result.clubs": never;
	"search_no_result.teams": never;
	"search_no_result.players": never;
	"search_no_result.matchs": never;
	"search_no_result.my_eyeball.clubs": never;
	"search_no_result.my_eyeball.teams": never;
	"search_no_result.my_eyeball.players": never;
	"search_no_result.my_eyeball.matchs": never;
	"home.club_pro.last_matchs": never;
	"home.club_pro.show_all_matchs": never;
	"home.club_pro.show_all_clubs": never;
	"home.club_pro.search_clubs": {
		br: (text: string) => any;
	};
	"home.club_pro.search_players": {
		br: (text: string) => any;
	};
	"home.club_pro.my_eyeball": never;
	"home.club_pro.nb_clubs_amat": {
		count: number;
	};
	"home.club_pro.nb_players_amat": {
		count: number;
	};
	"home.club_pro.nb_clubs": {
		count: number;
	};
	"home.club_pro.nb_players": {
		count: number;
	};
	"home.club_pro.nb_teams": {
		count: number;
	};
	"home.club_pro.nb_matchs": {
		count: number;
	};
	"home.club_pro.show_clubs": never;
	"home.club_pro.show_players": never;
	"home.club_pro.show_profils": never;
	"home.club_pro.player_to_watch": never;
	"select2.close_dropdown": never;
	"home.club_pro.game_to_watch": never;
	"footer.copyright": never;
	"footer.legals": never;
	"login.app.role.notsupported.scout": never;
	"match.placeholder.description": never;
	"match.description.special_char_error": never;
	"match.description.success": never;
	"matchsheet.required.substitute.name": never;
	"matchsheet.required.substitute.number": never;
	"header.club_pro.upcoming_games": never;
	"error.message.no_games_found": never;
	"planmatch.api.add.error.pasttime.content": never;
	"form.required.validation.message": never;
	"login.form.required.validation.message": never;
	"club_amateur.planification_match.add_game_popup.date.placeholder": never;
	"email.contains.comma.validation.message": never;
	"email.invalid.validation.message": never;
	"match.unknown_away_club_logo_max_size_exceed": never;
	"club_pro.club_amateur.search.placeholder": never;
	"club_pro.club_amateur.search.error.invalid_data": never;
	"app.coach.error.timeout": never;
	"app.coach.squad.player_name": never;
	"app.coach.squad.add_player_first_name_title": never;
	"app.coach.squad.add_player_last_name_title": never;
	"app.coach.squad.add_player_nationality_2_hint": never;
	"app.coach.squad.add_player_strong_foot_title": never;
	"app.coach.squad.add_player_position_1_hint": never;
	"app.coach.squad.edit_player_title": never;
	"app.coach.squad.add_squad_category_title": never;
	"app.coach.game.highlight.validate.title": never;
	"app.coach.game.highlight.validate.title_max": never;
	"app.coach.game.highlight.validate.note": never;
	"app.coach.game.highlight.validate.timestamp": never;
	"app.coach.game_program.no_results": never;
	"app.coach.game.score.validate.score": never;
	"app.coach.game.score.validate.range": never;
	"videos.table.th.category": never;
	"admin.club.validate.length.firstname": never;
	"admin.club.validate.length.lastname": never;
	"game.tab.full_match_video": never;
	"game.tab.player_stats": never;
	"game.stats.menu.summary": never;
	"game.stats.menu.offensive": never;
	"game.stats.menu.defensive": never;
	"game.stats.menu.distribution": never;
	"game.stats.menu.goalkeeper": never;
	"game.stats.menu.label": never;
	"game.stats.table.playerName": never;
	"game.stats.table.position": never;
	"game.stats.table.rating": never;
	"game.stats.table.minutesPlayed": never;
	"game.stats.table.goalsScrored": never;
	"game.stats.table.assists": never;
	"game.stats.table.offsides": never;
	"game.stats.table.shots": never;
	"game.stats.table.freekicks": never;
	"game.stats.table.corners": never;
	"game.stats.table.throwIns": never;
	"game.stats.table.fouls": never;
	"game.stats.table.yellowCards": never;
	"game.stats.table.redCards": never;
	"game.stats.table.goalsConceded": never;
	"game.stats.table.catches": never;
	"game.stats.table.punches": never;
	"game.stats.table.goalsKicksSuccess": never;
	"game.stats.table.goalsKicksTotal": never;
	"game.stats.table.aerialClearancesSuccess": never;
	"game.stats.table.aerialClearancesTotal": never;
	"game.stats.table.passesSuccess": never;
	"game.stats.table.passesTotal": never;
	"game.stats.table.passAccuracy": never;
	"game.stats.table.keyPasses": never;
	"game.stats.table.passesInFinalThirdSuccess": never;
	"game.stats.table.passesInFinalThirdTotal": never;
	"game.stats.table.passesInMiddleThirdSuccess": never;
	"game.stats.table.passesInMiddleThirdTotal": never;
	"game.stats.table.passesInDefensiveThirdSuccess": never;
	"game.stats.table.passesInDefensiveThirdTotal": never;
	"game.stats.table.longPassesSuccess": never;
	"game.stats.table.longPassesTotal": never;
	"game.stats.table.mediumRangePassesSuccess": never;
	"game.stats.table.mediumRangePassesTotal": never;
	"game.stats.table.shortPassesSuccess": never;
	"game.stats.table.shortPassesTotal": never;
	"game.stats.table.passesForwardSuccess": never;
	"game.stats.table.passesForwardTotal": never;
	"game.stats.table.passesSidewaysSuccess": never;
	"game.stats.table.passesSidewaysTotal": never;
	"game.stats.table.passesBackwardSuccess": never;
	"game.stats.table.passesBackwardTotal": never;
	"game.stats.table.crossesSuccess": never;
	"game.stats.table.crossesTotal": never;
	"game.stats.table.controlUnder": never;
	"game.stats.table.shotsOnTarget": never;
	"game.stats.table.blockedShots": never;
	"game.stats.table.shotsOffTarget": never;
	"game.stats.table.shotsInsidePa": never;
	"game.stats.table.shotsOutsidePa": never;
	"game.stats.table.takeOnsSuccessful": never;
	"game.stats.table.takeOnsTotal": never;
	"game.stats.table.tacklesSuccess": never;
	"game.stats.table.tacklesTotal": never;
	"game.stats.table.aerialDuelsSuccess": never;
	"game.stats.table.aerialDuelsTotal": never;
	"game.stats.table.groundDuelsSuccess": never;
	"game.stats.table.groundDuelsTotal": never;
	"game.stats.table.interceptions": never;
	"game.stats.table.clearances": never;
	"game.stats.table.interventions": never;
	"game.stats.table.recoveries": never;
	"game.stats.table.blocks": never;
	"game.stats.table.mistakes": never;
	"game.stats.table.foulsWon": never;
	"videos.score.success": never;
	"game.stats.table.no": never;
	"game.stats.download.csv": never;
	"game.tab.team_stats": never;
	"game.stats.see_more": never;
	"game.stats.see_less": never;
	"game.stats.table.goals": never;
	"game.stats.table.possession": never;
	"game.stats.table.freeKicks": never;
	"game.stats.table.averageRating": never;
	"all.enum.geographical.center": never;
	"all.enum.geographical.north_west": never;
	"all.enum.geographical.north_east": never;
	"all.enum.geographical.south_west": never;
	"all.enum.geographical.south_est": never;
	"all.enum.geographical.ile_de_france": never;
	"videos.table.th.stats": never;
	"continent.africa": never;
	"continent.asia": never;
	"continent.europe": never;
	"continent.north_america": never;
	"continent.oceania": never;
	"continent.south_america": never;
	"club.non_partner_player": never;
	"country.selection.success.message": never;
	"country.selection.save.btn": never;
	"country.selection.selected.countries": never;
	"country.selection.choose.country": never;
	"date.format.d/m/Y": never;
	"date.format.dd/MM/yyyy": never;
	"date.format.d LLLL y": never;
	"match.team.player_action": never;
	"terms.agree": never;
	"terms.disagree": never;
	"countries.selection.text": never;
	"label.match.national": never;
	"game.not.found": never;
	"enum.position.GK": never;
	"enum.position.RB": never;
	"enum.position.CB": never;
	"enum.position.LB": never;
	"enum.position.RWB": never;
	"enum.position.LWB": never;
	"enum.position.CDM": never;
	"enum.position.RM": never;
	"enum.position.LM": never;
	"enum.position.CM": never;
	"enum.position.RW": never;
	"enum.position.LW": never;
	"enum.position.CAM": never;
	"enum.position.RF": never;
	"enum.position.LF": never;
	"enum.position.CF": never;
	"enum.position.GK.key": never;
	"enum.position.RB.key": never;
	"enum.position.LB.key": never;
	"enum.position.CB.key": never;
	"enum.position.RWB.key": never;
	"enum.position.LWB.key": never;
	"enum.position.CDM.key": never;
	"enum.position.RM.key": never;
	"enum.position.LM.key": never;
	"enum.position.CM.key": never;
	"enum.position.RW.key": never;
	"enum.position.LW.key": never;
	"enum.position.CAM.key": never;
	"enum.position.RF.key": never;
	"enum.position.LF.key": never;
	"enum.position.CF.key": never;
	"match.aside.tab.highlights": never;
	"tooltip.default": never;
	"tooltip.comingsoon": never;
	"eyeball.something.wrong": never;
	"videos.table.th.country": never;
	"delete.game.success.message": never;
	"product.management.nonpartner.datatset": never;
	"product.management.nonpartner.players": never;
	"product.management.nonpartner.clubs": never;
	"product.management.poles": never;
	"product.management.bundles": never;
	"product.management.notifications": never;
	"product.management.specific.notifications": never;
	"product.management.schedule.notifications": never;
	"product.management.admin.user.management": never;
	"product.management.admin.role.permission": never;
	"product.management.country.expansion": never;
	"product.management.feed.area": never;
	"product.management.player.account": never;
	"permission.read": never;
	"permission.create": never;
	"permission.delete": never;
	"permission.edit": never;
	"permission.set_permissions": never;
	"permission.migrate_to_nonpartner": never;
	"permission.migrate_to_partner": never;
	"permission.convert_to_partner": never;
	"permission.publish": never;
	"permission.assign_pole": never;
	"resource.product_management": never;
	"resource.poles": never;
	"resource.non_partner_clubs": never;
	"resource.non_partner_players": never;
	"resource.roles_permissions_management": never;
	"resource.admins_creation": never;
	"resource.bundles": never;
	"resource.notifications": never;
	"resource.countries_expansion": never;
	"resource.player_accounts_management": never;
	"resource.feed_area": never;
	"admin.user.role.creation": never;
	"admin.user.role.updation": never;
	"admin.user.deletion": never;
	"admin.role.creation": never;
	"admin.role.updation": never;
	"admin.role.permission.assign": never;
	"admin.role.deletion.permission.unassign": never;
	"product.management.admin.user.creation": never;
	"admin.role.restrict.delete": never;
	"admin.role.name.exists": never;
	"photo.upload.success": never;
	"pole.add.success": never;
	"pole.update.success": never;
	"pole.delete.success": never;
	"pole.assign.success": never;
	"pole.assign.error": never;
	"admin.pole.unique": never;
	"admin.pole.assigned.pole1": never;
	"admin.pole.assigned.pole2": never;
	"admin.pole.assigned.pole3": never;
	"error.nonPartnerClub.not_unique": never;
	"admin.nonPartnerClub.creation": never;
	"admin.nonPartnerClub.updation": never;
	"admin.nonPartnerClub.delete": never;
	"error.date.mismatch": never;
	"permission.assign_bundle": never;
	"admin.assign.subscription.club": never;
	"admin.unassign.subscription.club": never;
	"btn.save": never;
	"admin.nonPartnerPlayer.delete": never;
	"label.action": never;
	"label.user.role": never;
	"label.user.account": never;
	"label.admin.users": never;
	"label.switch": never;
	"label.user.add": never;
	"label.role.add": never;
	"label.timezone": never;
	"label.location": never;
	"label.current_battery": never;
	"label.assigned_club": never;
	"label.sync": never;
	"label.assign": never;
	"label.assigned": never;
	"label.pole_management": never;
	"label.add.pole": never;
	"label.assign.pole.club": never;
	"label.assign_into": never;
	"label.serial_number": never;
	"label.max_accounts": never;
	"label.countries": never;
	"message.select_country": never;
	"message.select_game_options": never;
	"label.form.start_date": never;
	"label.form.expiration_date": never;
	"label.pro_club": never;
	"label.game_options": never;
	"label.AI": never;
	"label.statistics_rating": never;
	"label.statistics_player": never;
	"label.statistics_team": never;
	"label.events": never;
	"label.search": never;
	"label.migrate": never;
	"label.unassign": never;
	"logo.upload.success": never;
	"pole.unassign.success": never;
	"pole.unassign.error": never;
	"form.club.edit_team.success": never;
	"clubAmateur.teams.button.edit_team": never;
	"migration.already.exists": never;
	"migration.validation.message.select_source_club": never;
	"migration.validation.message.select_target_club": never;
	"btn.execute_migration": never;
	"migration.btn.skip": never;
	"migration.btn.merge": never;
	"migration.btn.retain": never;
	"migration.players_migration_process": never;
	"migration.players_successfully_migrated": never;
	"migration.games_successfully_migrated": never;
	"migration.players_failed_while_migration": never;
	"migration.games_failed_while_migration": never;
	"migration.btn.more_details": never;
	"tooltip.purchase.country": never;
	"delete.confirmation.are_you_sure": never;
	"delete.confirmation.are_you_sure_want_to_delete": {
		title: string;
	};
	"delete.confirmation.yes_delete_it": never;
	"club.non_partner_club.games": never;
	"club.non_partner.label.country": never;
	"club.non_partner.label.games": never;
	"club.non_partner.label.teams": never;
	"club.non_partner.label.players": never;
	"club.non_partner.label.comments": never;
	"club.non_partner.view.title": never;
	"club.non_partner.label.createdAt": never;
	"club.non_partner.label.createdBy": never;
	"club.non_partner.label.updatedAt": never;
	"club.non_partner.label.updatedBy": never;
	"label.match.homeClub": never;
	"label.showcase": never;
	"form.club.match_sheet.players.autoload.success": never;
	"scout.player.moved_player_text": never;
	"scout.player.profile_club_title": never;
	"admin.sourceclub.migrate.delete": never;
	"label.product": never;
	"resource.clubs_amateur": never;
	"resource.club_amateur_users": never;
	"resource.club_amateur_user_directors": never;
	"resource.club_amateur_user_coachs": never;
	"resource.club_amateur_teams": never;
	"resource.club_amateur_team_players": never;
	"resource.club_amateur_games": never;
	"resource.game_uploads": never;
	"resource.clubs_pro": never;
	"resource.clubs_pro_users": never;
	"permission.list": never;
	"permission.game_vip": never;
	"permission.game_hidden": never;
	"permission.game_view": never;
	"permission.game_score": never;
	"permission.game_teamsheet": never;
	"label.add.subscription": never;
	"label.subscriptions_management": never;
	"label.assign.subscription.club": never;
	"label.subscription": never;
	"product.management.subscriptions": never;
	"label.download": never;
	"label.club_name": never;
	"label.contact_name": never;
	"label.contact_phone": never;
	"label.contact_email": never;
	"form.validation.please_select_timezone": never;
	"header.admin.product_management": never;
	"team.deleted.successfully": never;
	"message.edit_player_club.success": {
		lastname: string;
		firstname: string;
	};
	"player.already.exists": never;
	"label.subscription.comment": never;
	"admin.enabled.success": never;
	"admin.disabled.success": never;
	"admin.country.delete": never;
	"admin.country.updation": never;
	"admin.country.creation": never;
	"error.country.not_unique": {
		country: string;
	};
	"admin.npc.games": never;
	"admin.npc.players": never;
	"scout.subscription.popup_message": never;
	"club.status.missing": never;
	"btn.add_player": never;
	"btn.add_team": never;
	"btn.filter_by_team": never;
	"btn.club_teams": never;
	"btn.assign_coach_to_team": never;
	"btn.edit_team": never;
	"label.similar_player_already_exists": never;
	"message.no_players_available": never;
	"message.no_players_in_team": never;
	"permission.test_email": never;
	"resource.specific_notiifcations": never;
	"resource.schedule_notifications": never;
	"game.player.delete.restrict": never;
	"error.message.select_category": never;
	"label.notification_management": never;
	"error.message.select_nationality": never;
	"scout.not_subscription.popup_message": never;
	"label.language": never;
	"label.date/time": never;
	"label.method": never;
	"label.delivered": never;
	"message.message_copied": never;
	"label.author": never;
	"label.methods": never;
	"label.retry": never;
	"label.detail": never;
	"label.failed": never;
	"label.success": never;
	"label.add_notification": never;
	"label.notification": never;
	"message.please_select_method": never;
	"message.all_message_fields_required": never;
	"message.message_content_required": never;
	"label.receivers": never;
	"label.individual_user": never;
	"label.accounts": never;
	"resource.subscriptions": never;
	"permission.assign_subscription": never;
	"label.tooltip_message": never;
	"label.add": never;
	"label.Please_select_country": never;
	"error.message.select_position": never;
	"label.enable": never;
	"label.add_country": never;
	"label.update_country": never;
	"message.please_select_receivers": never;
	"label.signup_to_eyeball": never;
	"label.email_address": never;
	"label.mobile_number": never;
	"label.club": never;
	"label.role": never;
	"label.signup": never;
	"label.or_signup_with": never;
	"label.login_to_eyeball": never;
	"label.dont_have_account": never;
	"label.register": never;
	"label.google": never;
	"label.microsoft": never;
	"label.refresh": never;
	"btn.filter_by_coach": never;
	"favorite.remove.club": never;
	"favorite.add.club": never;
	"favorite.remove.match": never;
	"favorite.add.match": never;
	"favorite.remove.player": never;
	"favorite.add.player": never;
	"favorite.remove.team": never;
	"favorite.add.team": never;
	"label.destination": never;
	"label.as_your_selected": never;
	"label.message_title _reached_maximum_length": never;
	"label.filter_by_event(s)": never;
	"label.select_all": never;
	"gameAnalysis.add.success": never;
	"gameAnalysis.exists": never;
	"label.user.region": never;
	"label.player.geographicalArea": never;
	"club.non-partner": never;
	"message.error_download_link": never;
	"message.not_allowed_to_download": never;
	"admin.club.validate.character.contactEmail": never;
	"picture.delete.success": never;
	"profile.phone.missing": never;
	"form.validation.phone.wrong_format": never;
	"label.bepro": never;
	"label.physical_statistics": never;
	"label.first_half": never;
	"label.start_time": never;
	"label.end_time": never;
	"label.second_half": never;
	"title.add_game": never;
	"label.my_profile": never;
	"label.subheader_my_subscription": never;
	"label.unselect_all_countries": never;
	"label.select_all_countries": never;
	"label.my_subscriptions": never;
	"label.subscriptions.expired": never;
	"label.subscriptions.tooltip": never;
	"label.game_option_review": never;
	"label.game_option_players": never;
	"label.game_option_team": never;
	"label.game_option_events": never;
	"label.game_option_download": never;
	"label.delete_account.check_2": never;
	"label.delete_account.permanent": never;
	"user.no.longer": never;
	"label.create_clip_from_selectedevent_types": never;
	"label.create_clip": never;
	"label.enter_the_clip_name": never;
	"label.video_clip_name": never;
	"label.share": never;
	"label.rename": never;
	"label.manual": never;
	"label.share_the_clip": never;
	"label.clip_link(url)": never;
	"label.link_expire_date": never;
	"label.set_expiration_date_disable_Link_after_this_date": never;
	"label.password_protect": never;
	"label.by_adding_password_you_can_restrict_access": never;
	"label.enter_the_clip_url": never;
	"label.enter_the_password": never;
	"label.play_video": never;
	"message.clip_name_changed_successfully": never;
	"label.delete_account.placeholder": never;
	"label.datagrid.club_exists": never;
	"label.datagrid.club_exists_2": never;
	"label.datagrid.club_no_match": never;
	"label.button.proceed": never;
	"label.migrate.non_partner": never;
	"label.player_to": never;
	"label.club_to": never;
	"label.partner": never;
	"label.migration": never;
	"migration.error.close_modal": never;
	"migration.are_you_sure": never;
	"button.migration.confirm": never;
	"game.clip.add.success": never;
	"game.clip.delete.success": never;
	"game.clip.already.exists": never;
	"migration.note.1": never;
	"migration.note.2": never;
	"migration.note.3": never;
	"migration.placeholder.team": never;
	"label.migration.player_skipped": never;
	"label.notofications.message": never;
	"label.notofications.body": never;
	"max.clip.exceeded": never;
	"game.clip.overwrite.success": never;
	"game.clip.replace.success": never;
	"label.overwrite": never;
	"label.can_either_replace_last_clip_by_or_not_continue": never;
	"label.replace_it": never;
	"label.clips": never;
	"restore.my.account": never;
	"email.restore.my.account.please.click": never;
	"message.restore.my.account.mail.sent": never;
	"label.notification_modal.test": never;
	"message.restore.my.account.mail.failure": never;
	"label.no_longer.email_sent": never;
	"label.btn.back_to_login": never;
	"continents.northAmerica": never;
	"continents.southAmerica": never;
	"continents.africa": never;
	"continents.asia": never;
	"continents.europe": never;
	"continents.oceania": never;
	"continents.antarctica": never;
	"label.subscription.expiration_days": {
		daysToExpiration: string;
	};
	"label.director": never;
	"terms.conditions": never;
	"button.generate_link": never;
	"label.my_clips": never;
	"button.update_link": never;
	"label.copy_link": never;
	"message.link_copied_to_clipboard": never;
	"player.validate.phoneNumber": never;
	"player.validate.phoneNumber_string": never;
	"label.created_date": never;
	"migration.game-edit-status-note": never;
	"label.date_time": never;
	"label.migrated_players": never;
	"label.migrated_games": never;
	"edit.matchsheet.validate": never;
	"club.not.found": never;
	"error.phoneNumber.not_unique": never;
	"player.playedInNationalTeam": never;
	"scout.menu.national_leagues": never;
	"label.ownership": never;
	"title.link_expired": never;
	"msg.link_expired": never;
	"label.content_protected": never;
	"label.to_view_enter_password": never;
	"ownership-restrictions-alert": {
		nonOwnerShipGamesCount: string;
	};
	"user-contact-sales-team": never;
	"msg.clip_ready": never;
	"msg.team_sheet_not_completed ": never;
	"msg.select_country": never;
	"form_search_player_game.category": never;
	"label.select": never;
	"search_no_result.my_eyeball.clips": never;
	"label.password.clip.wrong_format": never;
	"game.clip.add.failed": never;
	"phoneNumber.validation.error.invalidCountryCode": never;
	"label.match.category": never;
	"prod.text.dynamic.player.13021.notes": never;
	"prod.text.dynamic.game.13878.description": never;
	"prod.text.dynamic.player.10400.notes": never;
	"prod.text.dynamic.player.10407.notes": never;
	"prod.text.dynamic.player.10718.notes": never;
	"prod.text.dynamic.game.13875.description": never;
	"prod.text.dynamic.game.13904.description": never;
	"prod.text.dynamic.game.13879.description": never;
	"prod.text.dynamic.game.13876.description": never;
	"prod.text.dynamic.game.13880.description": never;
	"prod.text.dynamic.game.13948.description": never;
	"message.clip_link_updated": never;
	"prod.text.dynamic.game.13962.description": never;
	"prod.text.dynamic.game.13947.description": never;
	"prod.text.dynamic.game.13988.description": never;
	"prod.text.dynamic.game.13984.description": never;
	"prod.text.dynamic.game.13987.description": never;
	"prod.text.dynamic.player.19747.notes": never;
	"prod.text.dynamic.game.13961.description": never;
	"prod.text.dynamic.game.13963.description": never;
	"prod.text.dynamic.game.13335.description": never;
	"prod.text.dynamic.game.13336.description": never;
	"prod.text.dynamic.game.13283.description": never;
	"prod.text.dynamic.game.13992.description": never;
	"prod.text.dynamic.game.13264.description": never;
	"prod.text.dynamic.player.23795.notes": never;
	"prod.text.dynamic.game.13261.description": never;
	"prod.text.dynamic.game.13280.description": never;
	"prod.text.dynamic.game.14000.description": never;
	"prod.text.dynamic.game.13997.description": never;
	"prod.text.dynamic.game.13877.description": never;
	"prod.text.dynamic.game.14013.description": never;
	"prod.text.dynamic.game.13995.description": never;
	"prod.text.dynamic.game.13881.description": never;
	"prod.text.dynamic.game.14015.description": never;
	"prod.text.dynamic.game.14014.description": never;
	"prod.text.dynamic.game.14016.description": never;
	"prod.text.dynamic.game.14020.description": never;
	"prod.text.dynamic.game.14019.description": never;
	"prod.text.dynamic.game.14018.description": never;
	"prod.text.dynamic.game.14017.description": never;
	"btn.filter_by_club": never;
	"label.biography": never;
	"prod.text.dynamic.club.5208.biography": never;
	"prod.text.dynamic.player.21775.notes": never;
	"prod.text.dynamic.game.14054.description": never;
	"prod.text.dynamic.player.23610.notes": never;
	"prod.text.dynamic.player.23618.notes": never;
	"prod.text.dynamic.player.23621.notes": never;
	"label.player.dob": never;
	"prod.text.dynamic.player.23609.notes": never;
	"prod.text.dynamic.game.14062.description": never;
	"scout.menu.national": never;
	"scout.menu.league": never;
	"filter.daterange.season": never;
	"label.pagination.page": never;
	"label.pagination.of": never;
	"label.pagination.go.to.page": never;
	"label.pagination.show": never;
	"enter.role.name": never;
	"search.name": never;
	"search.club": never;
	"label.title": never;
	"prod.text.dynamic.club.5209.biography": never;
	"prod.text.dynamic.player.23608.notes": never;
	"prod.text.dynamic.player.23613.notes": never;
	"prod.text.dynamic.player.23619.notes": never;
	"prod.text.dynamic.player.23623.notes": never;
	"prod.text.dynamic.player.1682.notes": never;
	"prod.text.dynamic.player.24947.notes": never;
	"message.shared_link_generated": never;
	"prod.text.dynamic.player.348.notes": never;
	"prod.text.dynamic.player.3565.notes": never;
	"prod.text.dynamic.player.19476.notes": never;
	"prod.text.dynamic.player.23611.notes": never;
	"prod.text.dynamic.player.23614.notes": never;
	"prod.text.dynamic.player.23622.notes": never;
	"prod.text.dynamic.player.23617.notes": never;
	"prod.text.dynamic.player.23625.notes": never;
	"prod.text.dynamic.player.15387.notes": never;
	"prod.text.dynamic.player.272.notes": never;
	"prod.text.dynamic.player.17493.notes": never;
	"prod.text.dynamic.player.25056.notes": never;
	"prod.text.dynamic.player.23616.notes": never;
	"prod.text.dynamic.club.5081.biography": never;
	"info.nodata_available": never;
	"prod.text.dynamic.club.5210.biography": never;
	"prod.text.dynamic.player.25349.notes": never;
	"prod.text.dynamic.game.14478.description": never;
	"prod.text.dynamic.player.16699.notes": never;
	"prod.text.dynamic.game.14483.description": never;
	"label.downloadable_gametags": never;
	"label.ubitrack": never;
	"prod.text.dynamic.player.2686.notes": never;
	"label.download_options": never;
	"label.download_format": never;
	"label.1st_half": never;
	"prod.text.dynamic.game.14620.description": never;
	"label.2nd_half": never;
	"label.selected_events": never;
	"label.download_all": never;
	"prod.text.dynamic.club.5211.biography": never;
	"prod.text.dynamic.club.5212.biography": never;
	"prod.text.dynamic.player.10916.notes": never;
	"game.download.validate.team": never;
	"game.download.validate.download": never;
	"game.download.validate.download_string": never;
	"game.download.validate.format": never;
	"game.download.validate.format_string": never;
	"game.download.validate.event_category_string": never;
	"prod.text.dynamic.club.5213.biography": never;
	"prod.text.dynamic.club.5214.biography": never;
	"prod.text.dynamic.player.25843.notes": never;
	"prod.text.dynamic.player.25844.notes": never;
	"prod.text.dynamic.player.25845.notes": never;
	"prod.text.dynamic.player.1855.notes": never;
	"prod.text.dynamic.player.13259.notes": never;
	"prod.text.dynamic.player.21776.notes": never;
	"prod.text.dynamic.player.26009.notes": never;
	"prod.text.dynamic.player.26010.notes": never;
	"prod.text.dynamic.player.26011.notes": never;
	"prod.text.dynamic.player.26012.notes": never;
	"prod.text.dynamic.player.26013.notes": never;
	"prod.text.dynamic.player.26014.notes": never;
	"prod.text.dynamic.player.26015.notes": never;
	"prod.text.dynamic.player.26016.notes": never;
	"prod.text.dynamic.player.26017.notes": never;
	"prod.text.dynamic.player.26018.notes": never;
	"prod.text.dynamic.player.26019.notes": never;
	"prod.text.dynamic.player.26020.notes": never;
	"prod.text.dynamic.player.26021.notes": never;
	"prod.text.dynamic.player.26022.notes": never;
	"prod.text.dynamic.player.26023.notes": never;
	"prod.text.dynamic.game.14759.description": never;
	"prod.text.dynamic.player.14149.notes": never;
	"prod.text.dynamic.player.14866.notes": never;
	"msg.analyse_finished": never;
	"country.session.remove.success.message": never;
	"prod.text.dynamic.club.1.biography": never;
	"prod.text.dynamic.club.3.biography": never;
	"prod.text.dynamic.club.10.biography": never;
	"prod.text.dynamic.club.12.biography": never;
	"prod.text.dynamic.club.13.biography": never;
	"prod.text.dynamic.club.14.biography": never;
	"prod.text.dynamic.club.16.biography": never;
	"prod.text.dynamic.club.17.biography": never;
	"prod.text.dynamic.club.19.biography": never;
	"prod.text.dynamic.club.30.biography": never;
	"prod.text.dynamic.club.31.biography": never;
	"prod.text.dynamic.club.32.biography": never;
	"prod.text.dynamic.club.33.biography": never;
	"prod.text.dynamic.club.34.biography": never;
	"prod.text.dynamic.club.35.biography": never;
	"prod.text.dynamic.club.38.biography": never;
	"prod.text.dynamic.club.39.biography": never;
	"prod.text.dynamic.club.40.biography": never;
	"prod.text.dynamic.club.41.biography": never;
	"prod.text.dynamic.club.5043.biography": never;
	"prod.text.dynamic.club.5044.biography": never;
	"prod.text.dynamic.club.5045.biography": never;
	"prod.text.dynamic.club.5048.biography": never;
	"prod.text.dynamic.club.5049.biography": never;
	"prod.text.dynamic.club.5052.biography": never;
	"prod.text.dynamic.club.5053.biography": never;
	"prod.text.dynamic.club.5056.biography": never;
	"prod.text.dynamic.club.5057.biography": never;
	"prod.text.dynamic.club.5058.biography": never;
	"prod.text.dynamic.club.5060.biography": never;
	"prod.text.dynamic.club.5061.biography": never;
	"prod.text.dynamic.club.5062.biography": never;
	"prod.text.dynamic.club.5063.biography": never;
	"prod.text.dynamic.club.5064.biography": never;
	"prod.text.dynamic.club.5065.biography": never;
	"prod.text.dynamic.club.5066.biography": never;
	"prod.text.dynamic.club.5067.biography": never;
	"prod.text.dynamic.club.5068.biography": never;
	"prod.text.dynamic.club.5069.biography": never;
	"prod.text.dynamic.club.5070.biography": never;
	"prod.text.dynamic.club.5071.biography": never;
	"prod.text.dynamic.club.5072.biography": never;
	"prod.text.dynamic.club.5074.biography": never;
	"prod.text.dynamic.club.5075.biography": never;
	"prod.text.dynamic.club.5076.biography": never;
	"prod.text.dynamic.club.5078.biography": never;
	"prod.text.dynamic.club.5079.biography": never;
	"prod.text.dynamic.club.5080.biography": never;
	"prod.text.dynamic.club.5082.biography": never;
	"prod.text.dynamic.club.5083.biography": never;
	"prod.text.dynamic.club.5085.biography": never;
	"prod.text.dynamic.club.5087.biography": never;
	"prod.text.dynamic.club.5088.biography": never;
	"prod.text.dynamic.club.5089.biography": never;
	"prod.text.dynamic.club.5090.biography": never;
	"prod.text.dynamic.club.5091.biography": never;
	"prod.text.dynamic.club.5092.biography": never;
	"prod.text.dynamic.club.5093.biography": never;
	"prod.text.dynamic.club.5094.biography": never;
	"prod.text.dynamic.club.5095.biography": never;
	"prod.text.dynamic.club.5096.biography": never;
	"prod.text.dynamic.club.5097.biography": never;
	"prod.text.dynamic.club.5098.biography": never;
	"prod.text.dynamic.club.5099.biography": never;
	"prod.text.dynamic.club.5100.biography": never;
	"prod.text.dynamic.club.5101.biography": never;
	"prod.text.dynamic.club.5102.biography": never;
	"prod.text.dynamic.club.5103.biography": never;
	"prod.text.dynamic.club.5104.biography": never;
	"prod.text.dynamic.club.5105.biography": never;
	"prod.text.dynamic.club.5106.biography": never;
	"prod.text.dynamic.club.5108.biography": never;
	"prod.text.dynamic.club.5109.biography": never;
	"prod.text.dynamic.club.5110.biography": never;
	"prod.text.dynamic.club.5113.biography": never;
	"prod.text.dynamic.club.5114.biography": never;
	"prod.text.dynamic.club.5115.biography": never;
	"prod.text.dynamic.club.5116.biography": never;
	"prod.text.dynamic.club.5117.biography": never;
	"prod.text.dynamic.club.5118.biography": never;
	"prod.text.dynamic.club.5119.biography": never;
	"prod.text.dynamic.club.5120.biography": never;
	"prod.text.dynamic.club.5121.biography": never;
	"prod.text.dynamic.club.5125.biography": never;
	"prod.text.dynamic.club.5128.biography": never;
	"prod.text.dynamic.club.5129.biography": never;
	"prod.text.dynamic.club.5130.biography": never;
	"prod.text.dynamic.club.5132.biography": never;
	"prod.text.dynamic.club.5134.biography": never;
	"prod.text.dynamic.club.5135.biography": never;
	"prod.text.dynamic.club.5136.biography": never;
	"prod.text.dynamic.club.5137.biography": never;
	"prod.text.dynamic.club.5138.biography": never;
	"prod.text.dynamic.club.5139.biography": never;
	"prod.text.dynamic.club.5140.biography": never;
	"prod.text.dynamic.club.5141.biography": never;
	"prod.text.dynamic.club.5142.biography": never;
	"prod.text.dynamic.club.5143.biography": never;
	"prod.text.dynamic.club.5145.biography": never;
	"prod.text.dynamic.club.5147.biography": never;
	"prod.text.dynamic.club.5148.biography": never;
	"prod.text.dynamic.club.5149.biography": never;
	"prod.text.dynamic.club.5150.biography": never;
	"prod.text.dynamic.club.5151.biography": never;
	"prod.text.dynamic.club.5152.biography": never;
	"prod.text.dynamic.club.5153.biography": never;
	"prod.text.dynamic.club.5154.biography": never;
	"prod.text.dynamic.club.5155.biography": never;
	"prod.text.dynamic.club.5156.biography": never;
	"prod.text.dynamic.club.5157.biography": never;
	"prod.text.dynamic.club.5158.biography": never;
	"prod.text.dynamic.club.5159.biography": never;
	"prod.text.dynamic.club.5160.biography": never;
	"prod.text.dynamic.club.5162.biography": never;
	"prod.text.dynamic.club.5163.biography": never;
	"prod.text.dynamic.club.5164.biography": never;
	"prod.text.dynamic.club.5165.biography": never;
	"prod.text.dynamic.club.5166.biography": never;
	"prod.text.dynamic.club.5167.biography": never;
	"prod.text.dynamic.club.5168.biography": never;
	"prod.text.dynamic.club.5169.biography": never;
	"prod.text.dynamic.club.5170.biography": never;
	"prod.text.dynamic.club.5171.biography": never;
	"prod.text.dynamic.club.5172.biography": never;
	"prod.text.dynamic.club.5173.biography": never;
	"prod.text.dynamic.club.5174.biography": never;
	"prod.text.dynamic.club.5175.biography": never;
	"prod.text.dynamic.club.5176.biography": never;
	"prod.text.dynamic.club.5179.biography": never;
	"prod.text.dynamic.club.5180.biography": never;
	"prod.text.dynamic.club.5182.biography": never;
	"prod.text.dynamic.club.5183.biography": never;
	"prod.text.dynamic.club.5184.biography": never;
	"prod.text.dynamic.club.5191.biography": never;
	"prod.text.dynamic.club.5192.biography": never;
	"prod.text.dynamic.club.5193.biography": never;
	"prod.text.dynamic.club.5195.biography": never;
	"prod.text.dynamic.club.5196.biography": never;
	"prod.text.dynamic.club.5197.biography": never;
	"prod.text.dynamic.club.5199.biography": never;
	"prod.text.dynamic.club.5200.biography": never;
	"prod.text.dynamic.club.5202.biography": never;
	"prod.text.dynamic.club.5203.biography": never;
	"prod.text.dynamic.club.5204.biography": never;
	"prod.text.dynamic.club.5205.biography": never;
	"prod.text.dynamic.club.5206.biography": never;
	"prod.text.dynamic.club.5229.biography": never;
	"prod.text.dynamic.game.15755.description": never;
	"btn.search-stats": never;
	"prod.text.dynamic.club.5231.biography": never;
	"prod.text.dynamic.club.5232.biography": never;
	"prod.text.dynamic.player.563.notes": never;
	"prod.text.dynamic.club.5233.biography": never;
	"prod.text.dynamic.player.27859.notes": never;
	"prod.text.dynamic.player.1875.notes": never;
	"prod.text.dynamic.player.3705.notes": never;
	"prod.text.dynamic.player.10884.notes": never;
	"prod.text.dynamic.player.1813.notes": never;
	"prod.text.dynamic.player.13120.notes": never;
	"prod.text.dynamic.player.3977.notes": never;
	"prod.text.dynamic.player.14033.notes": never;
	"prod.text.dynamic.player.2566.notes": never;
	"prod.text.dynamic.player.1883.notes": never;
	"prod.text.dynamic.player.991.notes": never;
	"prod.text.dynamic.player.20968.notes": never;
	"prod.text.dynamic.player.10999.notes": never;
	"prod.text.dynamic.player.9963.notes": never;
	"prod.text.dynamic.player.14124.notes": never;
	"prod.text.dynamic.player.1444.notes": never;
	"prod.text.dynamic.player.3062.notes": never;
	"prod.text.dynamic.player.14133.notes": never;
	"prod.text.dynamic.player.13289.notes": never;
	"prod.text.dynamic.player.3979.notes": never;
	"prod.text.dynamic.player.2097.notes": never;
	"prod.text.dynamic.club.5234.biography": never;
	"player.not.found": never;
	"prod.text.dynamic.club.4.biography": never;
	"prod.text.dynamic.club.5.biography": never;
	"prod.text.dynamic.club.6.biography": never;
	"prod.text.dynamic.club.8.biography": never;
	"prod.text.dynamic.club.9.biography": never;
	"prod.text.dynamic.club.20.biography": never;
	"prod.text.dynamic.club.21.biography": never;
	"prod.text.dynamic.club.23.biography": never;
	"prod.text.dynamic.club.26.biography": never;
	"prod.text.dynamic.club.27.biography": never;
	"prod.text.dynamic.club.28.biography": never;
	"prod.text.dynamic.club.29.biography": never;
	"team.not.found": never;
	"prod.text.dynamic.player.10167.notes": never;
	"prod.text.dynamic.player.10148.notes": never;
	"prod.text.dynamic.player.1807.notes": never;
	"prod.text.dynamic.player.11012.notes": never;
	"prod.text.dynamic.player.10997.notes": never;
	"prod.text.dynamic.club.5230.biography": never;
	"prod.text.dynamic.club.5236.biography": never;
	"prod.text.dynamic.club.5237.biography": never;
	"logoff.success": never;
	"logoff.fail": never;
	"prod.text.dynamic.club.5238.biography": never;
	"prod.text.dynamic.club.5239.biography": never;
	"prod.text.dynamic.player.26453.notes": never;
	"prod.text.dynamic.game.16062.description": never;
	"prod.text.dynamic.club.5240.biography": never;
	"stats.view.grid": never;
	"label.filters": never;
	"label.info": never;
	"game.stats.table.shotsInsidePenaltyarea": never;
	"game.stats.table.shotsOutsidePenaltyarea": never;
	"label.apply.colum.selection": never;
	"game.stats.table.aerialClearances": never;
	"game.stats.table.goalsKicks": never;
	"game.stats.table.controlUnderPressure": never;
	"game.stats.table.crosses": never;
	"stats.filters": never;
	"select.rank.players.stat": never;
	"game.stats.menu.general": never;
	"game.stats.menu.goalkeeping": never;
	"label.goalkeeping": never;
	"game.stats.menu.columnPresets": never;
	"edit.columns": never;
	"stats.filter.settings": never;
	"player.forward": never;
	"players.found": never;
	"cell.background.color.meaning": never;
	"text.position.bottom": never;
	"text.position.middle": never;
	"text.position.top": never;
	"label.player_birthday": never;
	"label.player.nat": never;
	"game.stats.table.shotsInside": never;
	"game.stats.table.shotsOutside": never;
	"game.stats.table.passesAccuracy": never;
	"player.midfielder": never;
	"player.defender": never;
	"label.custom": never;
	"contextMenu.openInNewTab": never;
	"contextMenu.copyLink": never;
	"contextMenu.share": never;
	"prod.text.dynamic.club.5178.biography": never;
	"contextMenu.openInNewWindow": never;
	"contextMenu.saveAs": never;
	"label.player.strongestFoot.left.letter": never;
	"label.player.strongestFoot.right.letter": never;
	"prod.text.dynamic.game.15474.description": never;
	"prod.text.dynamic.club.5241.biography": never;
	"enum.position.-.key": never;
	"prod.text.dynamic.player.27376.notes": never;
	"prod.text.dynamic.player.27374.notes": never;
	"iframeLoader.text": never;
	"prod.text.dynamic.club.5244.biography": never;
	"prod.text.dynamic.game.16206.description": never;
	"prod.text.dynamic.player.1927.notes": never;
	"prod.text.dynamic.player.26274.notes": never;
	"prod.text.dynamic.player.1611.notes": never;
	"prod.text.dynamic.player.1618.notes": never;
	"prod.text.dynamic.player.12642.notes": never;
	"prod.text.dynamic.player.9369.notes": never;
	"prod.text.dynamic.player.11007.notes": never;
	"prod.text.dynamic.player.1615.notes": never;
	"file.maximum.size.warning": never;
	"prod.text.dynamic.player.20112.notes": never;
	"prod.text.dynamic.player.261.notes": never;
	"stats.view.country.message": never;
	"prod.text.dynamic.club.5245.biography": never;
	"prod.text.dynamic.club.5246.biography": never;
	"prod.text.dynamic.game.16219.description": never;
	"app.player.validate.firstName_string": never;
	"app.player.validate.lastName_string": never;
	"app.player.validate.firstName": never;
	"app.player.validate.lastName": never;
	"app.coach.game.highlight.validate.timestamp_int": never;
	"app.player.validate.plain_password.second": never;
	"app.player.validate.clubId_int": never;
	"app.user.update.success": never;
	"app.player.validate.player.sign_up_request.player_registered": never;
	"app.player.not.found": never;
	"app.game.clip.delete.success": never;
	"app.game.clip.dowload_link.failed": never;
	"app.game.not.found": never;
	"app.user.reset_password.invalid_token": never;
	"app.eyeball.text.ok": never;
	"app.eyeball.menu.games": never;
	"app.eyeball.lang.en": never;
	"app.eyeball.lang.fr": never;
	"app.eyeball.yes": never;
	"app.eyeball.no": never;
	"app.eyeball.filter.clubs": never;
	"app.eyeball.filter.teams": never;
	"app.eyeball.forgot_password.setup.password.title": never;
	"app.eyeball.forgot_password.setup.password_again.title": never;
	"app.coach.home.teams.info_players": never;
	"app.coach.home.club.contact": never;
	"app.coach.match.team_sheet_player_name_header": never;
	"app.coach.match.team_sheet_player_yob_header": never;
	"app.coach.match.shirt_title": never;
	"app.coach.match.shorts_title": never;
	"app.player.my_games.empty": never;
	"app.player.profile.edit": never;
	"app.player.profile.section_password": never;
	"app.player.profile.first_name.title": never;
	"app.player.profile.last_name.title": never;
	"app.player.profile.position.title": never;
	"app.player.profile.position.error": never;
	"app.player.profile.nationality.title": never;
	"app.player.profile.weight.title": never;
	"app.player.profile.height.title": never;
	"app.player.home.tabbar.games": never;
	"app.player.home.info.birthday": never;
	"app.player.home.info.height": never;
	"app.player.home.info.weight": never;
	"app.player.home.info.right_foot": never;
	"app.player.home.info.left_foot": never;
	"app.player.home.info.collapse": never;
	"app.player.home.stats.games": never;
	"app.player.home.highlights.game_tag_clip": never;
	"app.player.clip.share_title": never;
	"app.player.register.club.select": never;
	"global.locale.en": never;
	"global.locale.fr": never;
	"global.locale.es": never;
	"global.locale.de": never;
	"subscription.comment.default_value": never;
	"prod.text.dynamic.game.16247.description": never;
	"prod.text.dynamic.game.15662.description": never;
	"prod.text.dynamic.game.15970.description": never;
	"enum.gametype.championnat": never;
	"enum.gametype.amical": never;
	"enum.gametype.coupe": never;
	"enum.gametype.eightaside": never;
	"enum.gametype.poletest": never;
	"app.eyeball.lang.title": never;
	"prod.text.dynamic.player.12814.notes": never;
	"prod.text.dynamic.player.2886.notes": never;
	"prod.text.dynamic.player.2885.notes": never;
	"prod.text.dynamic.player.4353.notes": never;
	"prod.text.dynamic.player.28541.notes": never;
	"prod.text.dynamic.player.16438.notes": never;
	"prod.text.dynamic.player.10826.notes": never;
	"prod.text.dynamic.player.3155.notes": never;
	"prod.text.dynamic.player.1450.notes": never;
	"prod.text.dynamic.game.16288.description": never;
	"prod.text.dynamic.game.16252.description": never;
	"prod.text.dynamic.game.15315.description": never;
	"prod.text.dynamic.game.15445.description": never;
	"prod.text.dynamic.game.15446.description": never;
	"prod.text.dynamic.game.15133.description": never;
	"prod.text.dynamic.club.5248.biography": never;
	"header.search.doesntMatch.club": never;
	"header.search.doesntMatch.player": never;
	"header.search.doesntMatch.game": never;
	"msg.subscription.expired": never;
	"msg.no.subscription": never;
	"app.eyeball.lang.de": never;
	"app.eyeball.lang.es": never;
	"prod.text.dynamic.game.15971.description": never;
	"form_search_player_pro.custom_presets": never;
	"form_search_player_pro.default_presets": never;
	"prod.text.dynamic.club.5253.biography": never;
	"prod.text.dynamic.player.27854.notes": never;
	"prod.text.dynamic.player.3150.notes": never;
	"player.question.1.title": never;
	"player.question.2.title": never;
	"player.question.3.title": never;
	"player.question.4.title": never;
	"player.question.5.title": never;
	"player.question.6.title": never;
	"player.question.7.title": never;
	"prod.text.dynamic.player.28516.notes": never;
	"prod.text.dynamic.player.19785.notes": never;
	"prod.text.dynamic.club.5255.biography": never;
	"prod.text.dynamic.player.22670.notes": never;
	"prod.text.dynamic.player.22675.notes": never;
	"prod.text.dynamic.club.5256.biography": never;
	"prod.text.dynamic.player.22904.notes": never;
	"prod.text.dynamic.player.2156.notes": never;
	"prod.text.dynamic.player.21783.notes": never;
	"prod.text.dynamic.player.21778.notes": never;
	"prod.text.dynamic.player.377.notes": never;
	"favorite.remove.club.error": never;
	"favorite.add.club.error": never;
	"scout_homepage.search_clubs": never;
	"scout_homepage.search_players": never;
	"prod.text.dynamic.player.18759.notes": never;
	"prod.text.dynamic.player.1141.notes": never;
	"favorite.remove.match.error": never;
	"favorite.add.match.error": never;
	"favorite.add.player.error": never;
	"favorite.remove.player.error": never;
	"prod.text.dynamic.club.5257.biography": never;
	"fill.fields.form": never;
	"selected.players.batch.update": {
		noOfPlayers: string;
	};
	"player.batch.updated": never;
	"player.batch.failed": never;
	"prod.text.dynamic.player.17473.notes": never;
	"prod.text.dynamic.player.17477.notes": never;
	"prod.text.dynamic.game.16125.description": never;
	"leagueFilter.selectCountries": never;
	"label.player_stats_search": never;
	"prod.text.dynamic.player.1169.notes": never;
	"videoPlayer.controls.seekTime": {
		noOfSeconds: string;
	};
	"label.batch.update": never;
	"game.stats.table.gamesCount": never;
	"prod.text.dynamic.game.16479.description": never;
	"game.stats.table.backNumber": never;
	"prod.text.dynamic.club.5112.biography": never;
	"prod.text.dynamic.club.5260.biography": never;
	"timeline.first_half_start": never;
	"timeline.first_half_end": never;
	"timeline.second_half_start": never;
	"timeline.second_half_end": never;
	"stats.view.gold.subscription.message": never;
	"prod.text.dynamic.club.5261.biography": never;
	"prod.text.dynamic.club.5262.biography": never;
	"prod.text.dynamic.club.5265.biography": never;
	"permission.game_analyze": never;
	"product.management.migrations": never;
	"label.migrate_club": never;
	"migration.label.select_deselect_all_players": never;
	"prod.text.dynamic.player.26035.notes": never;
	"prod.text.dynamic.player.29974.notes": never;
	"prod.text.dynamic.player.26033.notes": never;
	"prod.text.dynamic.player.26046.notes": never;
	"prod.text.dynamic.player.26041.notes": never;
	"prod.text.dynamic.player.26048.notes": never;
	"prod.text.dynamic.player.26791.notes": never;
	"prod.text.dynamic.club.5266.biography": never;
	"prod.text.dynamic.player.13772.notes": never;
	"prod.text.dynamic.player.13773.notes": never;
	"prod.text.dynamic.player.18121.notes": never;
	"prod.text.dynamic.player.22905.notes": never;
	"prod.text.dynamic.player.13846.notes": never;
	"prod.text.dynamic.player.11111.notes": never;
	"prod.text.dynamic.player.2823.notes": never;
	"migration.label.select_team_for_all_players": never;
	"prod.text.dynamic.player.30101.notes": never;
	"prod.text.dynamic.club.5270.biography": never;
	"prod.text.dynamic.club.5263.biography": never;
	"btn.continue_all": never;
	"scout.subscription.UK.replace.popup_message": never;
	"prod.text.dynamic.club.5272.biography": never;
	"prod.text.dynamic.game.16754.description": never;
	"explore.player.stats.page": never;
	"prod.text.dynamic.player.18768.notes": never;
	"prod.text.dynamic.club.5228.biography": never;
	"prod.text.dynamic.player.25852.notes": never;
	"newVersionPrompt.heading": never;
	"newVersionPrompt.description": never;
	"newVersionPrompt.btnUpdate.text": never;
	"newVersionPrompt.btnHide.text": never;
	"newVersionPrompt.icon.ttitle": never;
	"prod.text.dynamic.player.1025.notes": never;
	"label.nationalLeagues.more": never;
	"label.nationalLeagues.subText": never;
	"prod.text.dynamic.player.16545.notes": never;
	"prod.text.dynamic.player.3211.notes": never;
	"prod.text.dynamic.player.3212.notes": never;
	"prod.text.dynamic.player.3213.notes": never;
	"prod.text.dynamic.player.16701.notes": never;
	"prod.text.dynamic.club.5288.biography": never;
	"prod.text.dynamic.player.27930.notes": never;
	"prod.text.dynamic.player.27931.notes": never;
	"prod.text.dynamic.player.27932.notes": never;
	"prod.text.dynamic.player.27933.notes": never;
	"prod.text.dynamic.player.27935.notes": never;
	"prod.text.dynamic.player.27936.notes": never;
	"prod.text.dynamic.player.27937.notes": never;
	"prod.text.dynamic.player.27940.notes": never;
	"prod.text.dynamic.player.27941.notes": never;
	"prod.text.dynamic.player.27942.notes": never;
	"prod.text.dynamic.player.27943.notes": never;
	"prod.text.dynamic.player.27944.notes": never;
	"prod.text.dynamic.player.27929.notes": never;
	"prod.text.dynamic.player.17390.notes": never;
	"label.nationalLeagues.less": never;
	"prod.text.dynamic.player.29432.notes": never;
	"prod.text.dynamic.player.29434.notes": never;
	"prod.text.dynamic.player.29435.notes": never;
	"prod.text.dynamic.player.29436.notes": never;
	"prod.text.dynamic.player.29437.notes": never;
	"prod.text.dynamic.player.29438.notes": never;
	"prod.text.dynamic.player.29439.notes": never;
	"prod.text.dynamic.player.29440.notes": never;
	"prod.text.dynamic.player.29441.notes": never;
	"prod.text.dynamic.player.29442.notes": never;
	"prod.text.dynamic.player.29443.notes": never;
	"prod.text.dynamic.player.29445.notes": never;
	"prod.text.dynamic.player.29446.notes": never;
	"prod.text.dynamic.player.29447.notes": never;
	"prod.text.dynamic.player.29448.notes": never;
	"prod.text.dynamic.player.29449.notes": never;
	"prod.text.dynamic.player.29450.notes": never;
	"stats.view.gold.subscription.upgrade.message": never;
	"prod.text.dynamic.game.17225.description": never;
	"prod.text.dynamic.game.17259.description": never;
	"prod.text.dynamic.game.17267.description": never;
	"validate.player.search.player.playedInNationalTeam": never;
	"label.countrySelection.maxCountriesSelected": never;
	"label.nationalGames.noGames": never;
	"prod.text.dynamic.player.31051.notes": never;
	"prod.text.dynamic.player.31052.notes": never;
	"prod.text.dynamic.player.31053.notes": never;
	"prod.text.dynamic.player.31141.notes": never;
	"prod.text.dynamic.player.26043.notes": never;
	"prod.text.dynamic.player.30417.notes": never;
	"prod.text.dynamic.game.17504.description": never;
	"prod.text.dynamic.game.17519.description": never;
	"prod.text.dynamic.game.17598.description": never;
	"prod.text.dynamic.game.17515.description": never;
	"prod.text.dynamic.club.5306.biography": never;
	"form_search_player_pro.columns": never;
	"prod.text.dynamic.club.5307.biography": never;
	"prod.text.dynamic.game.17522.description": never;
	"prod.text.dynamic.club.5308.biography": never;
	"prod.text.dynamic.game.17618.description": never;
	"prod.text.dynamic.game.17645.description": never;
	"prod.text.dynamic.game.17585.description": never;
	"form_search_player_pro.presets": never;
	"prod.text.dynamic.player.33669.notes": never;
	"prod.text.dynamic.player.33670.notes": never;
	"prod.text.dynamic.player.28052.notes": never;
	"prod.text.dynamic.player.28042.notes": never;
	"prod.text.dynamic.player.28644.notes": never;
	"prod.text.dynamic.player.28053.notes": never;
	"prod.text.dynamic.player.28039.notes": never;
	"prod.text.dynamic.player.28040.notes": never;
	"prod.text.dynamic.player.28043.notes": never;
	"prod.text.dynamic.player.28036.notes": never;
	"prod.text.dynamic.player.28047.notes": never;
	"prod.text.dynamic.player.28045.notes": never;
	"prod.text.dynamic.game.17692.description": never;
	"label.nationality.continents": never;
	"prod.text.dynamic.game.17720.description": never;
	"prod.text.dynamic.player.28041.notes": never;
	"prod.text.dynamic.game.17803.description": never;
	"prod.text.dynamic.game.17756.description": never;
	"prod.text.dynamic.player.12883.notes": never;
	"prod.text.dynamic.game.17842.description": never;
	"prod.text.dynamic.game.17840.description": never;
	"prod.text.dynamic.game.17859.description": never;
	"prod.text.dynamic.game.17830.description": never;
	"prod.text.dynamic.game.17771.description": never;
	"prod.text.dynamic.game.17870.description": never;
	"prod.text.dynamic.club.5310.biography": never;
	"prod.text.dynamic.player.13156.notes": never;
	"prod.text.dynamic.player.24300.notes": never;
	"prod.text.dynamic.club.5311.biography": never;
	"prod.text.dynamic.game.17773.description": never;
	"prod.text.dynamic.club.5312.biography": never;
	"prod.text.dynamic.club.5313.biography": never;
	"generate.confirmation.are_you_sure": never;
	"prod.text.dynamic.club.5295.biography": never;
	"prod.text.dynamic.game.17966.description": never;
	"opensearch.error": never;
	"select.rank.player.goals": never;
	"prod.text.dynamic.player.1013.notes": never;
	"prod.text.dynamic.player.16854.notes": never;
	"prod.text.dynamic.player.10165.notes": never;
	"prod.text.dynamic.game.17999.description": never;
	"prod.text.dynamic.player.17624.notes": never;
	"prod.text.dynamic.player.20662.notes": never;
	"prod.text.dynamic.game.18029.description": never;
	"prod.text.dynamic.game.18096.description": never;
	"prod.text.dynamic.game.18097.description": never;
	"prod.text.dynamic.game.18099.description": never;
	"prod.text.dynamic.player.9926.notes": never;
	"prod.text.dynamic.player.13296.notes": never;
	"prod.text.dynamic.game.18018.description": never;
	"prod.text.dynamic.game.18188.description": never;
	"player.profile.club.category": never;
	"prod.text.dynamic.game.18276.description": never;
	"player.question.answer.yes": never;
	"player.question.answer.no": never;
	"player.question.answer.maybe": never;
	"player.question.answer.little": never;
	"player.question.8.title": never;
	"player.question.9.title": never;
	"player.question.10.title": never;
	"player.question.11.title": never;
	"player.question.12.title": never;
	"player.question.13.title": never;
	"player.question.14.title": never;
	"player.question.15.title": never;
	"game.stats.table.goalsScored": never;
	"game.stats.table.gamesPlayed": never;
	"game.stats.table.teamAgeGroup": never;
	"signupLink.successfullyGenerated": never;
	"signupLink.copiedToClipboard": never;
	"signupLink.copyLink": never;
	"game.stats.table.takeons": never;
	"game.stats.table.tackles": never;
	"signupLink.confirmation.title": never;
	"signupLink.confirmation.confirm": never;
	"signupLink.confirmation.description": {
		title: string;
	};
	"game.stats.table.aerialDuels": never;
	"game.stats.table.groundDuels": never;
	"game.stats.table.passes": never;
	"game.stats.table.passesForward": never;
	"game.stats.table.keyPassess": never;
	"prod.text.dynamic.club.5318.biography": never;
	"prod.text.dynamic.game.18427.description": never;
	"prod.text.dynamic.game.18488.description": never;
	"prod.text.dynamic.club.5291.biography": never;
	"prod.text.dynamic.club.5319.biography": never;
	"prod.text.dynamic.game.18361.description": never;
	"prod.text.dynamic.game.18550.description": never;
	"prod.text.dynamic.player.17735.notes": never;
	"prod.text.dynamic.player.30514.notes": never;
	"prod.text.dynamic.player.14029.notes": never;
	"prod.text.dynamic.player.33735.notes": never;
	"prod.text.dynamic.game.18334.description": never;
	"label.game.stat.time": never;
	"label.game.notAnalyzed": never;
	"label.game.video.noData": never;
	"prod.text.dynamic.club.5315.biography": never;
	"prod.text.dynamic.player.33873.notes": never;
	"prod.text.dynamic.player.36200.notes": never;
	"prod.text.dynamic.club.5298.biography": never;
	"prod.text.dynamic.player.37107.notes": never;
	"prod.text.dynamic.player.37108.notes": never;
	"prod.text.dynamic.player.37109.notes": never;
	"prod.text.dynamic.player.37110.notes": never;
	"form_search_player_pro.saved_filters": never;
	"prod.text.dynamic.player.35948.notes": never;
	"prod.text.dynamic.player.35949.notes": never;
	"prod.text.dynamic.player.35950.notes": never;
	"prod.text.dynamic.player.35951.notes": never;
	"prod.text.dynamic.player.35952.notes": never;
	"prod.text.dynamic.player.35953.notes": never;
	"prod.text.dynamic.player.35957.notes": never;
	"prod.text.dynamic.player.36175.notes": never;
	"prod.text.dynamic.player.36176.notes": never;
	"prod.text.dynamic.player.36177.notes": never;
	"prod.text.dynamic.player.36178.notes": never;
	"prod.text.dynamic.player.36179.notes": never;
	"prod.text.dynamic.player.36180.notes": never;
	"prod.text.dynamic.player.36181.notes": never;
	"prod.text.dynamic.player.36182.notes": never;
	"prod.text.dynamic.player.36183.notes": never;
	"prod.text.dynamic.player.36184.notes": never;
	"prod.text.dynamic.player.36185.notes": never;
	"prod.text.dynamic.player.36186.notes": never;
	"prod.text.dynamic.player.35938.notes": never;
	"prod.text.dynamic.player.35940.notes": never;
	"prod.text.dynamic.player.35941.notes": never;
	"prod.text.dynamic.player.35942.notes": never;
	"prod.text.dynamic.player.35943.notes": never;
	"prod.text.dynamic.player.35944.notes": never;
	"prod.text.dynamic.player.35946.notes": never;
	"prod.text.dynamic.player.35947.notes": never;
	"prod.text.dynamic.player.35955.notes": never;
	"prod.text.dynamic.game.18710.description": never;
	"prod.text.dynamic.game.18825.description": never;
	"enum.position.ALL": never;
	"prod.text.dynamic.game.18850.description": never;
	"prod.text.dynamic.game.18890.description": never;
	"prod.text.dynamic.player.36050.notes": never;
	"prod.text.dynamic.player.36057.notes": never;
	"prod.text.dynamic.player.36058.notes": never;
	"prod.text.dynamic.player.36060.notes": never;
	"prod.text.dynamic.player.36068.notes": never;
	"prod.text.dynamic.game.18889.description": never;
	"prod.text.dynamic.game.18520.description": never;
	"prod.text.dynamic.game.18822.description": never;
	"prod.text.dynamic.game.18379.description": never;
	"prod.text.dynamic.club.5324.biography": never;
	"prod.text.dynamic.player.34620.notes": never;
	"prod.text.dynamic.player.17817.notes": never;
	"prod.text.dynamic.player.2070.notes": never;
	"prod.text.dynamic.game.18927.description": never;
	"home.club_pro.news.title": never;
	"home.club_pro.news.button": never;
	"label.priority": never;
	"prod.text.dynamic.player.35979.notes": never;
	"prod.text.dynamic.game.19017.description": never;
	"prod.text.dynamic.player.35261.notes": never;
	"prod.text.dynamic.game.19053.description": never;
	"prod.text.dynamic.game.19060.description": never;
	"prod.text.dynamic.game.19093.description": never;
	"prod.text.dynamic.game.19074.description": never;
	"prod.text.dynamic.player.25354.notes": never;
	"prod.text.dynamic.player.35877.notes": never;
	"prod.text.dynamic.player.35879.notes": never;
	"prod.text.dynamic.player.35880.notes": never;
	"prod.text.dynamic.player.35897.notes": never;
	"prod.text.dynamic.player.35896.notes": never;
	"prod.text.dynamic.player.35895.notes": never;
	"prod.text.dynamic.player.35894.notes": never;
	"prod.text.dynamic.player.35893.notes": never;
	"prod.text.dynamic.player.35892.notes": never;
	"prod.text.dynamic.player.35891.notes": never;
	"prod.text.dynamic.player.35890.notes": never;
	"prod.text.dynamic.player.35889.notes": never;
	"prod.text.dynamic.player.35888.notes": never;
	"prod.text.dynamic.player.35887.notes": never;
	"prod.text.dynamic.player.35886.notes": never;
	"prod.text.dynamic.player.35885.notes": never;
	"prod.text.dynamic.player.35884.notes": never;
	"prod.text.dynamic.player.35883.notes": never;
	"prod.text.dynamic.player.35882.notes": never;
	"prod.text.dynamic.player.35881.notes": never;
	"prod.text.dynamic.player.35878.notes": never;
	"prod.text.dynamic.game.19180.description": never;
	"prod.text.dynamic.player.17199.notes": never;
	"prod.text.dynamic.player.15510.notes": never;
	"prod.text.dynamic.player.35189.notes": never;
	"prod.text.dynamic.player.13301.notes": never;
	"prod.text.dynamic.player.23070.notes": never;
	"prod.text.dynamic.game.19109.description": never;
	"prod.text.dynamic.game.19049.description": never;
	"prod.text.dynamic.game.19119.description": never;
	"prod.text.dynamic.game.18277.description": never;
	"prod.text.dynamic.player.1480.notes": never;
	"prod.text.dynamic.player.1493.notes": never;
	"prod.text.dynamic.player.38958.notes": never;
	"prod.text.dynamic.player.17551.notes": never;
	"prod.text.dynamic.player.38770.notes": never;
	"prod.text.dynamic.player.15325.notes": never;
	"prod.text.dynamic.player.38969.notes": never;
	"prod.text.dynamic.player.38970.notes": never;
	"prod.text.dynamic.player.38973.notes": never;
	"prod.text.dynamic.player.17536.notes": never;
	"prod.text.dynamic.game.19324.description": never;
	"prod.text.dynamic.game.19327.description": never;
	"prod.text.dynamic.game.19370.description": never;
	"prod.text.dynamic.game.19372.description": never;
	"prod.text.dynamic.game.19343.description": never;
	"prod.text.dynamic.game.19340.description": never;
	"prod.text.dynamic.game.19439.description": never;
	"prod.text.dynamic.game.19526.description": never;
	"prod.text.dynamic.game.19303.description": never;
	"home.club_pro.show_all_news": never;
	"prod.text.dynamic.player.37850.notes": never;
	"prod.text.dynamic.game.19622.description": never;
	"prod.text.dynamic.player.38243.notes": never;
	"prod.text.dynamic.player.18791.notes": never;
	"prod.text.dynamic.player.18773.notes": never;
	"prod.text.dynamic.player.18786.notes": never;
	"prod.text.dynamic.player.18798.notes": never;
	"prod.text.dynamic.game.16476.description": never;
	"prod.text.dynamic.game.19651.description": never;
	"prod.text.dynamic.game.19698.description": never;
	"prod.text.dynamic.game.19684.description": never;
	"prod.text.dynamic.player.35433.notes": never;
	"prod.text.dynamic.game.19806.description": never;
	"prod.text.dynamic.club.5271.biography": never;
	"prod.text.dynamic.game.19842.description": never;
	"prod.text.dynamic.player.34900.notes": never;
	"prod.text.dynamic.player.34187.notes": never;
	"prod.text.dynamic.player.34898.notes": never;
	"prod.text.dynamic.player.34899.notes": never;
	"prod.text.dynamic.player.36609.notes": never;
	"prod.text.dynamic.club.5335.biography": never;
	"label.news.tags": never;
	"prod.text.dynamic.game.19832.description": never;
	"prod.text.dynamic.game.19830.description": never;
	"prod.text.dynamic.player.27450.notes": never;
	"prod.text.dynamic.game.20006.description": never;
	"prod.text.dynamic.club.5338.biography": never;
	"prod.text.dynamic.game.10185.description": never;
	"label.news.relatedNews": never;
	"prod.text.dynamic.game.20281.description": never;
	"prod.text.dynamic.game.20183.description": never;
	"prod.text.dynamic.game.19928.description": never;
	"label.pageNotFound": never;
	"label.pageNotFound.text": never;
	"label.button.backToHome": never;
	"prod.text.dynamic.game.20359.description": never;
	"prod.text.dynamic.game.20438.description": never;
	"prod.text.dynamic.game.20411.description": never;
	"prod.text.dynamic.game.20100.description": never;
	"prod.text.dynamic.game.20086.description": never;
	"prod.text.dynamic.game.20088.description": never;
	"prod.text.dynamic.game.20087.description": never;
	"prod.text.dynamic.game.20085.description": never;
	"prod.text.dynamic.game.19292.description": never;
	"prod.text.dynamic.game.20140.description": never;
	"prod.text.dynamic.game.20096.description": never;
	"prod.text.dynamic.game.20401.description": never;
	"prod.text.dynamic.game.20348.description": never;
	"prod.text.dynamic.game.20218.description": never;
	"prod.text.dynamic.game.20141.description": never;
	"prod.text.dynamic.game.20099.description": never;
	"prod.text.dynamic.game.18666.description": never;
	"prod.text.dynamic.game.20095.description": never;
	"prod.text.dynamic.game.17989.description": never;
	"prod.text.dynamic.game.20089.description": never;
	"prod.text.dynamic.game.20101.description": never;
	"prod.text.dynamic.game.17695.description": never;
	"prod.text.dynamic.game.17694.description": never;
	"prod.text.dynamic.game.17398.description": never;
	"prod.text.dynamic.game.17441.description": never;
	"prod.text.dynamic.game.17170.description": never;
	"prod.text.dynamic.game.16733.description": never;
	"prod.text.dynamic.game.16701.description": never;
	"prod.text.dynamic.game.16734.description": never;
	"prod.text.dynamic.game.16858.description": never;
	"prod.text.dynamic.game.16874.description": never;
	"prod.text.dynamic.game.16382.description": never;
	"prod.text.dynamic.game.16748.description": never;
	"prod.text.dynamic.game.16070.description": never;
	"prod.text.dynamic.game.16049.description": never;
	"prod.text.dynamic.game.16071.description": never;
	"prod.text.dynamic.player.23615.notes": never;
	"message.select_product": never;
	"prod.text.dynamic.player.27313.notes": never;
	"prod.text.dynamic.player.27314.notes": never;
	"prod.text.dynamic.player.27315.notes": never;
	"prod.text.dynamic.player.27316.notes": never;
	"prod.text.dynamic.player.27317.notes": never;
	"prod.text.dynamic.player.27318.notes": never;
	"prod.text.dynamic.player.27319.notes": never;
	"prod.text.dynamic.player.27320.notes": never;
	"prod.text.dynamic.player.27321.notes": never;
	"prod.text.dynamic.player.27322.notes": never;
	"prod.text.dynamic.player.27323.notes": never;
	"prod.text.dynamic.player.27325.notes": never;
	"prod.text.dynamic.player.27328.notes": never;
	"prod.text.dynamic.player.27329.notes": never;
	"prod.text.dynamic.player.40283.notes": never;
	"prod.text.dynamic.player.40284.notes": never;
	"prod.text.dynamic.player.40286.notes": never;
	"prod.text.dynamic.player.40287.notes": never;
	"prod.text.dynamic.player.40285.notes": never;
	"prod.text.dynamic.player.27979.notes": never;
	"prod.text.dynamic.player.27980.notes": never;
	"prod.text.dynamic.player.27981.notes": never;
	"prod.text.dynamic.player.27983.notes": never;
	"prod.text.dynamic.player.27985.notes": never;
	"prod.text.dynamic.player.27988.notes": never;
	"prod.text.dynamic.game.20499.description": never;
	"prod.text.dynamic.club.5341.biography": never;
	"prod.text.dynamic.game.20457.description": never;
	"prod.text.dynamic.player.26947.notes": never;
	"prod.text.dynamic.player.36897.notes": never;
	"prod.text.dynamic.club.5321.biography": never;
	"prod.text.dynamic.game.20772.description": never;
	"prod.text.dynamic.game.20664.description": never;
	"prod.text.dynamic.game.20583.description": never;
	"prod.text.dynamic.game.20865.description": never;
	"prod.text.dynamic.game.20878.description": never;
	"prod.text.dynamic.player.39601.notes": never;
	"prod.text.dynamic.player.39602.notes": never;
	"prod.text.dynamic.player.39603.notes": never;
	"prod.text.dynamic.player.39605.notes": never;
	"prod.text.dynamic.player.39606.notes": never;
	"prod.text.dynamic.player.39608.notes": never;
	"prod.text.dynamic.player.39610.notes": never;
	"prod.text.dynamic.player.39612.notes": never;
	"tag.Africa": never;
	"prod.text.dynamic.player.23814.notes": never;
	"signupLink.not.copiedToClipboard": never;
	"tag.Belgium": never;
	"tag.Best XI": never;
	"tag.France": never;
	"prod.text.dynamic.player.12375.notes": never;
	"tag.England": never;
	"tag.Sweden": never;
	"tag.Finland": never;
	"tag.Iceland": never;
	"tag.Spain": never;
	"tag.Northern Ireland": never;
	"tag.Norway": never;
	"tag.Netherlands": never;
	"tag.Player focus": never;
	"tag.World cup": never;
	"tag.First team": never;
	"tag.National team": never;
	"tag.Playing up": never;
	"tag.Goal": never;
	"tag.Striker": never;
	"tag.Platform": never;
	"tag.Denmark": never;
	"label.accessDenied.title": never;
	"prod.text.dynamic.game.21085.description": never;
	"prod.text.dynamic.club.5347.biography": never;
	"prod.text.dynamic.player.38961.notes": never;
	"prod.text.dynamic.player.14019.notes": never;
	"prod.text.dynamic.player.35065.notes": never;
	"prod.text.dynamic.player.15630.notes": never;
	"label.korastats": never;
	"gameAnalysis.rejected.success": never;
	"btn.statSearch.preview": never;
	"prod.text.dynamic.player.28159.notes": never;
	"prod.text.dynamic.player.28160.notes": never;
	"prod.text.dynamic.player.28162.notes": never;
	"prod.text.dynamic.player.28165.notes": never;
	"prod.text.dynamic.player.28152.notes": never;
	"prod.text.dynamic.player.28154.notes": never;
	"prod.text.dynamic.game.21536.description": never;
	"prod.text.dynamic.game.21331.description": never;
	"prod.text.dynamic.game.21245.description": never;
	"prod.text.dynamic.game.20982.description": never;
	"btn.reject": never;
	"status.rejected": never;
	"regionMap.newTitle": never;
	"prod.text.dynamic.game.21573.description": never;
	"prod.text.dynamic.game.21872.description": never;
	"prod.text.dynamic.player.1256.notes": never;
	"prod.text.dynamic.player.1264.notes": never;
	"prod.text.dynamic.game.21909.description": never;
	"prod.text.dynamic.game.21799.description": never;
	"prod.text.dynamic.game.22018.description": never;
	"prod.text.dynamic.player.9920.notes": never;
	"prod.text.dynamic.player.9946.notes": never;
	"prod.text.dynamic.player.18165.notes": never;
	"prod.text.dynamic.player.10142.notes": never;
	"prod.text.dynamic.club.5353.biography": never;
	"prod.text.dynamic.player.15208.notes": never;
	"prod.text.dynamic.game.21974.description": never;
	"label.button.countriesExpand": never;
	"prod.text.dynamic.game.22099.description": never;
	"prod.text.dynamic.club.5369.biography": never;
	"prod.text.dynamic.game.22110.description": never;
	"prod.text.dynamic.game.22142.description": never;
	"prod.text.dynamic.game.22204.description": never;
	"prod.text.dynamic.game.22203.description": never;
	"prod.text.dynamic.game.22151.description": never;
	"permission.game_analyze.denied": never;
	"prod.text.dynamic.player.27370.notes": never;
	"game.clip.add.failed.non_standard_exception": never;
	"game.clip.add.failed.issue_with_video": never;
	"prod.text.dynamic.game.22607.description": never;
	"prod.text.dynamic.game.22596.description": never;
	"prod.text.dynamic.game.22597.description": never;
	"prod.text.dynamic.game.22608.description": never;
	"prod.text.dynamic.game.22619.description": never;
	"prod.text.dynamic.game.22621.description": never;
	"prod.text.dynamic.club.5374.biography": never;
	"prod.text.dynamic.player.41547.notes": never;
	"prod.text.dynamic.player.41569.notes": never;
	"prod.text.dynamic.game.22675.description": never;
	"prod.text.dynamic.player.35929.notes": never;
	"prod.text.dynamic.player.35920.notes": never;
	"prod.text.dynamic.player.35925.notes": never;
	"prod.text.dynamic.player.35932.notes": never;
	"prod.text.dynamic.player.35926.notes": never;
	"prod.text.dynamic.player.30725.notes": never;
	"prod.text.dynamic.game.22702.description": never;
	"prod.text.dynamic.game.22715.description": never;
	"prod.text.dynamic.game.22740.description": never;
	"prod.text.dynamic.player.15239.notes": never;
	"prod.text.dynamic.player.19216.notes": never;
	"prod.text.dynamic.player.20659.notes": never;
	"prod.text.dynamic.player.13292.notes": never;
	"prod.text.dynamic.player.41099.notes": never;
	"prod.text.dynamic.club.5376.biography": never;
	"prod.text.dynamic.player.2574.notes": never;
	"prod.text.dynamic.game.22874.description": never;
	"prod.text.dynamic.game.22822.description": never;
	"prod.text.dynamic.game.23001.description": never;
	"prod.text.dynamic.game.22891.description": never;
	"prod.text.dynamic.game.22321.description": never;
	"prod.text.dynamic.game.21602.description": never;
	"prod.text.dynamic.game.22035.description": never;
	"prod.text.dynamic.game.22287.description": never;
	"prod.text.dynamic.game.22513.description": never;
	"prod.text.dynamic.game.22889.description": never;
	"prod.text.dynamic.game.23017.description": never;
	"prod.text.dynamic.player.21171.notes": never;
	"prod.text.dynamic.player.21182.notes": never;
	"prod.text.dynamic.game.23067.description": never;
	"prod.text.dynamic.player.29475.notes": never;
	"prod.text.dynamic.player.146.notes": never;
	"prod.text.dynamic.game.22974.description": never;
	"prod.text.dynamic.game.23118.description": never;
	"prod.text.dynamic.game.23117.description": never;
	"prod.text.dynamic.game.23113.description": never;
	"prod.text.dynamic.game.23119.description": never;
	"prod.text.dynamic.club.5383.biography": never;
	"prod.text.dynamic.game.23300.description": never;
	"prod.text.dynamic.game.23274.description": never;
	"pole.sync.success": never;
	"label.extra_2nd_half": never;
	"label.extra_1st_half": never;
	"prod.text.dynamic.club.5382.biography": never;
	"prod.text.dynamic.player.33105.notes": never;
	"prod.text.dynamic.player.33103.notes": never;
	"prod.text.dynamic.player.33114.notes": never;
	"prod.text.dynamic.player.37226.notes": never;
	"prod.text.dynamic.player.37227.notes": never;
	"prod.text.dynamic.player.37228.notes": never;
	"prod.text.dynamic.player.37230.notes": never;
	"prod.text.dynamic.player.38199.notes": never;
	"prod.text.dynamic.player.38200.notes": never;
	"prod.text.dynamic.player.38201.notes": never;
	"prod.text.dynamic.player.38204.notes": never;
	"prod.text.dynamic.player.38205.notes": never;
	"prod.text.dynamic.player.38206.notes": never;
	"prod.text.dynamic.player.38207.notes": never;
	"prod.text.dynamic.player.40587.notes": never;
	"prod.text.dynamic.player.40588.notes": never;
	"prod.text.dynamic.player.40589.notes": never;
	"prod.text.dynamic.player.35738.notes": never;
	"prod.text.dynamic.player.45392.notes": never;
	"favorite.remove.team.error": never;
	"favorite.add.team.error": never;
	"prod.text.dynamic.player.15292.notes": never;
	"prod.text.dynamic.player.24784.notes": never;
	"prod.text.dynamic.game.23659.description": never;
	"prod.text.dynamic.game.23570.description": never;
	"prod.text.dynamic.player.20646.notes": never;
	"prod.text.dynamic.player.17145.notes": never;
	"prod.text.dynamic.player.2878.notes": never;
	"timeline.extra_half_one_start": never;
	"timeline.extra_half_one_end": never;
	"timeline.extra_half_two_start": never;
	"timeline.extra_half_two_end": never;
	"prod.text.dynamic.game.23555.description": never;
	"prod.text.dynamic.club.5391.biography": never;
	"prod.text.dynamic.player.18913.notes": never;
	"prod.text.dynamic.club.5379.biography": never;
	"game.stats.table.goalsOwn": never;
	"label.showMore": never;
	"prod.text.dynamic.club.5392.biography": never;
	"label.extra_3rd_half": never;
	"prod.text.dynamic.player.17887.notes": never;
	"prod.text.dynamic.player.29310.notes": never;
	"prod.text.dynamic.club.5395.biography": never;
	"clip.label.event": never;
	"prod.text.dynamic.club.5396.biography": never;
	"prod.text.dynamic.player.47834.notes": never;
	"prod.text.dynamic.player.47833.notes": never;
	"prod.text.dynamic.game.24067.description": never;
	"prod.text.dynamic.game.24357.description": never;
	"prod.text.dynamic.game.23904.description": never;
	"prod.text.dynamic.club.5181.biography": never;
	"app.game.clip.delete.error": never;
	"message.clip_name_change_error": never;
	"prod.text.dynamic.club.5399.biography": never;
	"prod.text.dynamic.player.187.notes": never;
	"select.rank.player.goalsOwn": never;
	"prod.text.dynamic.club.5404.biography": never;
	"prod.text.dynamic.club.5405.biography": never;
	"prod.text.dynamic.club.5406.biography": never;
	"prod.text.dynamic.game.24009.description": never;
	"prod.text.dynamic.game.24516.description": never;
	"prod.text.dynamic.game.24508.description": never;
	"message.clips.share.success": never;
	"message.clips.share.error": never;
	"prod.text.dynamic.game.24525.description": never;
	"prod.text.dynamic.game.24526.description": never;
	"prod.text.dynamic.game.24276.description": never;
	"prod.text.dynamic.game.24256.description": never;
	"prod.text.dynamic.game.24275.description": never;
	"prod.text.dynamic.player.29765.notes": never;
	"placeholder.dropdown.player": never;
	"placeholder.dropdown.club": never;
	"label.loginToEyeballAdmin": never;
	"label.resyncType": never;
	"label.syncLocally": never;
	"label.resyncAfter": never;
	"label.resync_options.transformed": never;
	"title.resync_game_stats": never;
	"msg.game_provider_not_found": never;
	"msg.resync_request_sent_successfully": never;
	"msg.game_provider_not_supported": never;
	"prod.text.dynamic.player.3590.notes": never;
	"prod.text.dynamic.player.10195.notes": never;
	"prod.text.dynamic.player.2444.notes": never;
	"prod.text.dynamic.player.16672.notes": never;
	"label.resyncType.info": never;
	"label.syncLocally.info": never;
	"label.resyncAfter.info": never;
	"prod.text.dynamic.game.24877.description": never;
	"prod.text.dynamic.player.37946.notes": never;
	"prod.text.dynamic.game.24873.description": never;
	"prod.text.dynamic.game.24854.description": never;
	"prod.text.dynamic.club.5411.biography": never;
	"prod.text.dynamic.club.5412.biography": never;
	"prod.text.dynamic.game.25038.description": never;
	"status.approved": never;
	"prod.text.dynamic.club.5413.biography": never;
	"search_no_result.posts": never;
	"migration.validation.message.select_both_source_target_club_same": never;
	"form_add_club_manager.label.is_active": never;
	"form_add_club_manager.label.is_active.true": never;
	"form_add_club_manager.label.is_active.false": never;
	"prod.text.dynamic.club.5415.biography": never;
	"prod.text.dynamic.game.24857.description": never;
	"prod.text.dynamic.player.49816.notes": never;
	"prod.text.dynamic.player.49817.notes": never;
	"form_add_coach.label.is_active.true": never;
	"form_add_coach.label.is_active.false": never;
	"form_add_coach.label.is_active": never;
	"label.user.deactivate_reason": never;
	"app.player.userEmail.exists": never;
	"label.account.preferences": never;
	"label.account.details": never;
	"prod.text.dynamic.game.25068.description": never;
	"prod.text.dynamic.game.21588.description": never;
	"label.account.newsletter_checkbox": never;
	"prod.text.dynamic.game.25214.description": never;
	"btn.abort_resync": never;
	"label.resync": never;
	"label.resync_options.all": never;
	"prod.text.dynamic.game.24543.description": never;
	"prod.text.dynamic.player.3596.notes": never;
	"msg.resync_request_failed": never;
	"msg.resync_aborted_successfully": never;
	"msg.game_not_resynced": never;
	"prod.text.dynamic.player.17737.notes": never;
	"label.valitadion.password": never;
	"message.reset_password.fail": never;
	"message.notification_update.success": never;
	"message.notification_update.fail": never;
	"app.user.update.fail": never;
	"message.preference_update.success": never;
	"message.preference_update.fail": never;
	"prod.text.dynamic.player.9144.notes": never;
	"prod.text.dynamic.player.23815.notes": never;
	"label.search.header.placeholder": never;
	"label.search.noSub": never;
	"button.search.upgrade": never;
	"btn.analysis_approval": never;
	"prod.text.dynamic.player.20929.notes": never;
	"msg.resync_already_in_progress": never;
	"error.blocked_account": never;
	"timeline.extra_half_three_start": never;
	"timeline.extra_half_three_end": never;
	"prod.text.dynamic.game.25204.description": never;
	"prod.text.dynamic.game.25523.description": never;
	"prod.text.dynamic.game.24574.description": never;
	"player.search.preset.column.goalsOwn": never;
	"prod.text.dynamic.club.5421.biography": never;
	"tag.Tim's Choice": never;
	"tag.Must-watch games": never;
	"message.500page": never;
	"prod.text.dynamic.game.25150.description": never;
	"prod.text.dynamic.club.5422.biography": never;
	"photo.upload.fail": never;
	"prod.text.dynamic.game.25360.description": never;
	"prod.text.dynamic.game.25157.description": never;
	"prod.text.dynamic.game.25499.description": never;
	"prod.text.dynamic.player.19054.notes": never;
	"prod.text.dynamic.player.33559.notes": never;
	"label.download_option.simpleXml": never;
	"label.download_option.detailedXml": never;
	"message.500page.info": never;
	"prod.text.dynamic.player.33397.notes": never;
	"prod.text.dynamic.player.24775.notes": never;
	"prod.text.dynamic.player.23182.notes": never;
	"prod.text.dynamic.game.25855.description": never;
	"prod.text.dynamic.game.25854.description": never;
	"prod.text.dynamic.game.25853.description": never;
	"prod.text.dynamic.club.5428.biography": never;
	"prod.text.dynamic.club.5429.biography": never;
	"prod.text.dynamic.player.50435.notes": never;
	"prod.text.dynamic.player.30377.notes": never;
	"prod.text.dynamic.player.21792.notes": never;
	"prod.text.dynamic.player.21777.notes": never;
	"btn.subscribe_newsletter": never;
	"prod.text.dynamic.player.49167.notes": never;
	"prod.text.dynamic.game.25876.description": never;
	"prod.text.dynamic.game.24613.description": never;
	"prod.text.dynamic.game.25218.description": never;
	"prod.text.dynamic.game.25641.description": never;
	"prod.text.dynamic.game.26237.description": never;
	"prod.text.dynamic.club.5378.biography": never;
	"label.globalSearch.outOfSub": never;
	"prod.text.dynamic.player.18556.notes": never;
	"label.globalSearch.upgradeSub.title": never;
	"label.globalSearch.upgradeSub.text": never;
	"prod.text.dynamic.club.5432.biography": never;
	"prod.text.dynamic.player.477.notes": never;
	"error.message.contact_customer_support": never;
	"not.enough.permission": never;
	"prod.text.dynamic.player.27740.notes": never;
	"prod.text.dynamic.player.350.notes": never;
	"label.outOfSub.games": {
		outOfCountryCount: string;
	};
	"label.outOfSub.clubs": {
		outOfCountryCount: string;
	};
	"label.outOfSub.players": {
		outOfCountryCount: string;
	};
	"label.accessDenied.text.formatted": {
		b: (text: string) => any;
	};
	"prod.text.dynamic.player.15504.notes": never;
	"prod.text.dynamic.player.15509.notes": never;
	"prod.text.dynamic.player.1369.notes": never;
	"prod.text.dynamic.game.26459.description": never;
	"prod.text.dynamic.player.34840.notes": never;
	"prod.text.dynamic.game.24232.description": never;
	"prod.text.dynamic.player.38460.notes": never;
	"delete.game.failed.message": never;
	"prod.text.dynamic.game.26696.description": never;
	"prod.text.dynamic.player.3218.notes": never;
	"prod.text.dynamic.club.5447.biography": never;
	"prod.text.dynamic.club.5448.biography": never;
	"prod.text.dynamic.player.29225.notes": never;
	"prod.text.dynamic.player.444.notes": never;
	"prod.text.dynamic.game.26806.description": never;
	"cannot.access.match.sheet": never;
	"prod.text.dynamic.game.26766.description": never;
	"prod.text.dynamic.game.26887.description": never;
	"prod.text.dynamic.club.5452.biography": never;
	"contact.sales.team": never;
	"prod.text.dynamic.club.5453.biography": never;
	"prod.text.dynamic.club.5454.biography": never;
	"prod.text.dynamic.player.38218.notes": never;
	"prod.text.dynamic.game.26929.description": never;
	"prod.text.dynamic.player.30230.notes": never;
	"prod.text.dynamic.player.30235.notes": never;
	"prod.text.dynamic.player.30234.notes": never;
	"prod.text.dynamic.player.30237.notes": never;
	"prod.text.dynamic.player.40460.notes": never;
	"prod.text.dynamic.player.15805.notes": never;
	"prod.text.dynamic.game.27093.description": never;
	"prod.text.dynamic.player.14126.notes": never;
	"prod.text.dynamic.player.10147.notes": never;
	"prod.text.dynamic.player.10731.notes": never;
	"prod.text.dynamic.player.10374.notes": never;
	"prod.text.dynamic.game.27024.description": never;
	"prod.text.dynamic.game.25829.description": never;
	"prod.text.dynamic.club.5464.biography": never;
	"prod.text.dynamic.game.27262.description": never;
	"prod.text.dynamic.game.25007.description": never;
	"prod.text.dynamic.game.25006.description": never;
	"prod.text.dynamic.game.24515.description": never;
	"prod.text.dynamic.game.24831.description": never;
	"prod.text.dynamic.game.24096.description": never;
	"prod.text.dynamic.game.24483.description": never;
	"prod.text.dynamic.game.24513.description": never;
	"prod.text.dynamic.game.23485.description": never;
	"prod.text.dynamic.game.23146.description": never;
	"prod.text.dynamic.game.21067.description": never;
	"prod.text.dynamic.game.22792.description": never;
	"prod.text.dynamic.game.18988.description": never;
	"prod.text.dynamic.game.18989.description": never;
	"prod.text.dynamic.game.18990.description": never;
	"prod.text.dynamic.game.18991.description": never;
	"prod.text.dynamic.game.18993.description": never;
	"prod.text.dynamic.game.18994.description": never;
	"prod.text.dynamic.game.19301.description": never;
	"prod.text.dynamic.game.19321.description": never;
	"prod.text.dynamic.player.54553.notes": never;
	"prod.text.dynamic.player.38459.notes": never;
	"prod.text.dynamic.player.34363.notes": never;
	"prod.text.dynamic.player.21035.notes": never;
	"prod.text.dynamic.player.50512.notes": never;
	"video.not.found": {
		br: (text: string) => any;
	};
	"prod.text.dynamic.player.47016.notes": never;
	"prod.text.dynamic.player.47027.notes": never;
	"prod.text.dynamic.game.27462.description": never;
	"prod.text.dynamic.player.29567.notes": never;
	"prod.text.dynamic.player.37951.notes": never;
	"prod.text.dynamic.game.27943.description": never;
	"prod.text.dynamic.game.27944.description": never;
	"prod.text.dynamic.game.27942.description": never;
	"prod.text.dynamic.game.27667.description": never;
	"prod.text.dynamic.game.27895.description": never;
	"tag.Market Watch": never;
	"tag.Club Focus": never;
	"tag.Croatia": never;
	"btn.load_more": never;
	"prod.text.dynamic.player.32439.notes": never;
	"prod.text.dynamic.player.31344.notes": never;
	"prod.text.dynamic.game.28088.description": never;
	"prod.text.dynamic.game.27977.description": never;
	"prod.text.dynamic.game.27801.description": never;
	"team.coaches.updated": never;
	"invalid.data": never;
	"feature.not.enabled": never;
	"app.player.alreadyRegistered": never;
	"app.player.forbidden": never;
	"tag.Europe": never;
	"tag.Drin Gashi": never;
	"tag.Emilio Iglesias": never;
	"tag.Kieran Batchelor": never;
	"tag.Nael Blanchard": never;
	"tag.Trey Tak": never;
	"prod.text.dynamic.player.29223.notes": never;
	"moved.to.old.players": never;
	"prod.text.dynamic.game.28033.description": never;
	"prod.text.dynamic.player.15082.notes": never;
	"prod.text.dynamic.player.23088.notes": never;
	"prod.text.dynamic.player.41751.notes": never;
	"prod.text.dynamic.game.28345.description": never;
	"prod.text.dynamic.game.28504.description": never;
	"prod.text.dynamic.club.5487.biography": never;
	"prod.text.dynamic.player.3145.notes": never;
	"label.login.continue": never;
	"app.eyeball.filter.title.favorite": never;
	"revokeSessions.success": {
		sessionsDeleted: string;
	};
	"revokeSessions.fail": never;
	"revokeSessions.confirmation": never;
	"prod.text.dynamic.player.20327.notes": never;
	"prod.text.dynamic.player.26996.notes": never;
	"prod.text.dynamic.player.17825.notes": never;
	"prod.text.dynamic.player.20652.notes": never;
	"prod.text.dynamic.player.15578.notes": never;
	"prod.text.dynamic.game.29437.description": never;
	"prod.text.dynamic.game.29345.description": never;
	"prod.text.dynamic.player.24777.notes": never;
	"prod.text.dynamic.player.56360.notes": never;
	"prod.text.dynamic.player.56361.notes": never;
	"prod.text.dynamic.player.56362.notes": never;
	"prod.text.dynamic.player.56363.notes": never;
	"prod.text.dynamic.player.56364.notes": never;
	"prod.text.dynamic.player.56365.notes": never;
	"prod.text.dynamic.player.56366.notes": never;
	"prod.text.dynamic.player.56367.notes": never;
	"prod.text.dynamic.player.56368.notes": never;
	"prod.text.dynamic.player.56369.notes": never;
	"prod.text.dynamic.player.56370.notes": never;
	"prod.text.dynamic.player.56371.notes": never;
	"prod.text.dynamic.player.56372.notes": never;
	"prod.text.dynamic.player.56373.notes": never;
	"prod.text.dynamic.player.56374.notes": never;
	"prod.text.dynamic.player.56375.notes": never;
	"prod.text.dynamic.player.56376.notes": never;
	"prod.text.dynamic.player.56377.notes": never;
	"prod.text.dynamic.player.57761.notes": never;
	"prod.text.dynamic.game.29302.description": never;
	"prod.text.dynamic.game.28938.description": never;
	"prod.text.dynamic.game.28676.description": never;
	"prod.text.dynamic.game.28503.description": never;
	"prod.text.dynamic.game.28168.description": never;
	"prod.text.dynamic.game.27787.description": never;
	"prod.text.dynamic.game.27185.description": never;
	"prod.text.dynamic.game.28782.description": never;
	"prod.text.dynamic.game.29520.description": never;
	"prod.text.dynamic.game.29218.description": never;
	"prod.text.dynamic.game.28714.description": never;
	"prod.text.dynamic.game.28597.description": never;
	"prod.text.dynamic.club.5494.biography": never;
	"error.invalid_lineup": never;
	"prod.text.dynamic.player.20672.notes": never;
	"subscription.upgrade.download_option": never;
	"prod.text.dynamic.club.5496.biography": never;
	"prod.text.dynamic.game.29897.description": never;
	"prod.text.dynamic.game.29898.description": never;
	"prod.text.dynamic.game.29955.description": never;
	"prod.text.dynamic.game.29927.description": never;
	"prod.text.dynamic.game.29929.description": never;
	"prod.text.dynamic.game.29951.description": never;
	"prod.text.dynamic.game.29912.description": never;
	"prod.text.dynamic.game.26236.description": never;
	"prod.text.dynamic.player.817.notes": never;
	"header.player_stats": never;
	"permission.email_edit": never;
	"stats.view.coach.cm.info.panel": never;
	"label.show_table_results": {
		numOfResults: string;
	};
	"prod.text.dynamic.player.3897.notes": never;
	"prod.text.dynamic.player.41501.notes": never;
	"prod.text.dynamic.player.41486.notes": never;
	"prod.text.dynamic.player.41466.notes": never;
	"prod.text.dynamic.game.30207.description": never;
	"prod.text.dynamic.game.30112.description": never;
	"prod.text.dynamic.game.30000.description": never;
	"prod.text.dynamic.game.29821.description": never;
	"prod.text.dynamic.game.29823.description": never;
	"prod.text.dynamic.player.2876.notes": never;
	"prod.text.dynamic.player.58454.notes": never;
	"prod.text.dynamic.player.58387.notes": never;
	"prod.text.dynamic.game.30284.description": never;
	"prod.text.dynamic.game.30091.description": never;
	"prod.text.dynamic.game.30071.description": never;
	"prod.text.dynamic.club.5499.biography": never;
	"notification.push.title.game.added": never;
	"notification.push.title.game.analyzed": never;
	"prod.text.dynamic.game.29822.description": never;
	"prod.text.dynamic.game.27896.description": never;
	"prod.text.dynamic.player.1307.notes": never;
	"prod.text.dynamic.player.33887.notes": never;
	"prod.text.dynamic.game.30512.description": never;
	"prod.text.dynamic.club.5501.biography": never;
	"prod.text.dynamic.game.30577.description": never;
	"prod.text.dynamic.game.30576.description": never;
	"prod.text.dynamic.game.30575.description": never;
	"tag.Germany": never;
	"tag.Lithuania": never;
	"tag. Sultan Adeleke": never;
	"tag.Nigeria": never;
	"tag.Senegal": never;
	"tag.Performers of the Week": never;
	"tag.Wales": never;
	"prod.text.dynamic.game.30609.description": never;
	"prod.text.dynamic.player.15259.notes": never;
	"prod.text.dynamic.player.3176.notes": never;
	"prod.text.dynamic.player.12646.notes": never;
	"prod.text.dynamic.player.29508.notes": never;
	"prod.text.dynamic.player.17618.notes": never;
	"prod.text.dynamic.player.13353.notes": never;
	"prod.text.dynamic.game.30650.description": never;
	"prod.text.dynamic.player.10158.notes": never;
	"prod.text.dynamic.player.15506.notes": never;
	"prod.text.dynamic.player.36479.notes": never;
	"prod.text.dynamic.club.5504.biography": never;
	"prod.text.dynamic.game.30677.description": never;
	"prod.text.dynamic.game.30667.description": never;
	"prod.text.dynamic.player.56872.notes": never;
	"prod.text.dynamic.player.39719.notes": never;
	"prod.text.dynamic.player.39426.notes": never;
	"prod.text.dynamic.game.30741.description": never;
	"prod.text.dynamic.game.30716.description": never;
	"prod.text.dynamic.player.1707.notes": never;
	"prod.text.dynamic.game.30712.description": never;
	"prod.text.dynamic.game.30760.description": never;
	"prod.text.dynamic.game.30785.description": never;
	"prod.text.dynamic.player.31345.notes": never;
	"prod.text.dynamic.game.30786.description": never;
	"prod.text.dynamic.game.30731.description": never;
	"prod.text.dynamic.game.30734.description": never;
	"prod.text.dynamic.game.30735.description": never;
	"prod.text.dynamic.game.30736.description": never;
	"prod.text.dynamic.player.34123.notes": never;
	"prod.text.dynamic.player.1938.notes": never;
	"prod.text.dynamic.player.2998.notes": never;
	"prod.text.dynamic.player.27829.notes": never;
	"prod.text.dynamic.player.147.notes": never;
	"prod.text.dynamic.player.47552.notes": never;
	"prod.text.dynamic.player.2904.notes": never;
	"header.admin.video_test": never;
	"player.info.last.updated": never;
	"prod.text.dynamic.game.30829.description": never;
	"prod.text.dynamic.game.30827.description": never;
	"cannot.edit.highlight": never;
	"permission.game_analyze.no.changes.detected": never;
	"filter.ageCategory.tooltip": never;
	"prod.text.dynamic.player.31667.notes": never;
	"prod.text.dynamic.player.31650.notes": never;
	"prod.text.dynamic.game.30894.description": never;
	"prod.text.dynamic.game.30895.description": never;
	"prod.text.dynamic.game.30896.description": never;
	"prod.text.dynamic.game.30897.description": never;
	"prod.text.dynamic.game.30898.description": never;
	"prod.text.dynamic.game.30899.description": never;
	"prod.text.dynamic.game.30900.description": never;
	"prod.text.dynamic.game.30902.description": never;
	"prod.text.dynamic.game.30901.description": never;
	"prod.text.dynamic.player.29421.notes": never;
	"prod.text.dynamic.game.30907.description": never;
	"prod.text.dynamic.game.30905.description": never;
	"prod.text.dynamic.game.30825.description": never;
	"prod.text.dynamic.game.30821.description": never;
	"prod.text.dynamic.game.30818.description": never;
	"prod.text.dynamic.game.30824.description": never;
	"prod.text.dynamic.game.29952.description": never;
	"prod.text.dynamic.game.29953.description": never;
	"prod.text.dynamic.game.29942.description": never;
	"prod.text.dynamic.game.26235.description": never;
	"prod.text.dynamic.game.30819.description": never;
	"prod.text.dynamic.player.14144.notes": never;
	"prod.text.dynamic.player.12593.notes": never;
	"prod.text.dynamic.player.42058.notes": never;
	"prod.text.dynamic.player.11408.notes": never;
	"prod.text.dynamic.game.30949.description": never;
	"prod.text.dynamic.game.31025.description": never;
	"prod.text.dynamic.game.30948.description": never;
	"prod.text.dynamic.game.30947.description": never;
	"prod.text.dynamic.game.31037.description": never;
	"prod.text.dynamic.game.31038.description": never;
	"prod.text.dynamic.game.31039.description": never;
	"prod.text.dynamic.game.31040.description": never;
	"prod.text.dynamic.game.31041.description": never;
	"game.stats.table.totalGoals": never;
	"game.stats.table.totalAssists": never;
	"prod.text.dynamic.player.39694.notes": never;
	"prod.text.dynamic.player.41566.notes": never;
	"prod.text.dynamic.player.38980.notes": never;
	"prod.text.dynamic.club.5515.biography": never;
	"prod.text.dynamic.player.57122.notes": never;
	"prod.text.dynamic.player.56828.notes": never;
	"prod.text.dynamic.player.56833.notes": never;
	"resource.email_notifications": never;
	"notification_frequency.daily": never;
	"notification_frequency.weekly": never;
	"label.players": never;
	"prod.text.dynamic.player.41201.notes": never;
	"prod.text.dynamic.player.18436.notes": never;
	"prod.text.dynamic.player.14864.notes": never;
	"label.notification.frequency": never;
	"label.notification.type": never;
	"prod.text.dynamic.player.41064.notes": never;
	"prod.text.dynamic.game.31217.description": never;
	"prod.text.dynamic.game.31231.description": never;
	"prod.text.dynamic.game.31243.description": never;
	"prod.text.dynamic.game.31241.description": never;
	"prod.text.dynamic.game.31242.description": never;
	"prod.text.dynamic.game.31218.description": never;
	"prod.text.dynamic.game.31219.description": never;
	"prod.text.dynamic.game.31229.description": never;
	"prod.text.dynamic.club.5518.biography": never;
	"prod.text.dynamic.game.31245.description": never;
	"prod.text.dynamic.game.31255.description": never;
	"prod.text.dynamic.game.31258.description": never;
	"prod.text.dynamic.game.31256.description": never;
	"prod.text.dynamic.game.31270.description": never;
	"prod.text.dynamic.game.31267.description": never;
	"prod.text.dynamic.game.31286.description": never;
	"prod.text.dynamic.game.31288.description": never;
	"prod.text.dynamic.game.31287.description": never;
	"label.active": never;
	"label.expand": never;
	"prod.text.dynamic.game.31332.description": never;
	"prod.text.dynamic.game.31356.description": never;
	"prod.text.dynamic.game.31360.description": never;
	"prod.text.dynamic.player.17882.notes": never;
	"enum.notificationtypes.new_games.key": never;
	"enum.notificationtypes.analyzed_games.key": never;
	"msg.email_notification.success": never;
	"label.switch.on": never;
	"label.switch.off": never;
	"label.notification.category": never;
	"label.notification.selected": never;
	"msg.email_notification.failed": never;
	"prod.text.dynamic.player.17469.notes": never;
	"prod.text.dynamic.player.17467.notes": never;
	"prod.text.dynamic.player.17478.notes": never;
	"prod.text.dynamic.player.10713.notes": never;
	"label.teams": never;
	"label.clubs": never;
	"prod.text.dynamic.player.3217.notes": never;
	"prod.text.dynamic.player.2510.notes": never;
	"prod.text.dynamic.player.17900.notes": never;
	"new.games.available": never;
	"recent.games.uploaded": never;
	"game.analysed": never;
	"watch.newest.games.favorites": never;
	"recent.games.uploaded.msg": never;
	"game.analysed.msg": never;
	"contact.email": never;
	"prod.text.dynamic.game.31397.description": never;
	"message.metadata_approval.success": never;
	"label.sportlogiq": never;
	"prod.text.dynamic.player.58164.notes": never;
	"prod.text.dynamic.player.18548.notes": never;
	"prod.text.dynamic.player.22641.notes": never;
	"prod.text.dynamic.player.22644.notes": never;
	"prod.text.dynamic.player.22646.notes": never;
	"prod.text.dynamic.player.22910.notes": never;
	"prod.text.dynamic.club.5527.biography": never;
	"prod.text.dynamic.player.29462.notes": never;
	"prod.text.dynamic.club.5529.biography": never;
	"prod.text.dynamic.player.34784.notes": never;
	"app.eyeball.lang.it": never;
	"prod.text.dynamic.game.31976.description": never;
	"prod.text.dynamic.player.55477.notes": never;
	"prod.text.dynamic.player.29835.notes": never;
	"prod.text.dynamic.player.20629.notes": never;
	"prod.text.dynamic.player.19848.notes": never;
	"prod.text.dynamic.player.27499.notes": never;
	"prod.text.dynamic.player.34273.notes": never;
	"prod.text.dynamic.player.42416.notes": never;
	"prod.text.dynamic.player.20152.notes": never;
	"prod.text.dynamic.player.37953.notes": never;
	"prod.text.dynamic.player.37948.notes": never;
	"prod.text.dynamic.player.10624.notes": never;
	"prod.text.dynamic.player.1848.notes": never;
	"prod.text.dynamic.game.31731.description": never;
	"prod.text.dynamic.player.27173.notes": never;
	"prod.text.dynamic.player.55217.notes": never;
	"prod.text.dynamic.player.21779.notes": never;
	"prod.text.dynamic.club.22634.biography": never;
	"app.mail.guardian.content": {
		firstName: string;
		lastName: string;
	};
	"app.mail.guardian.btn": never;
	"prod.text.dynamic.club.22640.biography": never;
	"prod.text.dynamic.club.22641.biography": never;
	"prod.text.dynamic.club.22642.biography": never;
	"prod.text.dynamic.club.22643.biography": never;
	"prod.text.dynamic.club.22644.biography": never;
	"prod.text.dynamic.club.22645.biography": never;
	"prod.text.dynamic.club.22646.biography": never;
	"prod.text.dynamic.club.22647.biography": never;
	"prod.text.dynamic.club.22648.biography": never;
	"prod.text.dynamic.club.22649.biography": never;
	"notification.email.subject.guardian.approval.requested": never;
	"notification.push.title.guardian.approval.approved": never;
	"notification.push.body.guardian.approval.approved": never;
	"prod.text.dynamic.player.60952.notes": never;
	"prod.text.dynamic.game.32318.description": never;
	"game.stats.table.passesSuccessfull": never;
	"notification.email.subject.game.added": never;
	"notification.email.subject.game.analyzed": never;
	"notification.push.body.game.added": never;
	"notification.push.body.game.analyzed": never;
	"homepage.section.playersOfTheWeek": never;
	"game.stats.table.takeonsSuccess": never;
	"prod.text.dynamic.player.246984.notes": never;
	"prod.text.dynamic.player.236329.notes": never;
	"prod.text.dynamic.player.238852.notes": never;
	"prod.text.dynamic.player.319333.notes": never;
	"prod.text.dynamic.player.319334.notes": never;
	"prod.text.dynamic.player.26460.notes": never;
	"prod.text.dynamic.player.31405.notes": never;
	"prod.text.dynamic.player.31425.notes": never;
	"prod.text.dynamic.player.248283.notes": never;
	"prod.text.dynamic.player.319335.notes": never;
	"prod.text.dynamic.player.236071.notes": never;
	"prod.text.dynamic.player.319336.notes": never;
	"prod.text.dynamic.player.239638.notes": never;
	"prod.text.dynamic.player.246986.notes": never;
	"prod.text.dynamic.player.319350.notes": never;
	"prod.text.dynamic.player.240278.notes": never;
	"prod.text.dynamic.player.306567.notes": never;
	"prod.text.dynamic.player.260002.notes": never;
	"prod.text.dynamic.player.261512.notes": never;
	"prod.text.dynamic.player.319351.notes": never;
	"prod.text.dynamic.player.319353.notes": never;
	"prod.text.dynamic.club.22686.biography": never;
	"prod.text.dynamic.player.41969.notes": never;
	"prod.text.dynamic.game.32349.description": never;
	"prod.text.dynamic.game.32543.description": never;
	"prod.text.dynamic.club.22705.biography": never;
	"prod.text.dynamic.player.217046.notes": never;
	"prod.text.dynamic.player.27755.notes": never;
	"label.rank": never;
	"label.week": never;
	"label.button.reset": never;
	"game.stats.table.take-ons": never;
	"game.stats.table.aerial-duels": never;
	"game.stats.table.passes-forward": never;
	"prod.text.dynamic.player.36256.notes": never;
	"prod.text.dynamic.player.24768.notes": never;
	"prod.text.dynamic.player.9461.notes": never;
	"prod.text.dynamic.club.22768.biography": never;
	"prod.text.dynamic.player.49754.notes": never;
	"prod.text.dynamic.player.46924.notes": never;
	"prod.text.dynamic.club.22775.biography": never;
	"prod.text.dynamic.club.22778.biography": never;
	"prod.text.dynamic.player.9143.notes": never;
	"gameAnalysis.rejected.failed": never;
	"playersOfTheWeek.country.message": never;
	"prod.text.dynamic.game.33322.description": never;
	"button.view_all_players": never;
	"game.leftTeam.label": never;
	"game.leftTeam.success": never;
	"prod.text.dynamic.club.22831.biography": never;
	"game.leftTeam.notSet": never;
	"prod.text.dynamic.player.16298.notes": never;
	"prod.text.dynamic.player.16779.notes": never;
	"game.noVideo.headline": never;
	"game.noVideo.message": never;
	"prod.text.dynamic.club.22858.biography": never;
	"prod.text.dynamic.player.34513.notes": never;
	"prod.text.dynamic.player.47093.notes": never;
	"prod.text.dynamic.player.249985.notes": never;
	"prod.text.dynamic.player.272960.notes": never;
	"prod.text.dynamic.player.274214.notes": never;
	"prod.text.dynamic.player.245234.notes": never;
	"prod.text.dynamic.player.322911.notes": never;
	"prod.text.dynamic.player.304515.notes": never;
	"prod.text.dynamic.player.15621.notes": never;
	"playersOfTheWeek.empty_data.message": never;
	"prod.text.dynamic.player.14586.notes": never;
	"prod.text.dynamic.club.5451.biography": never;
	"product.management.game.uploads": never;
	"prod.text.dynamic.game.34040.description": never;
	"tag.Ivory Coast": never;
	"tag.Sultan Adeleke": never;
	"tag.Tim Reichelt": never;
	"tag.Ghana": never;
	"tag.Mali": never;
	"tag.Luxembourg": never;
	"tag.Poland": never;
	"tag.Scandinavia": never;
	"form_add_club_amateur.label.links": never;
	"form_add_club_amateur.label.link.add": never;
	"label.user.tran_link": never;
	"label.user.federation_link": never;
	"tag.Tournament": never;
	"mail.user.notification": never;
	"prod.text.dynamic.club.22770.biography": never;
	"prod.text.dynamic.club.22945.biography": never;
	"prod.text.dynamic.player.330404.notes": never;
	"prod.text.dynamic.club.22970.biography": never;
	"prod.text.dynamic.player.50719.notes": never;
	"prod.text.dynamic.player.50720.notes": never;
	"prod.text.dynamic.player.50721.notes": never;
	"prod.text.dynamic.player.50722.notes": never;
	"prod.text.dynamic.player.50723.notes": never;
	"prod.text.dynamic.player.50724.notes": never;
	"prod.text.dynamic.player.50726.notes": never;
	"prod.text.dynamic.player.50727.notes": never;
	"prod.text.dynamic.player.50728.notes": never;
	"prod.text.dynamic.player.50729.notes": never;
	"prod.text.dynamic.player.62140.notes": never;
	"prod.text.dynamic.player.62143.notes": never;
	"prod.text.dynamic.player.326112.notes": never;
	"prod.text.dynamic.player.330740.notes": never;
	"label.signup_requests": never;
	"prod.text.dynamic.club.22979.biography": never;
	"prod.text.dynamic.player.60920.notes": never;
	"prod.text.dynamic.player.236321.notes": never;
	"prod.text.dynamic.player.61008.notes": never;
	"prod.text.dynamic.player.26751.notes": never;
	"prod.text.dynamic.player.61089.notes": never;
	"prod.text.dynamic.player.61088.notes": never;
	"prod.text.dynamic.player.40013.notes": never;
	"prod.text.dynamic.player.325337.notes": never;
	"prod.text.dynamic.player.61011.notes": never;
	"prod.text.dynamic.player.236335.notes": never;
	"prod.text.dynamic.player.61097.notes": never;
	"prod.text.dynamic.player.236831.notes": never;
	"prod.text.dynamic.player.288310.notes": never;
	"prod.text.dynamic.player.26754.notes": never;
	"prod.text.dynamic.player.3767.notes": never;
	"prod.text.dynamic.club.23020.biography": never;
	"label.signup_request": never;
	"label.player_details": never;
	"label.guardian_approval_requests": never;
	"prod.text.dynamic.club.23046.biography": never;
	"prod.text.dynamic.game.34017.description": never;
	"prod.text.dynamic.club.5473.biography": never;
	"prod.text.dynamic.player.43922.notes": never;
	"prod.text.dynamic.club.23096.biography": never;
	"prod.text.dynamic.player.324263.notes": never;
	"prod.text.dynamic.player.324281.notes": never;
	"label.player": never;
	"label.team": never;
	"weekly.games.cm_coach": never;
	"prod.text.dynamic.club.23142.biography": never;
	"prod.text.dynamic.game.35498.description": never;
	"prod.text.dynamic.club.23155.biography": never;
	"prod.text.dynamic.club.23161.biography": never;
	"prod.text.dynamic.player.34220.notes": never;
	"prod.text.dynamic.player.18442.notes": never;
	"prod.text.dynamic.player.34266.notes": never;
	"prod.text.dynamic.club.23171.biography": never;
	"prod.text.dynamic.club.23166.biography": never;
	"prod.text.dynamic.club.23181.biography": never;
	"prod.text.dynamic.game.36041.description": never;
	"prod.text.dynamic.player.37938.notes": never;
	"prod.text.dynamic.player.37950.notes": never;
	"prod.text.dynamic.player.42485.notes": never;
	"prod.text.dynamic.player.18766.notes": never;
	"prod.text.dynamic.player.18869.notes": never;
	"prod.text.dynamic.player.33671.notes": never;
	"prod.text.dynamic.club.23274.biography": never;
	"prod.text.dynamic.player.56266.notes": never;
	"prod.text.dynamic.player.56267.notes": never;
	"prod.text.dynamic.club.23275.biography": never;
	"prod.text.dynamic.player.25846.notes": never;
	"prod.text.dynamic.player.25847.notes": never;
	"prod.text.dynamic.player.25848.notes": never;
	"prod.text.dynamic.player.25850.notes": never;
	"prod.text.dynamic.player.25853.notes": never;
	"prod.text.dynamic.player.25855.notes": never;
	"prod.text.dynamic.player.25857.notes": never;
	"prod.text.dynamic.player.32536.notes": never;
	"prod.text.dynamic.player.31143.notes": never;
	"prod.text.dynamic.player.31146.notes": never;
	"prod.text.dynamic.player.32535.notes": never;
	"prod.text.dynamic.player.37539.notes": never;
	"prod.text.dynamic.player.39384.notes": never;
	"prod.text.dynamic.player.41278.notes": never;
	"prod.text.dynamic.player.41281.notes": never;
	"prod.text.dynamic.player.47375.notes": never;
	"prod.text.dynamic.player.44706.notes": never;
	"prod.text.dynamic.player.44709.notes": never;
	"prod.text.dynamic.player.44710.notes": never;
	"prod.text.dynamic.player.44711.notes": never;
	"prod.text.dynamic.player.44712.notes": never;
	"prod.text.dynamic.player.44714.notes": never;
	"prod.text.dynamic.player.44715.notes": never;
	"prod.text.dynamic.player.44719.notes": never;
	"prod.text.dynamic.player.44721.notes": never;
	"prod.text.dynamic.player.44723.notes": never;
	"prod.text.dynamic.player.62342.notes": never;
	"prod.text.dynamic.player.51277.notes": never;
	"prod.text.dynamic.player.52583.notes": never;
	"prod.text.dynamic.player.287610.notes": never;
	"prod.text.dynamic.player.12737.notes": never;
	"prod.text.dynamic.player.12712.notes": never;
	"prod.text.dynamic.player.52366.notes": never;
	"prod.text.dynamic.player.58456.notes": never;
	"prod.text.dynamic.player.10971.notes": never;
	"prod.text.dynamic.player.26459.notes": never;
	"prod.text.dynamic.player.335352.notes": never;
	"prod.text.dynamic.player.335369.notes": never;
	"prod.text.dynamic.player.335368.notes": never;
	"prod.text.dynamic.player.344414.notes": never;
	"prod.text.dynamic.player.344409.notes": never;
	"prod.text.dynamic.player.335370.notes": never;
	"prod.text.dynamic.player.335351.notes": never;
	"prod.text.dynamic.player.266660.notes": never;
	"prod.text.dynamic.player.41334.notes": never;
	"prod.text.dynamic.player.41338.notes": never;
	"prod.text.dynamic.player.41340.notes": never;
	"prod.text.dynamic.player.41343.notes": never;
	"prod.text.dynamic.player.41336.notes": never;
	"prod.text.dynamic.player.41342.notes": never;
	"prod.text.dynamic.game.36518.description": never;
	"prod.text.dynamic.player.16299.notes": never;
	"prod.text.dynamic.player.236689.notes": never;
	"prod.text.dynamic.player.213888.notes": never;
	"prod.text.dynamic.player.26272.notes": never;
	"prod.text.dynamic.player.34760.notes": never;
	"prod.text.dynamic.player.225262.notes": never;
	"prod.text.dynamic.player.48199.notes": never;
	"prod.text.dynamic.game.36949.description": never;
	"prod.text.dynamic.game.37155.description": never;
	"prod.text.dynamic.game.37153.description": never;
	"prod.text.dynamic.game.37074.description": never;
	"prod.text.dynamic.player.37944.notes": never;
	"prod.text.dynamic.club.23393.biography": never;
	"prod.text.dynamic.game.36742.description": never;
	"prod.text.dynamic.game.36046.description": never;
	"prod.text.dynamic.game.35468.description": never;
	"prod.text.dynamic.game.35332.description": never;
	"prod.text.dynamic.game.35358.description": never;
	"prod.text.dynamic.game.35311.description": never;
	"prod.text.dynamic.game.35234.description": never;
	"prod.text.dynamic.game.34815.description": never;
	"prod.text.dynamic.game.34708.description": never;
	"error.my_clips.url_not_found": never;
	"prod.text.dynamic.game.37330.description": never;
	"prod.text.dynamic.game.37358.description": never;
	"prod.text.dynamic.game.37269.description": never;
	"prod.text.dynamic.club.23327.biography": never;
	"prod.text.dynamic.club.23411.biography": never;
	"prod.text.dynamic.player.338361.notes": never;
	"prod.text.dynamic.club.23429.biography": never;
	"mail.user.notification-daily": never;
	"mail.user.notification-weekly": never;
	"prod.text.dynamic.player.23653.notes": never;
	"prod.text.dynamic.player.23820.notes": never;
	"prod.text.dynamic.game.37839.description": never;
	"prod.text.dynamic.player.43902.notes": never;
	"prod.text.dynamic.player.43914.notes": never;
	"prod.text.dynamic.player.44764.notes": never;
	"prod.text.dynamic.player.50359.notes": never;
	"prod.text.dynamic.club.23491.biography": never;
	"prod.text.dynamic.club.23487.biography": never;
	"prod.text.dynamic.club.23499.biography": never;
	"prod.text.dynamic.game.37616.description": never;
	"prod.text.dynamic.player.37430.notes": never;
	"prod.text.dynamic.player.34146.notes": never;
	"prod.text.dynamic.player.34154.notes": never;
	"prod.text.dynamic.player.41005.notes": never;
	"mail.user.notification.immediate.new-game": never;
	"mail.user.notification.immediate.analyzed-game": never;
	"prod.text.dynamic.game.35044.description": never;
	"prod.text.dynamic.game.37969.description": never;
	"prod.text.dynamic.game.37419.description": never;
	"prod.text.dynamic.game.37410.description": never;
	"prod.text.dynamic.game.37412.description": never;
	"prod.text.dynamic.game.37400.description": never;
	"prod.text.dynamic.game.37398.description": never;
	"prod.text.dynamic.game.36231.description": never;
	"prod.text.dynamic.game.35691.description": never;
	"prod.text.dynamic.game.35690.description": never;
	"prod.text.dynamic.game.34504.description": never;
	"prod.text.dynamic.game.33687.description": never;
	"prod.text.dynamic.game.33103.description": never;
	"prod.text.dynamic.game.32450.description": never;
	"prod.text.dynamic.game.32071.description": never;
	"prod.text.dynamic.game.31956.description": never;
	"matchSheet.error.numberSign.duplicate": {
		originalValue: string;
		prefixedValue: string;
	};
	"prod.text.dynamic.game.38400.description": never;
	"matchSheet.label.saveAnyway": never;
	"matchSheet.error.numberSign.startingLineup": never;
	"prod.text.dynamic.club.23416.biography": never;
	"prod.text.dynamic.club.23562.biography": never;
	"prod.text.dynamic.game.37351.description": never;
	"prod.text.dynamic.player.43224.notes": never;
	"prod.text.dynamic.player.329384.notes": never;
	"prod.text.dynamic.club.23602.biography": never;
	"prod.text.dynamic.club.23277.biography": never;
	"prod.text.dynamic.club.23604.biography": never;
	"prod.text.dynamic.club.23608.biography": never;
	"prod.text.dynamic.game.38807.description": never;
	"prod.text.dynamic.game.38961.description": never;
	"prod.text.dynamic.player.17821.notes": never;
	"prod.text.dynamic.player.62037.notes": never;
	"prod.text.dynamic.game.30143.description": never;
	"prod.text.dynamic.game.30142.description": never;
	"prod.text.dynamic.game.30141.description": never;
	"prod.text.dynamic.player.15318.notes": never;
	"app.player.home.info.strong_foot": never;
	"game.stats.table.na": never;
	"game.stats.table.na.value": never;
	"prod.text.dynamic.game.40017.description": never;
	"enum.position.MR.key": never;
	"matchSheet.locked.title": never;
	"matchSheet.locked.text": never;
	"prod.text.dynamic.game.40272.description": never;
	"prod.text.dynamic.club.23780.biography": never;
	"prod.text.dynamic.game.40570.description": never;
	"admin.videoUploads.metadataEditor.btnApprove.label": never;
	"app.eyeball.lang.pt": never;
	"admin.videoUploads.metadataEditor.btnRevoke.label": never;
	"admin.videoUploads.metadataEditor.modalApproveTitle": never;
	"admin.videoUploads.metadataEditor.modalRevokeTitle": never;
	"admin.videoUploads.metadataEditor.modalApproveText": never;
	"admin.videoUploads.metadataEditor.modalRevokeText": never;
	"admin.videoUploads.metadataEditor.modalButtonSubmit": never;
	"matchSheet.error.gamePlayer.duplicate": never;
	"prod.text.dynamic.player.44965.notes": never;
	"prod.text.dynamic.player.30213.notes": never;
	"prod.text.dynamic.player.30214.notes": never;
	"prod.text.dynamic.player.57922.notes": never;
	"prod.text.dynamic.player.30132.notes": never;
	"prod.text.dynamic.player.30133.notes": never;
	"prod.text.dynamic.player.317971.notes": never;
	"prod.text.dynamic.player.317967.notes": never;
	"prod.text.dynamic.player.317969.notes": never;
	"prod.text.dynamic.player.317972.notes": never;
	"prod.text.dynamic.game.40674.description": never;
	"prod.text.dynamic.game.40864.description": never;
	"prod.text.dynamic.game.41091.description": never;
	"prod.text.dynamic.club.23899.biography": never;
	"prod.text.dynamic.player.370752.notes": never;
	"prod.text.dynamic.player.335961.notes": never;
	"prod.text.dynamic.game.41422.description": never;
	"prod.text.dynamic.player.228276.notes": never;
	"prod.text.dynamic.game.41623.description": never;
	"prod.text.dynamic.player.228278.notes": never;
	"prod.text.dynamic.club.24019.biography": never;
	"prod.text.dynamic.player.18176.notes": never;
	"prod.text.dynamic.game.42314.description": never;
	"prod.text.dynamic.player.19290.notes": never;
	"prod.text.dynamic.player.20121.notes": never;
	"prod.text.dynamic.player.17157.notes": never;
	"prod.text.dynamic.player.17155.notes": never;
	"prod.text.dynamic.club.24038.biography": never;
	"prod.text.dynamic.player.42253.notes": never;
	"prod.text.dynamic.club.24045.biography": never;
	"prod.text.dynamic.club.24049.biography": never;
	"prod.text.dynamic.player.1237.notes": never;
	"prod.text.dynamic.player.49096.notes": never;
	"prod.text.dynamic.game.42585.description": never;
	"prod.text.dynamic.player.264648.notes": never;
	"prod.text.dynamic.game.42652.description": never;
	"prod.text.dynamic.player.34364.notes": never;
	"prod.text.dynamic.player.373608.notes": never;
	"players_of_the_week.search_no_result.players": never;
	"prod.text.dynamic.club.24125.biography": never;
	"prod.text.dynamic.game.43126.description": never;
	"prod.text.dynamic.club.23821.biography": never;
	"prod.text.dynamic.club.24150.biography": never;
	"prod.text.dynamic.game.43436.description": never;
	"prod.text.dynamic.player.48327.notes": never;
	"prod.text.dynamic.player.48355.notes": never;
	"prod.text.dynamic.player.233741.notes": never;
	"prod.text.dynamic.club.24190.biography": never;
	"prod.text.dynamic.game.43992.description": never;
	"prod.text.dynamic.game.43983.description": never;
	"prod.text.dynamic.player.57886.notes": never;
	"prod.text.dynamic.player.17739.notes": never;
	"prod.text.dynamic.player.330436.notes": never;
	"prod.text.dynamic.player.330437.notes": never;
	"prod.text.dynamic.player.335672.notes": never;
	"prod.text.dynamic.game.44295.description": never;
	"prod.text.dynamic.player.334979.notes": never;
	"admin.video.gamesWithoutVideo": never;
	"admin.video.gamesWithVideo": never;
	"admin.video.selectVideoProvider": never;
	"admin.video.selectedGameWithVideoWarning": never;
	"admin.video.backToVideoList": never;
	"admin.video.assignedGame": never;
	"admin.video.assignVideoToGame": never;
	"admin.video.filterByDate": never;
	"admin.video.propertyFilter": never;
	"admin.video.displayingLimitedResults": never;
	"admin.video.selectAClub": never;
	"gamePage.label.video": never;
	"gamePage.label.data": never;
	"prod.text.dynamic.club.24299.biography": never;
	"prod.text.dynamic.club.24301.biography": never;
	"prod.text.dynamic.club.24302.biography": never;
	"prod.text.dynamic.club.24303.biography": never;
	"prod.text.dynamic.club.24306.biography": never;
	"prod.text.dynamic.club.24307.biography": never;
	"prod.text.dynamic.club.24308.biography": never;
	"prod.text.dynamic.club.24309.biography": never;
	"prod.text.dynamic.club.24310.biography": never;
	"prod.text.dynamic.club.24311.biography": never;
	"prod.text.dynamic.club.24313.biography": never;
	"prod.text.dynamic.game.44660.description": never;
	"prod.text.dynamic.club.24329.biography": never;
	"prod.text.dynamic.club.24330.biography": never;
	"prod.text.dynamic.club.24334.biography": never;
	"gamePage.label.timeline": never;
	"gamePage.label.eventList": never;
	"gamePage.label.teamSheet": never;
	"gamePage.label.filters": never;
	"prod.text.dynamic.club.24339.biography": never;
	"prod.text.dynamic.player.327655.notes": never;
	"prod.text.dynamic.player.41878.notes": never;
	"prod.text.dynamic.club.24347.biography": never;
	"prod.text.dynamic.club.24351.biography": never;
	"prod.text.dynamic.game.44985.description": never;
	"prod.text.dynamic.player.391644.notes": never;
	"prod.text.dynamic.game.45048.description": never;
	"prod.text.dynamic.player.390302.notes": never;
	"prod.text.dynamic.game.45502.description": never;
	"prod.text.dynamic.club.24411.biography": never;
	"timeline.label.matchEnd": never;
	"prod.text.dynamic.player.18818.notes": never;
	"prod.text.dynamic.club.24417.biography": never;
	"prod.text.dynamic.game.44905.description": never;
	"teamsheet.download.csv": never;
	"teamsheet.download.pdf": never;
	"teamsheet.download.xlsx": never;
	"prod.text.dynamic.club.24476.biography": never;
	"prod.text.dynamic.club.24480.biography": never;
	"prod.text.dynamic.game.46060.description": never;
	"prod.text.dynamic.game.45674.description": never;
	"prod.text.dynamic.player.257462.notes": never;
	"prod.text.dynamic.club.24533.biography": never;
	"prod.text.dynamic.game.46378.description": never;
	"prod.text.dynamic.game.46492.description": never;
	"prod.text.dynamic.player.37968.notes": never;
	"video.editor.firstHalfStart": never;
	"video.editor.secondHalfStart": never;
	"video.editor.firstHalfEnd": never;
	"video.editor.secondHalfEnd": never;
	"video.editor.thirdHalfStart": never;
	"video.editor.thirdHalfEnd": never;
	"video.editor.fourthHalfStart": never;
	"video.editor.fourthHalfEnd": never;
	"prod.text.dynamic.club.24570.biography": never;
	"gamePage.createEvent.label": never;
	"gamePage.createEvent.desc": never;
	"gamePage.createCustomClip.label": never;
	"gamePage.createCustomClip.desc": never;
	"gamePage.label.createEvent": never;
	"gamePage.label.createClip": never;
	"prod.text.dynamic.player.36501.notes": never;
	"prod.text.dynamic.player.326073.notes": never;
	"prod.text.dynamic.player.375419.notes": never;
	"prod.text.dynamic.game.46324.description": never;
	"prod.text.dynamic.game.46937.description": never;
	"prod.text.dynamic.player.251610.notes": never;
	"prod.text.dynamic.player.225421.notes": never;
	"prod.text.dynamic.club.24623.biography": never;
	"prod.text.dynamic.club.24624.biography": never;
	"gamePage.eventEdit.confirm.label": never;
	"gamePage.eventEdit.cancel.label": never;
	"status.notApproved": never;
	"label.approval.approve": never;
	"label.approval.revokeApproval": never;
	"prod.text.dynamic.club.24638.biography": never;
	"prod.text.dynamic.club.24639.biography": never;
	"gamePage.label.editEvent": never;
	"game.tab.full_game": never;
	"game.tab.clips": never;
	"prod.text.dynamic.game.47483.description": never;
	"prod.text.dynamic.player.402886.notes": never;
	"prod.text.dynamic.game.47562.description": never;
	"gamePage.teamStats.type.goal": never;
	"gamePage.teamStats.type.possession": never;
	"gamePage.teamStats.type.shotOnTarget": never;
	"gamePage.teamStats.type.shotOffTarget": never;
	"gamePage.teamStats.type.foul": never;
	"gamePage.teamStats.type.offside": never;
	"gamePage.teamStats.type.freeKick": never;
	"gamePage.teamStats.type.corner": never;
	"gamePage.teamStats.type.averageRating": never;
	"gamePage.teamStats.type.shotInsidePa": never;
	"gamePage.teamStats.type.shotOutsidePa": never;
	"gamePage.teamStats.type.takeOnSuccess": never;
	"gamePage.teamStats.type.takeOn": never;
	"gamePage.teamStats.type.tackleSuccess": never;
	"gamePage.teamStats.type.tackle": never;
	"gamePage.teamStats.type.aerialDuel": never;
	"gamePage.teamStats.type.interception": never;
	"gamePage.teamStats.type.clearance": never;
	"gamePage.teamStats.type.recovery": never;
	"gamePage.teamStats.type.block": never;
	"gamePage.teamStats.type.mistake": never;
	"gamePage.teamStats.type.foulWon": never;
	"gamePage.teamStats.type.passSuccess": never;
	"gamePage.teamStats.type.pass": never;
	"gamePage.teamStats.type.passAccuracy": never;
	"gamePage.teamStats.type.keyPass": never;
	"gamePage.teamStats.type.passInFinalThirdSuccess": never;
	"gamePage.teamStats.type.passInFinalThird": never;
	"gamePage.teamStats.type.passInMiddleThirdSuccess": never;
	"gamePage.teamStats.type.passInMiddleThird": never;
	"gamePage.teamStats.type.passInDefensiveThirdSuccess": never;
	"gamePage.teamStats.type.passInDefensiveThird": never;
	"gamePage.teamStats.type.passLongSuccess": never;
	"gamePage.teamStats.type.passLong": never;
	"gamePage.teamStats.type.passMediumSuccess": never;
	"gamePage.teamStats.type.passMedium": never;
	"gamePage.teamStats.type.passShortSuccess": never;
	"gamePage.teamStats.type.passShort": never;
	"gamePage.teamStats.type.passForwardSuccess": never;
	"gamePage.teamStats.type.passForward": never;
	"gamePage.teamStats.type.passSidewaysSuccess": never;
	"gamePage.teamStats.type.passSideways": never;
	"gamePage.teamStats.type.passBackwardSuccess": never;
	"gamePage.teamStats.type.passBackward": never;
	"gamePage.teamStats.type.crossSuccess": never;
	"gamePage.teamStats.type.cross": never;
	"gamePage.playerStats.description.minutesPlayed": never;
	"gamePage.playerStats.description.rating": never;
	"gamePage.playerStats.description.goal": never;
	"gamePage.playerStats.description.offside": never;
	"gamePage.playerStats.description.shot": never;
	"gamePage.playerStats.description.assist": never;
	"gamePage.playerStats.description.freeKick": never;
	"gamePage.playerStats.description.corner": never;
	"gamePage.playerStats.description.throwIn": never;
	"gamePage.playerStats.description.foul": never;
	"gamePage.playerStats.description.cardYellow": never;
	"gamePage.playerStats.description.cardRed": never;
	"gamePage.playerStats.description.shotOnTarget": never;
	"gamePage.playerStats.description.shotBlocked": never;
	"gamePage.playerStats.description.shotOffTarget": never;
	"gamePage.playerStats.description.shotInsidePa": never;
	"gamePage.playerStats.description.shotOutsidePa": never;
	"gamePage.playerStats.description.tackleRatio": never;
	"gamePage.playerStats.description.aerialDuelRatio": never;
	"gamePage.playerStats.description.groundDuelRatio": never;
	"gamePage.playerStats.description.interception": never;
	"gamePage.playerStats.description.recovery": never;
	"gamePage.playerStats.description.block": never;
	"gamePage.playerStats.description.mistake": never;
	"gamePage.playerStats.description.foulWon": never;
	"gamePage.playerStats.description.passRatio": never;
	"gamePage.playerStats.description.passAccuracy": never;
	"gamePage.playerStats.description.keyPass": never;
	"gamePage.playerStats.description.passInFinalThirdRatio": never;
	"gamePage.playerStats.description.passInMiddleThirdRatio": never;
	"gamePage.playerStats.description.passInDefensiveThirdRatio": never;
	"gamePage.playerStats.description.passLongRatio": never;
	"gamePage.playerStats.description.passMediumRangeRatio": never;
	"gamePage.playerStats.description.passShortRatio": never;
	"gamePage.playerStats.description.passForwardRatio": never;
	"gamePage.playerStats.description.passSideWaysRatio": never;
	"gamePage.playerStats.description.passBackwardRatio": never;
	"gamePage.playerStats.description.crossRatio": never;
	"gamePage.playerStats.description.goalConceded": never;
	"gamePage.playerStats.description.catch": never;
	"gamePage.playerStats.description.punch": never;
	"gamePage.playerStats.description.goalKickSuccess": never;
	"gamePage.playerStats.description.goalKick": never;
	"gamePage.playerStats.description.aerialClearanceSuccess": never;
	"gamePage.playerStats.description.aerialClearance": never;
	"gamePage.playerStats.type.number": never;
	"gamePage.playerStats.type.name": never;
	"gamePage.playerStats.type.position": never;
	"gamePage.playerStats.type.rating": never;
	"gamePage.playerStats.type.minutesPlayed": never;
	"gamePage.playerStats.type.goal": never;
	"gamePage.playerStats.type.goalOwn": never;
	"gamePage.playerStats.type.assist": never;
	"gamePage.playerStats.type.offside": never;
	"gamePage.playerStats.type.shot": never;
	"gamePage.playerStats.type.freeKick": never;
	"gamePage.playerStats.type.corner": never;
	"gamePage.playerStats.type.throwIn": never;
	"gamePage.playerStats.type.foul": never;
	"gamePage.playerStats.type.cardYellow": never;
	"gamePage.playerStats.type.cardRed": never;
	"gamePage.playerStats.type.shotOnTarget": never;
	"gamePage.playerStats.type.shotBlocked": never;
	"gamePage.playerStats.type.shotOffTarget": never;
	"gamePage.playerStats.type.shotInsidePa": never;
	"gamePage.playerStats.type.shotOutsidePa": never;
	"gamePage.playerStats.type.tackle": never;
	"gamePage.playerStats.type.tackleRatio": never;
	"gamePage.playerStats.type.aerialDuelRatio": never;
	"gamePage.playerStats.type.groundDuelRatio": never;
	"gamePage.playerStats.type.interception": never;
	"gamePage.playerStats.type.recovery": never;
	"gamePage.playerStats.type.mistake": never;
	"gamePage.playerStats.type.foulWon": never;
	"gamePage.playerStats.type.passAccuracy": never;
	"gamePage.playerStats.type.keyPass": never;
	"gamePage.playerStats.type.passInFinalThirdRatio": never;
	"gamePage.playerStats.type.passInMiddleThirdRatio": never;
	"gamePage.playerStats.type.passInDefensiveThirdRatio": never;
	"gamePage.playerStats.type.passLongRatio": never;
	"gamePage.playerStats.type.passMediumRatio": never;
	"gamePage.playerStats.type.passShortRatio": never;
	"gamePage.playerStats.type.passForwardRatio": never;
	"gamePage.playerStats.type.passSidewaysRatio": never;
	"gamePage.playerStats.type.passBackwardRatio": never;
	"gamePage.playerStats.type.crossRatio": never;
	"gamePage.playerStats.type.goalConceded": never;
	"gamePage.playerStats.type.catch": never;
	"gamePage.playerStats.type.blockAndParry": never;
	"gamePage.playerStats.type.goalKickSuccess": never;
	"gamePage.playerStats.type.goalKick": never;
	"gamePage.playerStats.type.aerialClearanceSuccess": never;
	"gamePage.playerStats.type.aerialClearance": never;
	"gamePage.playerStats.type.block": never;
	"gamePage.playerStats.type.passRatio": never;
	"prod.text.dynamic.club.24661.biography": never;
	"prod.text.dynamic.game.47690.description": never;
	"gamePage.stats.category.summary": never;
	"gamePage.stats.category.offensive": never;
	"gamePage.stats.category.defensive": never;
	"gamePage.stats.category.distribution": never;
	"gamePage.stats.category.goalkeeper": never;
	"event.v3.type.block": never;
	"event.v3.type.clearance": never;
	"event.v3.type.own_goal": never;
	"event.v3.type.card": never;
	"event.v3.type.foul": never;
	"event.v3.type.interception": never;
	"event.v3.type.tackle": never;
	"event.v3.type.take_on_against": never;
	"event.v3.type.catch_interception": never;
	"event.v3.type.punch": never;
	"event.v3.type.goal_conceded": never;
	"event.v3.type.save": never;
	"event.v3.type.take_on": never;
	"event.v3.type.goal": never;
	"event.v3.type.foul_won": never;
	"event.v3.type.shot": never;
	"event.v3.type.aerial_duel": never;
	"event.v3.type.pass": never;
	"event.v3.type.corner": never;
	"event.v3.type.free_kick": never;
	"event.v3.type.goal_kick": never;
	"event.v3.type.throw_in": never;
	"event.v3.type.penalty": never;
	"prod.text.dynamic.club.24711.biography": never;
	"tag.Stat filter": never;
	"tag.Georgia": never;
	"tag.Estonia": never;
	"tag.Goals of the Week": never;
	"tag.Armenia": never;
	"tag.Cameroun": never;
	"tag.Latvia": never;
	"tag.Japan": never;
	"tag.Romania": never;
	"tag.Sierra Leone": never;
	"tag.Transfer": never;
	"gamePage.label.gameTypeInfo": never;
	"event.filter.category.offensive": never;
	"event.filter.category.defensive": never;
	"event.filter.category.distribution": never;
	"event.filter.category.set_pieces": never;
	"event.v3.type.highlight": never;
	"prod.text.dynamic.player.330744.notes": never;
	"prod.text.dynamic.player.330742.notes": never;
	"prod.text.dynamic.player.330743.notes": never;
	"prod.text.dynamic.player.330741.notes": never;
	"app.eyeball.create_player_card.picture.upload_info": never;
	"event.filter.period.1": never;
	"event.filter.period.2": never;
	"event.filter.period.3": never;
	"event.filter.period.4": never;
	"event.filter.period.5": never;
	"event.filter.category.goalkeeper": never;
	"prod.text.dynamic.game.48121.description": never;
	"prod.text.dynamic.club.24734.biography": never;
	"prod.text.dynamic.player.56877.notes": never;
	"event.v3.type.pass_received": never;
	"event.v3.type.recovery": never;
	"event.v3.type.ball_out_of_play": never;
	"event.v3.type.technical_error": never;
	"event.v3.type.substitution": never;
	"event.v3.type.offside": never;
	"event.filter.button.savedFilters": never;
	"event.filter.button.saveFilter": never;
	"event.filter.button.clearFilter": never;
	"event.v3.flag.block_type": never;
	"event.v3.flag.block_type.after_shot": never;
	"event.v3.flag.block_type.after_pass": never;
	"event.v3.flag.body_part": never;
	"event.v3.flag.body_part.left_foot": never;
	"event.v3.flag.body_part.right_foot": never;
	"event.v3.flag.body_part.head": never;
	"event.v3.flag.body_part.other": never;
	"event.v3.flag.under_pressure": never;
	"event.v3.flag.card_type": never;
	"event.v3.flag.card_type.yellow": never;
	"event.v3.flag.card_type.red": never;
	"event.v3.flag.goal_conceded_type": never;
	"event.v3.flag.goal_conceded_type.after_shot": never;
	"event.v3.flag.goal_conceded_type.after_penalty": never;
	"event.v3.flag.after_shot_inside_pa": never;
	"event.v3.flag.body_part.hand": never;
	"event.v3.flag.diving_save": never;
	"event.v3.flag.save_type": never;
	"event.v3.flag.save_type.block": never;
	"event.v3.flag.save_type.catch": never;
	"event.v3.flag.save_type.parry": never;
	"event.v3.flag.success": never;
	"event.v3.flag.success.true": never;
	"event.v3.flag.success.false": never;
	"event.v3.flag.third": never;
	"event.v3.flag.third.defensive": never;
	"event.v3.flag.third.middle": never;
	"event.v3.flag.third.final": never;
	"event.v3.flag.assist": never;
	"event.v3.flag.assist.true": never;
	"event.v3.flag.assist.false": never;
	"event.v3.flag.goal": never;
	"event.v3.flag.on_target": never;
	"event.v3.flag.on_target.on": never;
	"event.v3.flag.on_target.off": never;
	"event.v3.flag.on_target.blocked": never;
	"event.v3.flag.direction": never;
	"event.v3.flag.direction.forward": never;
	"event.v3.flag.direction.backward": never;
	"event.v3.flag.direction.sideways": never;
	"event.v3.flag.restart": never;
	"event.v3.flag.restart.free_kick": never;
	"event.v3.flag.restart.corner_kick": never;
	"event.v3.flag.restart.throw_in": never;
	"event.v3.flag.cross": never;
	"event.v3.flag.global.true": never;
	"event.v3.flag.global.false": never;
	"event.v3.flag.key_pass": never;
	"event.v3.flag.length": never;
	"event.v3.flag.length.short": never;
	"event.v3.flag.length.medium": never;
	"event.v3.flag.length.long": never;
	"event.v3.flag.goal_contribution": never;
	"event.v3.flag.global.na": never;
	"event.v3.flag.goal_contribution.assist": never;
	"event.v3.flag.goal_contribution.goal": never;
	"event.v3.type.cross": never;
	"event.v3.type.penalty_shootout": never;
	"event.v3.flag.event_type": never;
	"event.v3.flag.tackle_type": never;
	"event.v3.flag.tackle_type.standing": never;
	"event.v3.flag.tackle_type.sliding": never;
	"event.v3.flag.situation": never;
	"event.v3.flag.goal_type.play": never;
	"event.v3.flag.goal_type.penalty": never;
	"event.v3.flag.goal_type.shootout": never;
	"event.v3.flag.inside_pa": never;
	"event.v3.flag.gk_pass": never;
	"event.v3.flag.gk_pass.kick_from_hand": never;
	"event.v3.flag.gk_pass.kick_from_ground": never;
	"event.v3.flag.gk_pass.throw": never;
	"event.v3.flag.restart.goal_kick": never;
	"event.v3.flag.restart.penalty": never;
	"event.v3.flag.restart.shootout": never;
	"event.v3.type.control_under_pressure": never;
	"eventList.action.selectAll": never;
	"eventList.action.createClip": never;
	"teamSheet.eventsModal.action.deselectAll": never;
	"teamSheet.eventsModal.action.selectAll": never;
	"teamSheet.eventsModal.action.createClip": never;
	"teamSheet.eventsModal.action.playEvents": never;
	"app.player.clubId.id.notNull": never;
	"previousClub.not.found": never;
	"prod.text.dynamic.game.48596.description": never;
	"prod.text.dynamic.game.48528.description": never;
	"prod.text.dynamic.game.48738.description": never;
	"prod.text.dynamic.club.24804.biography": never;
	"prod.text.dynamic.player.0.notes": never;
	"prod.text.dynamic.player.46175.notes": never;
	"common.action.save": never;
	"common.action.cancel": never;
	"common.action.overwrite": never;
	"event.filter.create.title": never;
	"common.action.delete": never;
	"event.filter.delete.title": never;
	"event.filter.create.text": never;
	"event.filter.overwrite.title": never;
	"event.filter.create.input.placeholder": never;
	"prod.text.dynamic.club.24819.biography": never;
	"prod.text.dynamic.player.330415.notes": never;
	"prod.text.dynamic.player.38456.notes": never;
	"gamePage.label.clipDescription": never;
	"gamePage.label.clipName": never;
	"prod.text.dynamic.player.417602.notes": never;
	"prod.text.dynamic.player.417649.notes": never;
	"prod.text.dynamic.player.417639.notes": never;
	"prod.text.dynamic.player.417626.notes": never;
	"prod.text.dynamic.player.417712.notes": never;
	"prod.text.dynamic.player.417805.notes": never;
	"prod.text.dynamic.game.49090.description": never;
	"gamePage.teamStats.type.goalOwn": never;
	"teamSheet.eventsModal.action.advancedFilters": never;
	"teamSheet.eventsModal.nothingToPlay": never;
	"gamePage.teamStats.type.shot": never;
	"matchSheet.table.actions": never;
	"prod.text.dynamic.club.24881.biography": never;
	"prod.text.dynamic.game.49586.description": never;
	"prod.text.dynamic.player.407834.notes": never;
	"prod.text.dynamic.player.418176.notes": never;
	"prod.text.dynamic.player.330412.notes": never;
	"label.gamePage.eventsPlaying": never;
	"teamSheet.eventsModal.action.playEventsAll": never;
	"label.gamePage.events.noFilter": never;
	"gamePage.teamStats.type.shotBlocked": never;
	"prod.text.dynamic.club.24940.biography": never;
	"prod.text.dynamic.game.50294.description": never;
	"stats.export.title": never;
	"stats.export.periods": never;
	"stats.export.team": never;
	"stats.export.statsCategories": never;
	"clipModal.create.name": never;
	"clipModal.create.description": never;
	"stats.export.events": never;
	"stats.export.teams": never;
	"prod.text.dynamic.club.24962.biography": never;
	"prod.text.dynamic.club.24963.biography": never;
	"label.validation.endStartTime": never;
	"label.btn.deleteEvent": never;
	"gamePage.message.deleteClip": never;
	"label.error.invalidForm": never;
	"label.btn.export": never;
	"label.gamePage.filteredEvents": never;
	"message.gamePage.noRelevantEvents": never;
	"prod.text.dynamic.game.50508.description": never;
	"prod.text.dynamic.game.50082.description": never;
	"prod.text.dynamic.player.37965.notes": never;
	"prod.text.dynamic.player.378708.notes": never;
	"gamePage.playerStats.type.takeOnRatio": never;
	"gamePage.playerStats.description.takeOnRatio": never;
	"prod.text.dynamic.player.398625.notes": never;
	"prod.text.dynamic.player.37961.notes": never;
	"product.management.api": never;
	"product.management.api.die_ligen": never;
	"prod.text.dynamic.club.25062.biography": never;
	"gamePage.playerStats.export.button": never;
	"gamePage.teamStats.export.button": never;
	"gamePage.teamStats.playHome": never;
	"gamePage.teamStats.playAway": never;
	"gamePage.teamStats.playAll": never;
	"stats.export.submit": never;
	"prod.text.dynamic.club.25099.biography": never;
	"gamePage.playerStats.export.column.team": never;
	"gamePage.teamStats.export.column.category": never;
	"gamePage.teamStats.export.column.statistic": never;
	"prod.text.dynamic.player.271095.notes": never;
	"prod.text.dynamic.player.419970.notes": never;
	"prod.text.dynamic.player.419964.notes": never;
	"prod.text.dynamic.club.25183.biography": never;
	"prod.text.dynamic.player.34762.notes": never;
	"prod.text.dynamic.player.47659.notes": never;
	"prod.text.dynamic.club.25265.biography": never;
	"label.skipReview": never;
	"label.skipReview.info": never;
	"label.resync_options.all_keep_mapping": never;
	"prod.text.dynamic.club.25312.biography": never;
	"app.player.custom.filter.goal": never;
	"app.player.custom.filter.save": never;
	"app.player.custom.filter.nice_move": never;
	"app.player.custom.filter.off_the_ball": never;
	"app.player.custom.filter.celebration": never;
	"app.player.custom.filter.dribble": never;
	"app.player.custom.filter.magic": never;
	"app.player.custom.filter.nutmeg": never;
	"app.player.custom.filter.off_the_post": never;
	"app.player.custom.filter.other": never;
	"highlight.filter.tags": never;
	"prod.text.dynamic.club.25328.biography": never;
	"prod.text.dynamic.player.304991.notes": never;
	"prod.text.dynamic.club.25339.biography": never;
	"gamePage.teamStats.playHomeGoal": never;
	"gamePage.teamStats.playAwayGoal": never;
	"gamePage.teamStats.playAwayGoalOwn": never;
	"gamePage.teamStats.playHomeGoalOwn": never;
	"prod.text.dynamic.player.13968.notes": never;
	"prod.text.dynamic.club.25393.biography": never;
	"prod.text.dynamic.club.25395.biography": never;
	"prod.text.dynamic.club.25397.biography": never;
	"prod.text.dynamic.player.319541.notes": never;
	"event.filter.tags": never;
	"prod.text.dynamic.player.45362.notes": never;
	"prod.text.dynamic.club.25469.biography": never;
	"app.player.game_page.content.actions.title": never;
	"video-tasks.table.link.teamsheet": never;
	"video-tasks.modal.teamsheet.error.no_club": never;
	"video-tasks.modal.teamsheet.table.name": never;
	"video-tasks.modal.teamsheet.table.status": never;
	"video-tasks.table.header.eyeball_game_id": never;
	"video-tasks.table.header.video_id": never;
	"video-tasks.table.header.match_id": never;
	"video-tasks.table.header.game_date": never;
	"video-tasks.table.header.updated_at": never;
	"video-tasks.table.header.league": never;
	"video-tasks.table.header.league_country": never;
	"video-tasks.table.header.home_team": never;
	"video-tasks.table.header.away_team": never;
	"video-tasks.table.header.video_status": never;
	"video-tasks.table.header.teamsheet_status": never;
	"video-tasks.table.header.actions": never;
	"video-tasks.table.status.pending": never;
	"video-tasks.table.status.not_available": never;
	"video-tasks.table.status.available": never;
	"video-tasks.table.status.mapped": never;
	"video-tasks.table.status.not_mapped": never;
	"video-tasks.table.status.partially_mapped": never;
	"video-tasks.table.status.queued": never;
	"video-tasks.table.status.initialized": never;
	"video-tasks.table.status.downloading": never;
	"video-tasks.table.status.downloaded": never;
	"video-tasks.table.status.migrated": never;
	"video-tasks.table.status.error": never;
	"prod.text.dynamic.player.380248.notes": never;
	"video-tasks.modal.teamsheet.create_action": never;
	"video-tasks.modal.teamsheet.map_action": never;
	"video-tasks.modal.teamsheet.error.unknown": never;
	"prod.text.dynamic.club.25552.biography": never;
	"prod.text.dynamic.player.448827.notes": never;
	"prod.text.dynamic.player.448826.notes": never;
	"prod.text.dynamic.player.448825.notes": never;
	"prod.text.dynamic.player.448824.notes": never;
	"prod.text.dynamic.player.448831.notes": never;
	"prod.text.dynamic.club.25609.biography": never;
	"prod.text.dynamic.club.25610.biography": never;
	"prod.text.dynamic.club.25611.biography": never;
	"prod.text.dynamic.club.25612.biography": never;
	"prod.text.dynamic.club.25613.biography": never;
	"prod.text.dynamic.club.25614.biography": never;
	"prod.text.dynamic.club.25615.biography": never;
	"prod.text.dynamic.club.25616.biography": never;
	"gamePage.teamStats.type.groundDuelsSuccess": never;
	"gamePage.teamStats.type.groundDuelsTotal": never;
	"gamePage.teamStats.type.interventions": never;
	"gamePage.teamStats.type.controlUnderPressure": never;
	"video-tasks.table.zero_records": never;
	"video-tasks.table.end_of_list": never;
	"video-tasks.table.fetching": never;
	"prod.text.dynamic.club.25640.biography": never;
	"prod.text.dynamic.club.25642.biography": never;
	"prod.text.dynamic.club.25702.biography": never;
	"prod.text.dynamic.club.25715.biography": never;
	"prod.text.dynamic.club.25717.biography": never;
	"prod.text.dynamic.club.25718.biography": never;
	"prod.text.dynamic.club.25719.biography": never;
	"prod.text.dynamic.player.455691.notes": never;
	"prod.text.dynamic.player.455727.notes": never;
	"prod.text.dynamic.club.25745.biography": never;
	"prod.text.dynamic.player.273038.notes": never;
	"gamePage.teamStats.type.fieldTilt": never;
	"gamePage.teamStats.description.fieldTilt": never;
	"gamePage.teamStats.type.shotConversion": never;
	"prod.text.dynamic.club.25792.biography": never;
	"gamePage.teamStats.description.shotConversion": never;
	"gamePage.playerStats.type.shotConversion": never;
	"prod.text.dynamic.player.459091.notes": never;
	"prod.text.dynamic.player.459094.notes": never;
	"prod.text.dynamic.player.459095.notes": never;
	"prod.text.dynamic.player.459106.notes": never;
	"prod.text.dynamic.player.459096.notes": never;
	"prod.text.dynamic.player.459097.notes": never;
	"prod.text.dynamic.player.459098.notes": never;
	"prod.text.dynamic.player.459099.notes": never;
	"prod.text.dynamic.player.459100.notes": never;
	"prod.text.dynamic.player.459101.notes": never;
	"prod.text.dynamic.player.459102.notes": never;
	"prod.text.dynamic.player.459103.notes": never;
	"prod.text.dynamic.player.459104.notes": never;
	"prod.text.dynamic.player.459105.notes": never;
	"prod.text.dynamic.player.459135.notes": never;
	"prod.text.dynamic.player.459188.notes": never;
	"prod.text.dynamic.player.459191.notes": never;
	"prod.text.dynamic.player.459192.notes": never;
	"prod.text.dynamic.player.459193.notes": never;
	"prod.text.dynamic.player.459194.notes": never;
	"prod.text.dynamic.player.459195.notes": never;
	"prod.text.dynamic.player.459171.notes": never;
	"prod.text.dynamic.player.457904.notes": never;
	"gamePage.teamStats.type.secondBallWon": never;
	"video-tasks.modal.teamsheet.title": never;
	"video-tasks.table.header.category": never;
	"gamePage.teamStats.description.secondBallWon": never;
	"gamePage.header.noClub": never;
	"video-tasks.modal.teamsheet.map.warning": never;
	"video-tasks.modal.teamsheet.map.submit": never;
	"video-tasks.modal.teamsheet.map.title": never;
	"video-tasks.modal.teamsheet.map.success.updated": never;
	"video-tasks.modal.teamsheet.createStatus.success": never;
	"prod.text.dynamic.player.460317.notes": never;
	"prod.text.dynamic.player.460318.notes": never;
	"prod.text.dynamic.club.24335.biography": never;
	"prod.text.dynamic.club.25864.biography": never;
	"prod.text.dynamic.club.25870.biography": never;
	"gamePage.label.dataInsights": never;
	"gamePage.dataInsights.label.periods": never;
	"gamePage.playerStats.description.passSidewaysRatio": never;
	"gamePage.playerStats.description.passMediumRatio": never;
	"gamePage.dataInsights.eventType.takeOn": never;
	"gamePage.dataInsights.eventType.goal": never;
	"gamePage.dataInsights.eventType.foulWon": never;
	"gamePage.dataInsights.eventType.shot": never;
	"prod.text.dynamic.club.25891.biography": never;
	"prod.text.dynamic.club.25892.biography": never;
	"prod.text.dynamic.club.25893.biography": never;
	"gamePage.dataInsights.eventType.technicalError": never;
	"gamePage.dataInsights.eventType.goalOwn": never;
	"gamePage.dataInsights.eventType.foulCommited": never;
	"gamePage.dataInsights.eventType.block": never;
	"gamePage.dataInsights.eventType.interception": never;
	"gamePage.dataInsights.eventType.tackle": never;
	"gamePage.dataInsights.eventType.clearance": never;
	"gamePage.dataInsights.eventType.card": never;
	"gamePage.dataInsights.eventType.takeOnAgainst": never;
	"gamePage.dataInsights.eventType.aerialDuel": never;
	"gamePage.dataInsights.eventType.pass": never;
	"gamePage.dataInsights.eventType.passReceived": never;
	"gamePage.dataInsights.eventType.loseBallRecovery": never;
	"gamePage.dataInsights.eventType.offside": never;
	"gamePage.dataInsights.eventType.catchInterception": never;
	"gamePage.dataInsights.eventType.punch": never;
	"gamePage.dataInsights.eventType.goalConceded": never;
	"gamePage.dataInsights.eventType.save": never;
	"prod.text.dynamic.club.25897.biography": never;
	"event.v3.label.flag": never;
	"prod.text.dynamic.club.25935.biography": never;
	"prod.text.dynamic.club.25964.biography": never;
	"gamePage.playerRating.modal.rating.title": {
		player: string;
	};
	"gamePage.playerRating.modal.badge.title": {
		player: string;
	};
	"gamePage.playerRating.modal.title": never;
	"gamePage.playerRating.modal.primaryButton": never;
	"gamePage.playerRating.modal.secondaryButton": never;
	"gamePage.playerRating.modal.visibility.title": never;
	"gamePage.playerRating.modal.visibility.text": never;
	"gamePage.playerRating.modal.visibility.coach": never;
	"gamePage.playerRating.modal.visibility.player": never;
	"gamePage.playerRating.modal.visibility.playerParent": never;
	"gamePage.playerRating.modal.rating.text": never;
	"gamePage.playerRating.modal.badge.text": never;
	"gamePage.playerRating.modal.visibility.badgesTooltip": never;
	"prod.text.dynamic.club.25974.biography": never;
	"prod.text.dynamic.club.26031.biography": never;
	"gamePage.dataInsights.label.playAll": never;
	"gamePage.dataInsights.label.player": never;
	"gamePage.dataInsights.label.viewEvent": never;
	"gamePage.dataInsights.label.min": never;
	"gamePage.dataInsights.label.sec": never;
	"gamePage.dataInsights.label.time": never;
	"prod.text.dynamic.club.26041.biography": never;
	"resource.discover_sections_management": never;
	"prod.text.dynamic.club.26050.biography": never;
	"prod.text.dynamic.club.26051.biography": never;
	"prod.text.dynamic.club.26063.biography": never;
	"prod.text.dynamic.club.26064.biography": never;
	"prod.text.dynamic.club.26065.biography": never;
	"prod.text.dynamic.club.26107.biography": never;
	"prod.text.dynamic.club.25832.biography": never;
	"gamePage.dataInsights.filter.showPlayerNumber": never;
	"video-tasks.table.status.home_club_not_mapped": never;
	"video-tasks.table.status.away_club_not_mapped": never;
	"video-tasks.table.status.both_club_not_mapped": never;
	"prod.text.dynamic.club.26128.biography": never;
	"gamePage.dataInsights.label.addWidget": never;
	"gamePage.dataInsights.label.resetDefault": never;
	"gamePage.dataInsights.label.parameters": never;
	"token.movement.type.add_purchase": never;
	"token.movement.type.add_gift": never;
	"token.movement.type.remove_refund": never;
	"token.movement.type.remove_remove": never;
	"token.movement.type.transfer_from_club": never;
	"token.movement.type.transfer_to_team": never;
	"gamePage.dataInsights.label.saveView": never;
	"prod.text.dynamic.club.26142.biography": never;
	"tokens.modal.message.added": never;
	"tokens.modal.message.removed": never;
	"prod.text.dynamic.club.24526.biography": never;
	"prod.text.dynamic.player.438723.notes": never;
	"prod.text.dynamic.club.26176.biography": never;
	"prod.text.dynamic.player.396451.notes": never;
	"prod.text.dynamic.player.396452.notes": never;
	"prod.text.dynamic.player.21726.notes": never;
	"prod.text.dynamic.player.345066.notes": never;
	"prod.text.dynamic.player.33748.notes": never;
	"prod.text.dynamic.player.47315.notes": never;
	"product.management.discover": never;
	"gamePage.dataInsights.label.unkownError": never;
	"prod.text.dynamic.club.26211.biography": never;
	"prod.text.dynamic.club.26109.biography": never;
	"prod.text.dynamic.club.26249.biography": never;
	"video-tasks.table.filter.all_unmapped_clubs": never;
	"video-tasks.table.filter.label": never;
	"admin.nonPartnerPlayer.updated": never;
	"admin.nonPartnerPlayer.created": never;
	"error.nonPartnerPlayer.duplicateNameInClub": never;
	"gamePage.dataInsights.label.details": never;
	"gamePage.dataInsights.label.addTab": never;
	"prod.text.dynamic.club.26263.biography": never;
	"prod.text.dynamic.club.26264.biography": never;
	"prod.text.dynamic.club.26265.biography": never;
	"seasonModal.title": never;
	"seasonModal.reset_button": never;
	"common.action.confirm": never;
	"season.selection.text": never;
	"gamePage.dataInsights.label.limitedExperience": never;
	"gamePage.dataInsights.label.limitedExpTooltip": never;
	"gamePage.dataInsights.label.invalidInput": never;
	"gamePage.dataInsights.label.editTab": never;
	"prod.text.dynamic.player.473159.notes": never;
	"prod.text.dynamic.player.473153.notes": never;
	"prod.text.dynamic.player.473154.notes": never;
	"prod.text.dynamic.player.472463.notes": never;
	"prod.text.dynamic.player.472460.notes": never;
	"prod.text.dynamic.player.472468.notes": never;
	"prod.text.dynamic.player.472472.notes": never;
	"prod.text.dynamic.player.472462.notes": never;
	"prod.text.dynamic.player.472464.notes": never;
	"prod.text.dynamic.player.472461.notes": never;
	"prod.text.dynamic.player.421020.notes": never;
	"prod.text.dynamic.player.472467.notes": never;
	"prod.text.dynamic.player.421021.notes": never;
	"season.label.newFunction": never;
	"seasonModal.dateRange.placeholder": never;
	"seasonModal.dateRange.tooLong": never;
	"seasonModal.dateRange.betaInfo": never;
	"seasonModal.dateRange.title": never;
	"prod.text.dynamic.club.26311.biography": never;
	"btn.submit_form": never;
	"prod.text.dynamic.player.369161.notes": never;
	"prod.text.dynamic.club.26338.biography": never;
	"prod.text.dynamic.player.290634.notes": never;
	"prod.text.dynamic.player.475847.notes": never;
	"prod.text.dynamic.player.475849.notes": never;
	"prod.text.dynamic.player.475852.notes": never;
	"prod.text.dynamic.player.475853.notes": never;
	"prod.text.dynamic.player.475856.notes": never;
	"prod.text.dynamic.player.475876.notes": never;
	"prod.text.dynamic.player.475878.notes": never;
	"prod.text.dynamic.player.475857.notes": never;
	"video-tasks.modal.teamsheet.map.search_by_name_or_id": never;
	"video-tasks.table.status.optimized": never;
	"resource.discover_token_management": never;
	"tag.Team of the week": never;
	"tag.Stat Filter": never;
	"tag.Cameroon": never;
	"tag.Morocco": never;
	"tag.Guinea": never;
	"tag.North Macedonia": never;
	"tag.South Africa": never;
	"tag.Burkina Faso": never;
	"tag.Gambia": never;
	"tag.Marko Mrdalj": never;
	"tag.Slovakia": never;
	"tag.Marko MrdaIj": never;
	"prod.text.dynamic.club.26466.biography": never;
	"gamePage.label.physicalMetrics": never;
	"gamePage.physicalMetrics.statsLink": never;
	"common.action.downloadPdf": never;
	"gamePage.physicalMetrics.request": never;
	"gamePage.physicalMetrics.downloadLink": never;
	"gamePage.physicalMetrics.nextVideoLink": never;
	"gamePage.physicalMetrics.addNextLink": never;
	"common.validation.url": never;
	"prod.text.dynamic.player.37947.notes": never;
	"prod.text.dynamic.player.46793.notes": never;
	"prod.text.dynamic.player.256401.notes": never;
	"prod.text.dynamic.player.436517.notes": never;
	"gamePage.physicalMetrics.unknownErrorOccured": never;
	"prod.text.dynamic.club.26596.biography": never;
	"gamePage.physicalMetrics.status.Initial": never;
	"gamePage.physicalMetrics.status.Requested": never;
	"gamePage.physicalMetrics.status.In-Progress": never;
	"gamePage.physicalMetrics.status.Review": never;
	"gamePage.physicalMetrics.status.Done": never;
	"gamePage.physicalMetrics.status.Rejected": never;
	"prod.text.dynamic.club.26657.biography": never;
	"prod.text.dynamic.club.26658.biography": never;
	"prod.text.dynamic.club.26659.biography": never;
	"prod.text.dynamic.club.26660.biography": never;
	"prod.text.dynamic.club.26661.biography": never;
	"prod.text.dynamic.club.26662.biography": never;
	"prod.text.dynamic.club.26703.biography": never;
	"gamePage.dataInsights.chart.culmulative": never;
	"prod.text.dynamic.player.479095.notes": never;
	"prod.text.dynamic.club.26744.biography": never;
	"gamePage.physicalMetrics.modal.savedVideoUrl": never;
	"prod.text.dynamic.club.26762.biography": never;
	"gamePage.playerStats.description.shotConversion": never;
	"prod.text.dynamic.club.25899.biography": never;
	"prod.text.dynamic.player.495442.notes": never;
	"prod.text.dynamic.player.493121.notes": never;
	"prod.text.dynamic.player.493119.notes": never;
	"prod.text.dynamic.player.495441.notes": never;
	"matchSheet.table.anonymized": never;
	"matchSheet.table.anonymized.tooltip.title": never;
	"matchSheet.table.anonymized.tooltip.content": never;
	"matchSheet.table.anonymize.all": never;
	"matchSheet.table.deanonymize.all": never;
	"prod.text.dynamic.player.476059.notes": never;
	"gamePage.dataInsights.chart.distributionTimePeriod": never;
	"gamePage.dataInsights.saveSettings.error": never;
	"prod.text.dynamic.player.497606.notes": never;
	"prod.text.dynamic.club.26989.biography": never;
	"gamePage.dataInsights.label.emptyWidget": never;
	"gamePage.dataInsights.label.customWidgets": never;
	"gamePage.dataInsights.modal.newWidget": never;
	"gamePage.dataInsights.modal.widgetRemoved": never;
	"gamePage.dataInsights.modal.tabAdded": never;
	"gamePage.dataInsights.modal.tabRemoved": never;
	"gamePage.dataInsights.modal.tabUpdated": never;
	"gamePage.dataInsights.label.widgetSettingSaved": never;
	"gamePage.dataInsights.label.navigateTo": never;
	"prod.text.dynamic.club.27066.biography": never;
	"gamePage.dataInsights.label.eventType": never;
	"gamePage.dataInsights.label.visualMap": never;
	"gamePage.dataInsights.label.customInsights": never;
	"gamePage.dataInsights.flashBag.resetMessage": never;
	"prod.text.dynamic.player.420293.notes": never;
	"prod.text.dynamic.player.420287.notes": never;
	"prod.text.dynamic.player.420292.notes": never;
	"prod.text.dynamic.player.420294.notes": never;
	"prod.text.dynamic.player.420296.notes": never;
	"prod.text.dynamic.player.420295.notes": never;
	"prod.text.dynamic.player.498163.notes": never;
	"prod.text.dynamic.player.452336.notes": never;
	"label.form.nationalCountries": never;
	"prod.text.dynamic.player.449102.notes": never;
	"prod.text.dynamic.club.27258.biography": never;
	"prod.text.dynamic.player.35660.notes": never;
	"gamePage.dataInsights.mapType.PointMap": never;
	"prod.text.dynamic.player.506254.notes": never;
	"gamePage.dataInsights.mapType.directional": never;
	"gamePage.dataInsights.mapType.zonal": never;
	"gamePage.dataInsights.mapType.distributionChart": never;
	"gamePage.dataInsights.mapType.cumulativeProgressionCharts": never;
	"prod.text.dynamic.player.506257.notes": never;
	"prod.text.dynamic.player.506258.notes": never;
	"prod.text.dynamic.player.506259.notes": never;
	"prod.text.dynamic.player.506260.notes": never;
	"prod.text.dynamic.player.506261.notes": never;
	"prod.text.dynamic.player.506262.notes": never;
	"prod.text.dynamic.player.506265.notes": never;
	"prod.text.dynamic.player.506266.notes": never;
	"prod.text.dynamic.player.506267.notes": never;
	"prod.text.dynamic.player.506269.notes": never;
	"prod.text.dynamic.player.506255.notes": never;
	"prod.text.dynamic.player.506256.notes": never;
	"prod.text.dynamic.player.506263.notes": never;
	"prod.text.dynamic.player.506264.notes": never;
	"prod.text.dynamic.player.506268.notes": never;
	"prod.text.dynamic.player.506270.notes": never;
	"prod.text.dynamic.player.506271.notes": never;
	"gamePage.dataInsights.label.playerNumber": never;
	"resource.operations_management": never;
	"prod.text.dynamic.player.38401.notes": never;
	"prod.text.dynamic.player.509154.notes": never;
	"prod.text.dynamic.player.508046.notes": never;
	"prod.text.dynamic.player.48613.notes": never;
	"prod.text.dynamic.player.49959.notes": never;
	"prod.text.dynamic.player.58572.notes": never;
	"prod.text.dynamic.player.338802.notes": never;
	"prod.text.dynamic.player.474627.notes": never;
	"prod.text.dynamic.player.474628.notes": never;
	"prod.text.dynamic.player.474629.notes": never;
	"prod.text.dynamic.player.474630.notes": never;
	"prod.text.dynamic.player.403428.notes": never;
	"prod.text.dynamic.player.324041.notes": never;
	"prod.text.dynamic.player.324048.notes": never;
	"prod.text.dynamic.player.325824.notes": never;
	"prod.text.dynamic.player.403430.notes": never;
	"prod.text.dynamic.player.324044.notes": never;
	"prod.text.dynamic.player.324042.notes": never;
	"prod.text.dynamic.player.324046.notes": never;
	"prod.text.dynamic.player.324043.notes": never;
	"prod.text.dynamic.player.484443.notes": never;
	"prod.text.dynamic.player.324037.notes": never;
	"prod.text.dynamic.player.484463.notes": never;
	"prod.text.dynamic.player.343099.notes": never;
	"prod.text.dynamic.player.368070.notes": never;
	"prod.text.dynamic.player.339379.notes": never;
	"prod.text.dynamic.player.330094.notes": never;
	"prod.text.dynamic.player.324050.notes": never;
	"prod.text.dynamic.player.48548.notes": never;
	"prod.text.dynamic.player.48551.notes": never;
	"prod.text.dynamic.player.50492.notes": never;
	"prod.text.dynamic.player.325825.notes": never;
	"prod.text.dynamic.player.330041.notes": never;
	"prod.text.dynamic.player.424140.notes": never;
	"prod.text.dynamic.player.50089.notes": never;
	"prod.text.dynamic.player.320378.notes": never;
	"prod.text.dynamic.player.325829.notes": never;
	"prod.text.dynamic.player.344611.notes": never;
	"prod.text.dynamic.player.510497.notes": never;
	"prod.text.dynamic.club.27369.biography": never;
	"prod.text.dynamic.player.509155.notes": never;
	"label.old_players": never;
	"prod.text.dynamic.player.476850.notes": never;
	"prod.text.dynamic.player.476871.notes": never;
	"gamePage.physicalMetrics.modal.duplicateUrl": never;
	"prod.text.dynamic.player.498215.notes": never;
	"prod.text.dynamic.player.501313.notes": never;
	"prod.text.dynamic.player.498193.notes": never;
	"continents.nationalContinents": never;
	"national_team.europe": never;
	"national_team.africa": never;
	"prod.text.dynamic.player.466018.notes": never;
	"prod.text.dynamic.player.466019.notes": never;
	"prod.text.dynamic.player.466022.notes": never;
	"prod.text.dynamic.player.466023.notes": never;
	"prod.text.dynamic.player.466029.notes": never;
	"prod.text.dynamic.player.466031.notes": never;
	"prod.text.dynamic.player.466032.notes": never;
	"prod.text.dynamic.player.466034.notes": never;
	"prod.text.dynamic.player.466035.notes": never;
	"prod.text.dynamic.player.466057.notes": never;
	"prod.text.dynamic.club.27432.biography": never;
	"prod.text.dynamic.player.512567.notes": never;
	"prod.text.dynamic.player.498199.notes": never;
	"prod.text.dynamic.player.498200.notes": never;
	"prod.text.dynamic.player.485243.notes": never;
	"prod.text.dynamic.player.501330.notes": never;
	"gamePage.dataInsights.test": never;
	"prod.text.dynamic.club.27443.biography": never;
	"prod.text.dynamic.player.476772.notes": never;
	"prod.text.dynamic.player.485242.notes": never;
	"prod.text.dynamic.club.27501.biography": never;
	"prod.text.dynamic.club.27508.biography": never;
	"club.partner-club": never;
	"prod.text.dynamic.player.444796.notes": never;
	"prod.text.dynamic.player.474379.notes": never;
	"tag.Samet Caliskan": never;
	"tag.Brazil": never;
	"prod.text.dynamic.player.522785.notes": never;
	"prod.text.dynamic.player.516461.notes": never;
	"tag.Argentina": never;
	"tag.Colombia": never;
	"tag.Uruguay": never;
	"tag.Czech Republic": never;
	"tag.Scotland": never;
	"tag.South America": never;
	"prod.text.dynamic.club.27643.biography": never;
	"prod.text.dynamic.player.475688.notes": never;
	"prod.text.dynamic.club.27706.biography": never;
	"prod.text.dynamic.club.27710.biography": never;
	"prod.text.dynamic.player.450913.notes": never;
	"prod.text.dynamic.player.452145.notes": never;
	"prod.text.dynamic.player.451006.notes": never;
	"prod.text.dynamic.player.452143.notes": never;
	"breadcrumb.backTo./": never;
	"breadcrumb.backTo./clubs": never;
	"breadcrumb.backTo./my-eyeball/my-clubs": never;
	"breadcrumb.backTo./my-eyeball/my-teams": never;
	"breadcrumb.backTo./players-of-the-week": never;
	"breadcrumb.backTo./players": never;
	"breadcrumb.backTo./my-eyeball/my-players": never;
	"breadcrumb.backTo./my-eyeball/my-games": never;
	"breadcrumb.backTo./games": never;
	"breadcrumb.backTo./club/non-partner": never;
	"prod.text.dynamic.player.525548.notes": never;
	"prod.text.dynamic.player.525550.notes": never;
	"prod.text.dynamic.player.525551.notes": never;
	"prod.text.dynamic.player.525552.notes": never;
	"prod.text.dynamic.player.525553.notes": never;
	"national_team.asia": never;
	"national_team.northAmerica": never;
	"national_team.southAmerica": never;
	"national_team.oceania": never;
	"prod.text.dynamic.player.405943.notes": never;
	"prod.text.dynamic.player.474814.notes": never;
	"prod.text.dynamic.player.474817.notes": never;
	"prod.text.dynamic.player.474818.notes": never;
	"prod.text.dynamic.player.481098.notes": never;
	"prod.text.dynamic.player.481097.notes": never;
	"prod.text.dynamic.player.527134.notes": never;
	"prod.text.dynamic.player.528444.notes": never;
	"prod.text.dynamic.player.528463.notes": never;
	"prod.text.dynamic.player.528464.notes": never;
	"prod.text.dynamic.player.528465.notes": never;
	"prod.text.dynamic.player.528474.notes": never;
	"prod.text.dynamic.player.528476.notes": never;
	"prod.text.dynamic.player.528477.notes": never;
	"prod.text.dynamic.player.528478.notes": never;
	"prod.text.dynamic.player.528480.notes": never;
	"prod.text.dynamic.player.528481.notes": never;
	"prod.text.dynamic.player.528484.notes": never;
	"prod.text.dynamic.player.528485.notes": never;
	"prod.text.dynamic.player.528486.notes": never;
	"prod.text.dynamic.player.528487.notes": never;
	"prod.text.dynamic.player.528488.notes": never;
	"prod.text.dynamic.player.528489.notes": never;
	"prod.text.dynamic.player.528490.notes": never;
	"prod.text.dynamic.player.528491.notes": never;
	"prod.text.dynamic.player.528492.notes": never;
	"prod.text.dynamic.player.528493.notes": never;
	"prod.text.dynamic.player.528494.notes": never;
	"prod.text.dynamic.player.528495.notes": never;
	"prod.text.dynamic.player.528496.notes": never;
	"prod.text.dynamic.player.528497.notes": never;
	"prod.text.dynamic.player.528498.notes": never;
	"prod.text.dynamic.player.528499.notes": never;
	"prod.text.dynamic.player.528500.notes": never;
	"prod.text.dynamic.player.528501.notes": never;
	"prod.text.dynamic.player.528503.notes": never;
	"prod.text.dynamic.player.528504.notes": never;
	"prod.text.dynamic.player.528506.notes": never;
	"prod.text.dynamic.player.528508.notes": never;
	"prod.text.dynamic.player.528523.notes": never;
	"prod.text.dynamic.player.528524.notes": never;
	"prod.text.dynamic.player.528525.notes": never;
	"prod.text.dynamic.player.528546.notes": never;
	"prod.text.dynamic.player.528549.notes": never;
	"leftFilter.height.weight.tootlip": never;
	"prod.text.dynamic.player.528556.notes": never;
	"prod.text.dynamic.player.528557.notes": never;
	"prod.text.dynamic.player.528558.notes": never;
	"prod.text.dynamic.player.528559.notes": never;
	"prod.text.dynamic.player.528560.notes": never;
	"prod.text.dynamic.player.528561.notes": never;
	"prod.text.dynamic.player.528562.notes": never;
	"prod.text.dynamic.player.528563.notes": never;
	"prod.text.dynamic.player.528564.notes": never;
	"prod.text.dynamic.player.528566.notes": never;
	"prod.text.dynamic.player.528567.notes": never;
	"prod.text.dynamic.player.528568.notes": never;
	"prod.text.dynamic.player.528569.notes": never;
	"prod.text.dynamic.player.528572.notes": never;
	"prod.text.dynamic.player.528573.notes": never;
	"prod.text.dynamic.player.528574.notes": never;
	"prod.text.dynamic.player.528575.notes": never;
	"prod.text.dynamic.player.528576.notes": never;
	"prod.text.dynamic.player.528577.notes": never;
	"prod.text.dynamic.player.528579.notes": never;
	"prod.text.dynamic.player.528580.notes": never;
	"prod.text.dynamic.player.528598.notes": never;
	"breadcrumb.backTo./national-leagues": never;
	"prod.text.dynamic.player.529238.notes": never;
	"prod.text.dynamic.player.529239.notes": never;
	"prod.text.dynamic.player.529262.notes": never;
	"prod.text.dynamic.player.529270.notes": never;
	"prod.text.dynamic.player.529271.notes": never;
	"prod.text.dynamic.player.529272.notes": never;
	"prod.text.dynamic.player.529273.notes": never;
	"prod.text.dynamic.player.529277.notes": never;
	"prod.text.dynamic.player.529278.notes": never;
	"prod.text.dynamic.player.529279.notes": never;
	"prod.text.dynamic.player.529280.notes": never;
	"prod.text.dynamic.player.529281.notes": never;
	"prod.text.dynamic.player.529283.notes": never;
	"prod.text.dynamic.player.529284.notes": never;
	"prod.text.dynamic.player.529285.notes": never;
	"prod.text.dynamic.player.529292.notes": never;
	"prod.text.dynamic.player.529294.notes": never;
	"prod.text.dynamic.player.529295.notes": never;
	"prod.text.dynamic.player.529385.notes": never;
	"prod.text.dynamic.player.529386.notes": never;
	"prod.text.dynamic.player.529902.notes": never;
	"prod.text.dynamic.player.529909.notes": never;
	"prod.text.dynamic.player.529916.notes": never;
	"prod.text.dynamic.player.529942.notes": never;
	"label.national_teams": never;
	"prod.text.dynamic.player.530683.notes": never;
	"prod.text.dynamic.player.530962.notes": never;
	"prod.text.dynamic.player.530963.notes": never;
	"video-tasks.modal.teamsheet.success.mapped": never;
	"gamePage.dataInsights.paginate.range": {
		current: string;
		last: string;
	};
	"prod.text.dynamic.player.532053.notes": never;
	"prod.text.dynamic.player.532220.notes": never;
	"prod.text.dynamic.player.532229.notes": never;
	"prod.text.dynamic.player.532251.notes": never;
	"prod.text.dynamic.club.27911.biography": never;
	"prod.text.dynamic.player.533853.notes": never;
	"prod.text.dynamic.player.533930.notes": never;
	"prod.text.dynamic.player.533939.notes": never;
	"prod.text.dynamic.player.534784.notes": never;
	"prod.text.dynamic.player.534792.notes": never;
	"prod.text.dynamic.player.534799.notes": never;
	"prod.text.dynamic.player.536897.notes": never;
	"prod.text.dynamic.player.536898.notes": never;
	"label.player.last_game": never;
	"product.management.product.quality": never;
	"btn.filter_by_gender": never;
	"form_search_player_game.gender": never;
	"label.player.gender": never;
	"label.subscription.competition": never;
	"table.pagination.page.label": never;
	"product.management.admin.user.duplicates": never;
	"prod.text.dynamic.player.538759.notes": never;
	"prod.text.dynamic.player.538760.notes": never;
	"prod.text.dynamic.player.538761.notes": never;
	"prod.text.dynamic.player.538762.notes": never;
	"prod.text.dynamic.player.538763.notes": never;
	"prod.text.dynamic.player.538764.notes": never;
	"prod.text.dynamic.player.538765.notes": never;
	"prod.text.dynamic.player.538766.notes": never;
	"prod.text.dynamic.player.538767.notes": never;
	"prod.text.dynamic.player.538768.notes": never;
	"prod.text.dynamic.player.538769.notes": never;
	"prod.text.dynamic.player.538770.notes": never;
	"prod.text.dynamic.player.538771.notes": never;
	"prod.text.dynamic.player.538772.notes": never;
	"prod.text.dynamic.player.538773.notes": never;
	"prod.text.dynamic.player.538774.notes": never;
	"prod.text.dynamic.player.538775.notes": never;
	"prod.text.dynamic.player.538776.notes": never;
	"prod.text.dynamic.player.538777.notes": never;
	"prod.text.dynamic.player.538778.notes": never;
	"prod.text.dynamic.player.538779.notes": never;
	"prod.text.dynamic.player.538780.notes": never;
	"prod.text.dynamic.player.538781.notes": never;
	"prod.text.dynamic.player.538782.notes": never;
	"prod.text.dynamic.player.538783.notes": never;
	"prod.text.dynamic.player.538784.notes": never;
	"prod.text.dynamic.player.538785.notes": never;
	"prod.text.dynamic.player.538806.notes": never;
	"prod.text.dynamic.player.538807.notes": never;
	"prod.text.dynamic.player.538808.notes": never;
	"prod.text.dynamic.player.538809.notes": never;
	"prod.text.dynamic.player.538810.notes": never;
	"prod.text.dynamic.player.538811.notes": never;
	"prod.text.dynamic.player.538812.notes": never;
	"prod.text.dynamic.player.538813.notes": never;
	"prod.text.dynamic.player.538814.notes": never;
	"prod.text.dynamic.player.538815.notes": never;
	"prod.text.dynamic.player.538816.notes": never;
	"prod.text.dynamic.player.538817.notes": never;
	"prod.text.dynamic.player.538818.notes": never;
	"prod.text.dynamic.player.538819.notes": never;
	"prod.text.dynamic.player.538820.notes": never;
	"prod.text.dynamic.player.538821.notes": never;
	"prod.text.dynamic.player.538822.notes": never;
	"prod.text.dynamic.player.538823.notes": never;
	"prod.text.dynamic.player.538824.notes": never;
	"prod.text.dynamic.player.538825.notes": never;
	"prod.text.dynamic.player.538826.notes": never;
	"prod.text.dynamic.player.538827.notes": never;
	"prod.text.dynamic.player.538828.notes": never;
	"prod.text.dynamic.player.538829.notes": never;
	"prod.text.dynamic.player.538830.notes": never;
	"prod.text.dynamic.player.538831.notes": never;
	"prod.text.dynamic.player.538832.notes": never;
	"prod.text.dynamic.player.538833.notes": never;
	"prod.text.dynamic.player.538834.notes": never;
	"prod.text.dynamic.player.538835.notes": never;
	"prod.text.dynamic.player.538836.notes": never;
	"resource.die_ligen": never;
	"resource.api_management": never;
	"form_add_club_amateur.label.pipedriveOrganizationId": never;
	"form_add_club_amateur.placeholder.pipedriveOrganizationId": never;
	"player.search.failed": never;
	"prod.text.dynamic.club.28061.biography": never;
	"column.preset.fetch.error": never;
	"column.preset.save.error": never;
	"column.preset.delete.error": never;
	"resource.club_pro_pipedrive_org_id": never;
	"resource.subscription_deal_id": never;
	"label.pipedrive_deal_id": never;
	"prod.text.dynamic.club.28096.biography": never;
	"prod.text.dynamic.club.28128.biography": never;
	"resource.discover_user_enterprise_management": never;
	"tooltip.purchase.national_continent": never;
	"video-tasks.table.status.both_team_not_mapped": never;
	"video-tasks.table.status.home_team_not_mapped": never;
	"video-tasks.table.status.away_team_not_mapped": never;
	"shadowTeams.pageTitle": never;
	"shadowTeams.save": never;
	"shadowTeams.saveSuccess": never;
	"shadowTeams.saveError": never;
	"shadowTeams.exportPdf": never;
	"shadowTeams.addPlayerButton.add": never;
	"shadowTeams.addPlayerButton.addMore": never;
	"shadowTeams.pitch.showLess": {
		count: string;
	};
	"shadowTeams.pitch.showAll": {
		count: string;
	};
	"shadowTeams.addPlayerModal.title": never;
	"shadowTeams.addPlayerModal.tabs.searchAll": never;
	"shadowTeams.addPlayerModal.tabs.myPlayers": never;
	"shadowTeams.addPlayerModal.tabs.addOwn": never;
	"shadowTeams.addPlayerModal.searchAll.searchPlaceholder": never;
	"shadowTeams.addPlayerModal.searchAll.loading": never;
	"shadowTeams.addPlayerModal.searchAll.noPlayersFound": never;
	"shadowTeams.addPlayerModal.searchAll.startTyping": never;
	"shadowTeams.addPlayerModal.myPlayers.searchPlaceholder": never;
	"shadowTeams.addPlayerModal.myPlayers.loading": never;
	"shadowTeams.addPlayerModal.myPlayers.loadingMore": never;
	"shadowTeams.addPlayerModal.myPlayers.noPlayersFound": never;
	"shadowTeams.addPlayerModal.myPlayers.typeAtLeast2Chars": never;
	"shadowTeams.addPlayerModal.myPlayers.noFavoritePlayers": never;
	"shadowTeams.addPlayerModal.addOwn.name": never;
	"shadowTeams.addPlayerModal.addOwn.namePlaceholder": never;
	"shadowTeams.addPlayerModal.addOwn.nameRequired": never;
	"shadowTeams.addPlayerModal.addOwn.nationality": never;
	"shadowTeams.addPlayerModal.addOwn.nationalityPlaceholder": never;
	"shadowTeams.addPlayerModal.addOwn.club": never;
	"shadowTeams.addPlayerModal.addOwn.clubPlaceholder": never;
	"shadowTeams.addPlayerModal.addOwn.age": never;
	"shadowTeams.addPlayerModal.addOwn.agePlaceholder": never;
	"shadowTeams.addPlayerModal.addOwn.cancel": never;
	"shadowTeams.addPlayerModal.addOwn.create": never;
	"shadowTeams.filterPanel.title": never;
	"shadowTeams.filterPanel.hideFilters": never;
	"shadowTeams.filterPanel.showFilters": never;
	"shadowTeams.filterPanel.tabs.info": never;
	"shadowTeams.filterPanel.tabs.playerList": never;
	"shadowTeams.infoTab.formation.label": never;
	"shadowTeams.infoTab.formation.placeholder": never;
	"shadowTeams.infoTab.formation.custom": never;
	"shadowTeams.infoTab.formation.changeConfirmation": never;
	"shadowTeams.infoTab.display.label": never;
	"shadowTeams.infoTab.display.age": never;
	"shadowTeams.infoTab.display.club": never;
	"shadowTeams.infoTab.display.height": never;
	"shadowTeams.infoTab.display.nationality": never;
	"shadowTeams.playerListTab.title": never;
	"shadowTeams.playerListTab.empty": never;
	"prod.text.dynamic.player.545966.notes": never;
	"prod.text.dynamic.club.28221.biography": never;
	"prod.text.dynamic.club.28223.biography": never;
	"resource.operations_management_summary_tab": never;
	"picture.upload.success": never;
	"subheader.my_eyeball.my_shadow_teams": never;
	"shadowTeams.table.name": never;
	"shadowTeams.table.created": never;
	"shadowTeams.table.updated": never;
	"shadowTeams.table.formation": never;
	"shadowTeams.table.players": never;
	"shadowTeams.title": never;
	"shadowTeams.create": never;
	"shadowTeams.empty.noResults": never;
	"shadowTeams.toast.created": never;
	"shadowTeams.modal.create.title": never;
	"shadowTeams.modal.create.name": never;
	"shadowTeams.modal.name.placeholder": never;
	"shadowTeams.modal.create.formation": never;
	"shadowTeams.modal.create.submit": never;
	"shadowTeams.deleteSuccess": never;
	"shadowTeams.deleteTitle": never;
	"shadowTeams.deleteMessage": never;
	"shadowTeams.editTitle": never;
	"shadowTeams.edit.name": never;
	"shadowTeams.edit.namePlaceholder": never;
	"shadowTeams.nameRequired": never;
	"shadowTeams.updateSuccess": never;
	"label.pagination.rows_per_page": never;
	"label.pagination.all": never;
	"prod.text.dynamic.club.27054.biography": never;
	"prod.text.dynamic.club.28339.biography": never;
	"placeholder.dropdown.gender": never;
	"matchSheet.gender": never;
	"prod.text.dynamic.player.553132.notes": never;
	"prod.text.dynamic.club.28366.biography": never;
	"playerProfile.tabs.overview": never;
	"playerProfile.tabs.games": never;
	"playerProfile.tabs.performance": never;
	"prod.text.dynamic.club.28386.biography": never;
	"prod.text.dynamic.player.554183.notes": never;
	"prod.text.dynamic.player.554615.notes": never;
	"prod.text.dynamic.player.554616.notes": never;
	"prod.text.dynamic.player.554617.notes": never;
	"prod.text.dynamic.player.554618.notes": never;
	"prod.text.dynamic.player.554619.notes": never;
	"prod.text.dynamic.player.554620.notes": never;
	"prod.text.dynamic.player.554621.notes": never;
	"prod.text.dynamic.player.554622.notes": never;
	"prod.text.dynamic.player.554623.notes": never;
	"prod.text.dynamic.player.554624.notes": never;
	"prod.text.dynamic.club.28402.biography": never;
	"prod.text.dynamic.club.28403.biography": never;
	"prod.text.dynamic.club.28404.biography": never;
	"playerProfile.seasonalStats.title": never;
	"playerProfile.seasonalStats.selectSeason": never;
	"playerProfile.seasonalStats.last5GamesMinutesPlayed": never;
	"gamePage.dataInsights.pagination.showingResults": {
		totalItems: string;
		startIndex: string;
		endIndex: string;
	};
	"playerProfile.averageRating.title": never;
	"playerProfile.averageRating.placeholder": never;
	"playerProfile.averageRating.noData": never;
	"playerProfile.averageRating.betterThan": {
		percent: string;
	};
	"playerProfile.averageRating.overallRating": never;
	"playerProfile.averageRating.lastMatches": {
		count: string;
	};
	"playerProfile.lastGamesFilter.games.all": never;
	"playerProfile.lastGamesFilter.games.5": never;
	"playerProfile.lastGamesFilter.games.10": never;
	"prod.text.dynamic.player.555672.notes": never;
	"prod.text.dynamic.player.555673.notes": never;
	"prod.text.dynamic.player.555676.notes": never;
	"prod.text.dynamic.player.555677.notes": never;
	"prod.text.dynamic.player.555681.notes": never;
	"prod.text.dynamic.player.555682.notes": never;
	"prod.text.dynamic.player.555683.notes": never;
	"prod.text.dynamic.player.555684.notes": never;
	"prod.text.dynamic.player.555685.notes": never;
	"prod.text.dynamic.player.555686.notes": never;
	"prod.text.dynamic.player.555687.notes": never;
	"prod.text.dynamic.player.555688.notes": never;
	"prod.text.dynamic.player.555689.notes": never;
	"prod.text.dynamic.player.555690.notes": never;
	"prod.text.dynamic.player.555691.notes": never;
	"prod.text.dynamic.player.555692.notes": never;
	"prod.text.dynamic.player.555740.notes": never;
	"prod.text.dynamic.player.555741.notes": never;
	"prod.text.dynamic.player.555742.notes": never;
	"prod.text.dynamic.player.555743.notes": never;
	"prod.text.dynamic.player.555744.notes": never;
	"prod.text.dynamic.player.555745.notes": never;
	"prod.text.dynamic.player.555746.notes": never;
	"prod.text.dynamic.player.555747.notes": never;
	"prod.text.dynamic.player.555748.notes": never;
	"prod.text.dynamic.player.555749.notes": never;
	"prod.text.dynamic.player.555750.notes": never;
	"prod.text.dynamic.player.555752.notes": never;
	"prod.text.dynamic.player.555753.notes": never;
	"prod.text.dynamic.player.555754.notes": never;
	"prod.text.dynamic.player.555821.notes": never;
	"prod.text.dynamic.player.555822.notes": never;
	"playerProfile.performanceRadar.title": never;
	"playerProfile.performanceRadar.positionPlaceholder": never;
	"playerProfile.gameTypeFilter.latest": never;
	"playerProfile.gameTypeFilter.best": never;
	"playerProfile.seasonFilter.all": never;
	"playerProfile.latestGames.title": never;
	"playerProfile.latestGames.viewAllGames": never;
	"playerProfile.clubHistory.title": never;
	"playerProfile.clubHistory.season": never;
	"playerProfile.clubHistory.club": never;
	"playerProfile.clubHistory.ageCategory": never;
	"playerProfile.clubHistory.rating": never;
	"playerProfile.clubHistory.noData": never;
	"prod.text.dynamic.club.28453.biography": never;
	"gamePage.dataInsights.label.limitedDirectionalTooltip": never;
	"gamePage.dataInsights.label.limitedDirectionalDescription": never;
	"prod.text.dynamic.player.556884.notes": never;
	"prod.text.dynamic.player.557078.notes": never;
	"prod.text.dynamic.player.557079.notes": never;
	"prod.text.dynamic.player.557080.notes": never;
	"prod.text.dynamic.player.557081.notes": never;
	"prod.text.dynamic.club.28484.biography": never;
	"form_add_club_amateur.label.contractEndDate": never;
	"prod.text.dynamic.club.28487.biography": never;
	"form_add_club_amateur.label.autoRenewalYears": never;
	"form_add_club_amateur.label.hasNonEbCamera": never;
	"form_add_club_amateur.label.teamsheetAvailability": never;
	"form_add_club_amateur.label.fixtureAvailability": never;
	"form_add_club_amateur.placeholder.autoRenewalYears": never;
	"form_add_club_amateur.label.manager": never;
	"form_add_club_amateur.label.marketing_opt_in.true": never;
	"form_add_club_amateur.label.marketing_opt_in.false": never;
	"form_add_club_amateur.label.marketingOptIn": never;
	"form_add_club_amateur.label.consents.add": never;
	"admin.club.validate.contractEndDate.past_date": never;
	"form_add_club_manager.label.has_non_eb_camera.true": never;
	"form_add_club_manager.label.has_non_eb_camera.false": never;
	"prod.text.dynamic.club.28501.biography": never;
	"breadcrumb.backTo./search": never;
	"playerProfile.noData.title": never;
	"playerProfile.noData.message": never;
	"prod.text.dynamic.club.28521.biography": never;
	"prod.text.dynamic.club.28522.biography": never;
	"prod.text.dynamic.club.28523.biography": never;
	"prod.text.dynamic.player.559872.notes": never;
	"player.profile.notActive": never;
	"player.partner.tooltip": never;
	"player.nationalTeam.badge": never;
	"prod.text.dynamic.player.560638.notes": never;
	"prod.text.dynamic.player.560639.notes": never;
	"prod.text.dynamic.club.28541.biography": never;
	"breadcrumb.backTo./my-eyeball/my-shadow-teams": never;
	"prod.text.dynamic.club.28566.biography": never;
	"playerProfile.filter.all": never;
	"playerProfile.filter.period": never;
	"playerProfile.filter.selectPeriod": never;
	"playerProfile.filter.comparedTo": never;
	"playerProfile.filter.selectPosition": never;
	"playerProfile.performance.comparedToTooltip": never;
	"playerProfile.performance.offensive": never;
	"playerProfile.performance.defensive": never;
	"playerProfile.performance.distribution": never;
	"playerProfile.performance.goalkeeper": never;
	"playerProfile.performance.noData": never;
	"playerProfile.performance.howToReadColors": never;
	"playerProfile.performance.bottom20": never;
	"playerProfile.performance.middle20": never;
	"playerProfile.performance.top20": never;
	"prod.text.dynamic.player.562542.notes": never;
	"playerProfile.filter.gameNational": never;
	"playerProfile.filter.analyzedGames": never;
	"playerProfile.filter.team": never;
	"playerProfile.filter.games": never;
	"seasonSelector.placeholder": never;
	"seasonSelector.selectSeason": never;
	"seasonSelector.orSelectTimePeriod": never;
	"seasonSelector.selectDateRange": never;
	"playerProfile.filter.selectGameNational": never;
	"playerProfile.filter.selectTeam": never;
	"playerProfile.filter.selectGames": never;
	"playerProfile.gameNationalFilter.all": never;
	"playerProfile.gameNationalFilter.national": never;
	"playerProfile.gameNationalFilter.club": never;
	"label.eyeball_addons": never;
	"gamePage.dataInsights.pagination.itemsPerPage": never;
	"message.select_eyeball_addons": never;
	"prod.text.dynamic.club.28677.biography": never;
	"locked.game.modal.title": never;
	"locked.game.modal.text": {
		contact: (text: string) => any;
		b: (text: string) => any;
	};
	"prod.text.dynamic.club.28691.biography": never;
	"prod.text.dynamic.clubNonPartner.28267.description": never;
	"prod.text.dynamic.clubNonPartner.28737.description": never;
	"prod.text.dynamic.clubNonPartner.28733.description": never;
	"prod.text.dynamic.clubNonPartner.28729.description": never;
	"prod.text.dynamic.clubNonPartner.28728.description": never;
	"prod.text.dynamic.clubNonPartner.28730.description": never;
	"prod.text.dynamic.clubNonPartner.28740.description": never;
	"prod.text.dynamic.clubNonPartner.28738.description": never;
	"prod.text.dynamic.clubNonPartner.28747.description": never;
	"prod.text.dynamic.clubNonPartner.28748.description": never;
	"prod.text.dynamic.clubNonPartner.28731.description": never;
	"prod.text.dynamic.clubNonPartner.28746.description": never;
	"prod.text.dynamic.clubNonPartner.28755.description": never;
	"prod.text.dynamic.clubNonPartner.28739.description": never;
	"prod.text.dynamic.clubNonPartner.28749.description": never;
	"prod.text.dynamic.clubNonPartner.28734.description": never;
	"prod.text.dynamic.clubNonPartner.28760.description": never;
	"prod.text.dynamic.player.569774.notes": never;
	"prod.text.dynamic.player.569775.notes": never;
	"prod.text.dynamic.club.28787.biography": never;
	"prod.text.dynamic.player.570482.notes": never;
	"label.datagrid.yes": never;
	"label.datagrid.no": never;
	"label.datagrid.days": never;
	"portal.gender.Male": never;
	"portal.gender.Female": never;
	"portal.gender.Mixed": never;
	"discover.game.field_updated_success": never;
	"discover.game.field_updated_error": never;
	"admin.discover.user_note.user_not_found": {
		id: string;
	};
	"discover.userNote.toast.created": never;
	"discover.userNote.toast.updated": never;
	"discover.userNote.toast.cannotBeEmpty": never;
	"discover.userNote.toast.deleted": never;
	"discover.userNote.updating": never;
	"discover.userNote.submitting": never;
	"discover.userNote.updateNote": never;
	"discover.userNote.submitNote": never;
	"discover.userNote.label": never;
	"discover.userNote.placeholder": never;
	"discover.userNote.character": never;
	"discover.userNote.characters": never;
	"discover.userNote.addNote": never;
	"discover.userNote.deleteConfirm": never;
	"discover.userNote.table.id": never;
	"discover.userNote.table.note": never;
	"discover.userNote.table.createdBy": never;
	"discover.userNote.table.createdAt": never;
	"discover.userNote.edit": never;
	"discover.userNote.delete": never;
	"discover.userNote.editNote": never;
	"discover.userNote.tab": never;
	"prod.text.dynamic.club.28861.biography": never;
	"product.management.eyeball_addons.ai_scout": never;
	"product.management.eyeball_addons.ai_support_pack": never;
	"product.management.eyeball_addons.ai_player_data": never;
	"product.management.eyeball_addons.efg": never;
	"token.not.valid.or.already.used": never;
	"discover.redirect.info.title": {
		b: (text: string) => any;
	};
	"discover.redirect.info.text": {
		link: (text: string) => any;
		b: (text: string) => any;
	};
	"discover.redirect.info.button": never;
	"message.status.update.success": never;
	"admin.duplicate_page.notes_placeholder": never;
	"admin.duplicate_page.btn.mark_as_not_duplicate": never;
	"admin.duplicate_page.status.migrated": never;
	"admin.duplicate_page.status.not_duplicate": never;
	"admin.duplicate_page.status.skipped": never;
	"admin.duplicate_page.status.new": never;
	"admin.duplicate_page.label.merge": never;
	"admin.duplicate_page.label.possible_duplicate_id": never;
	"admin.duplicate_page.label.player_id": never;
	"admin.duplicate_page.message.no_possible_duplicate_found": never;
	"customer_api.subscription.key_creation_failed": never;
	"customer_api.subscription.club_already_has_one": never;
	"admin.duplicate_page.status.merged": never;
	"admin.duplicate_page.label.deleted": never;
	"admin.duplicate_page.filter.all": never;
	"admin.duplicate_page.filter.pending": never;
	"admin.duplicate_page.filter.processed": never;
	"admin.duplicate_page.status.retained": never;
	"message.error.generic": never;
	"admin.summary_tab.label.online": never;
	"admin.summary_tab.label.offline": never;
	"admin.summary_tab.label.active_subscription": never;
	"admin.summary_tab.placeholder.active_subscription": never;
	"admin.duplicate_page.message.possible_duplicate_record_failed": never;
	"customer_api.error.usage_plan_name_not_configured": never;
	"customer_api.error.aws_create_usage_plan_key_no_id": never;
	"customer_api.error.aws_api_key_value_missing": never;
	"customer_api.error.aws_get_usage_plans_no_items": never;
	"customer_api.error.aws_create_api_key_no_id": never;
	"admin.operations_management_summary.filter_manager_empty": never;
	"admin.operations_management_summary.filter_placeholder_clubs": never;
	"admin.operations_management_summary.filter_placeholder_managers": never;
	"resource.log_in_as_user": never;
	"permission.log_in_as_user": never;
	"playerProfile.performanceRadar.tooltip": never;
	"customer_api.error.aws_get_usage_plans_no_matching_plan": never;
	"gamePage.postPlayerGrading.success": never;
	"customer_api.error.subscription_product_must_be_customer_api": never;
	"customer_api.error.subscription_must_have_pro_club": never;
	"ai-player-search.header.title": never;
	"ai-player-search.toggle.label": never;
	"ai-player-search.toggle.on": never;
	"ai-player-search.toggle.off": never;
	"ai-player-search.demo-badge.label": never;
	"playerProfile.tabs.comparison": never;
	"ai-player-search.demo-banner.heading": never;
	"game.stats.table.shotConversion": never;
	"game.stats.table.tacklesRatio": never;
	"ai-player-search.search-box.placeholder": never;
	"ai-player-search.search-box.demo-placeholder": never;
	"ai-player-search.search-box.demo-badge-label": never;
	"ai-player-search.search-box.demo-notice": never;
	"app.player.team.member.role.ROLE_DISCOVER_WORKS_FOR_CLUB": never;
	ROLE_DISCOVER_WORKS_FOR_CLUB: never;
	"game.stats.table.topPercent": {
		percent: string;
	};
	"ai-player-search.demo-banner.body": {
		highlight: (text: string) => any;
	};
	"game.stats.table.noValue": never;
	"ai-player-search.start-page.heading": {
		highlight: (text: string) => any;
	};
	"ai-player-search.start-page.description": never;
	"ai-player-search.start-page.quick-start-section.heading": never;
	"ai-player-search.start-page.quick-start-section.description": never;
	"ai-player-search.start-page.in-depth-section.heading": never;
	"ai-player-search.start-page.in-depth-section.description": never;
	"ai-player-search.start-page.advanced-section.heading": never;
	"ai-player-search.sidebar.heading": never;
	"ai-player-search.sidebar.pinned-section.heading": never;
	"ai-player-search.sidebar.history-section.heading": never;
	"ai-player-search.sidebar.actions.pin": never;
	"ai-player-search.sidebar.actions.delete": never;
	"ai-player-search.no-match-card.not-related.title": never;
	"ai-player-search.no-match-card.not-related.description": never;
	"ai-player-search.no-match-card.subscription-limited.title": never;
	"ai-player-search.no-match-card.subscription-limited.description": {
		region: string;
		br: (text: string) => any;
		b: (text: string) => any;
	};
	"ai-player-search.no-match-card.no-results.title": never;
	"ai-player-search.no-match-card.no-results.description": never;
	"ai-player-search.no-match-card.unavailable.title": never;
	"ai-player-search.no-match-card.unavailable.description": never;
	"ai-player-search.no-match-card.error.title": never;
	"ai-player-search.no-match-card.error.description": never;
	"ai-player-search.no-match-card.timeout.title": never;
	"ai-player-search.no-match-card.timeout.description": never;
	"label.gender": never;
	"reportError.title": never;
	"reportError.successTitle": never;
	"reportError.successDescription": never;
	"reportError.okay": never;
	"reportError.eventDetails": never;
	"reportError.playerDetails": never;
	"reportError.time": never;
	"reportError.duration": never;
	"reportError.durationSeconds": {
		count: string;
	};
	"reportError.type": never;
	"reportError.name": never;
	"reportError.number": never;
	"reportError.club": never;
	"reportError.errorType.label": never;
	"reportError.selectClub": never;
	"reportError.selectCorrectPlayer": never;
	"reportError.selectWrongEvent": never;
	"reportError.correctEvent": never;
	"reportError.resetAll": never;
	"reportError.description": never;
	"reportError.descriptionPlaceholder": never;
	"reportError.cancel": never;
	"reportError.send": never;
	"reportError.sending": never;
	"reportError.choose": never;
	"reportError.noOptionsAvailable": never;
	"reportError.homeTeamFallback": never;
	"reportError.awayTeamFallback": never;
	"reportError.unknownPlayerFallback": never;
	"reportError.noPlayersAvailable": never;
	"reportError.noWrongEventsAvailable": never;
	"reportError.noEventTypesAvailable": never;
	"reportError.selectionStatusSingle": never;
	"reportError.selectionStatusMultiple": {
		count: string;
	};
	"reportError.selectionReport": never;
	"reportError.errorType.wrongPlayer": never;
	"reportError.errorType.wrongEventType": never;
	"reportError.errorType.eventMissing": never;
	"reportError.errorType.duplicatedEvent": never;
	"reportError.errorType.other": never;
	"reportError.eventGroup.offensive": never;
	"reportError.eventGroup.defensive": never;
	"reportError.eventGroup.distribution": never;
	"reportError.eventGroup.goalKeeper": never;
	"reportError.eventType.shot": never;
	"reportError.eventType.takeOn": never;
	"reportError.eventType.goal": never;
	"reportError.eventType.foulWon": never;
	"reportError.eventType.offside": never;
	"reportError.eventType.technicalError": never;
	"reportError.eventType.ownGoal": never;
	"reportError.eventType.foulCommitted": never;
	"reportError.eventType.block": never;
	"reportError.eventType.interception": never;
	"reportError.eventType.looseBallRecovery": never;
	"reportError.eventType.tackle": never;
	"reportError.eventType.clearance": never;
	"reportError.eventType.card": never;
	"reportError.eventType.takeOnAgainst": never;
	"reportError.eventType.aerialDistribution": never;
	"reportError.eventType.pass": never;
	"reportError.eventType.passReceived": never;
	"reportError.eventType.catchInterception": never;
	"reportError.eventType.punch": never;
	"reportError.eventType.concededGoal": never;
	"reportError.eventType.save": never;
	"discover.error.reported_tagging_issue.invalid_game_event": never;
	"myPlayers.grade.sort.ASC": never;
	"myPlayers.grade.sort.DESC": never;
	"myPlayers.grade.filter.low": never;
	"myPlayers.grade.filter.mid": never;
	"myPlayers.grade.filter.high": never;
	"myPlayers.grade.filter.all": never;
	"form_add_club_pro.label.club_administrator": never;
	"form_add_club_pro.label.club_administrator.true": never;
	"form_add_club_pro.label.club_administrator.false": never;
	"game_analysis_physical.validation.player_position": never;
	"game_analysis_physical.validation.not_exists": never;
	"game_analysis_physical.validation.rejected": never;
	"game_analysis_physical.validation.already_analysed": never;
	"game_analysis_physical.validation.home_team_starts_unspecified": never;
	"myPlayers.table.showing_range": {
		total: string;
		start: string;
		end: string;
	};
	"gamePage.putPlayerGrading.success": never;
	"gamePage.deletePlayerGrading.success": never;
	"gamePage.playerGrading.title": never;
	"gamePage.playerGrading.performanceGrade": never;
	"gamePage.playerGrading.potentialGrade": never;
	"gamePage.playerGrading.noteLabel": never;
	"gamePage.playerGrading.noteHelper": never;
	"gamePage.playerGrading.notePlaceholder": never;
	"gamePage.playerGrading.footerHint": never;
	"gamePage.playerGrading.cancel": never;
	"gamePage.playerGrading.save": never;
	"gamePage.playerGrading.removeGrade": never;
	"gamePage.playerGrading.deleteConfirmTitle": never;
	"gamePage.playerGrading.deleteConfirmBody": never;
	"gamePage.playerGrading.deleteConfirmCancel": never;
	"gamePage.playerGrading.deleteConfirmRemove": never;
	"gamePage.playerGrading.triggerAria": never;
	"gamePage.playerGrading.triggerAriaGraded": never;
	"gamePage.playerGrading.performanceGradeRequired": never;
	"gamePage.playerGrading.updateGradeError": never;
	"gamePage.playerGrading.fieldOptional": never;
	"myPlayers.topFilters.showFiltersPanel": never;
	"myPlayers.topFilters.placeholderAll": never;
	"myPlayers.topFilters.gradingGradedNoted": never;
	"myPlayers.topFilters.gradingUngraded": never;
	"myPlayers.labels.contributors": never;
	"myPlayers.labels.grading": never;
	"myPlayers.labels.performanceGrade": never;
	"myPlayers.labels.potentialGrade": never;
	"myPlayers.labels.sort": never;
	"myPlayers.table.pinPlayerFailed": never;
	"myPlayers.table.unpinPlayerFailed": never;
	"myPlayers.columns.performanceGrade": never;
	"myPlayers.columns.potentialGrade": never;
	"myPlayers.columns.lastFiveGradesSubtitle": never;
	"myPlayers.columns.gradeAndNotes": never;
	"myPlayers.columns.lastGraded": never;
	"myPlayers.notesModal.dialogAriaLabel": never;
	"myPlayers.notesModal.loadError": never;
	"myPlayers.notesModal.eyeballRating": never;
	"myPlayers.notesModal.performanceGrading": never;
	"myPlayers.notesModal.sectionHeading": never;
	"myPlayers.notesModal.empty": never;
	"myPlayers.noteCard.gameLabel": never;
	"myPlayers.noteCard.performanceGradeLabel": never;
	"myPlayers.noteCard.potentialGradeLabel": never;
	"myPlayers.gradeCell.notGraded": never;
	"myPlayers.gradeCell.average": never;
	"myPlayers.tickboxMultiSelect.selectedCount": {
		count: string;
	};
	"discover.gamesTable.column.id": never;
	"discover.gamesTable.column.date": never;
	"discover.gamesTable.column.country": never;
	"discover.gamesTable.column.home": never;
	"discover.gamesTable.column.away": never;
	"discover.gamesTable.column.ageCategory": never;
	"discover.gamesTable.column.score": never;
	"discover.gamesTable.column.teamRoster": never;
	"discover.gamesTable.column.hasVideo": never;
	"discover.gamesTable.column.analysisProvider": never;
	"discover.gamesTable.column.gameAnalysisStatus": never;
	"discover.gamesTable.column.vip": never;
	"discover.gamesTable.column.hidden": never;
	"discover.gamesTable.column.hiddenForScout": never;
	"discover.gamesTable.column.isDiscover": never;
	"discover.gamesTable.column.processingLevel": never;
	"discover.gamesTable.column.analysisRequestedAt": never;
	"discover.gamesTable.group.basic": never;
	"discover.gamesTable.group.teams": never;
	"discover.gamesTable.group.media": never;
	"discover.gamesTable.group.analysis": never;
	"discover.gamesTable.group.status": never;
	"discover.gamesTable.filter.id": never;
	"discover.gamesTable.filter.ageCategory": never;
	"discover.gamesTable.filter.homeClub": never;
	"discover.gamesTable.filter.homeTeam": never;
	"discover.gamesTable.filter.awayClub": never;
	"discover.gamesTable.filter.awayTeam": never;
	"discover.gamesTable.filter.hasVideo": never;
	"discover.gamesTable.filter.isDiscover": never;
	"discover.gamesTable.filter.isVip": never;
	"discover.gamesTable.filter.isHidden": never;
	"discover.gamesTable.filter.isHiddenForScout": never;
	"discover.gamesTable.filter.providerTag": never;
	"discover.gamesTable.filter.gameAnalysisStatus": never;
	"discover.gamesTable.filter.owner": never;
	"discover.gamesTable.filter.country": never;
	"discover.gamesTable.filter.requestedProcessingLevel": never;
	"discover.gamesTable.filter.date": never;
	"discover.gamesTable.filter.analysisRequestedAt": never;
	"discover.gamesTable.filterPlaceholder.id": never;
	"discover.gamesTable.filterPlaceholder.ageCategory": never;
	"discover.gamesTable.filterPlaceholder.homeClub": never;
	"discover.gamesTable.filterPlaceholder.homeTeam": never;
	"discover.gamesTable.filterPlaceholder.awayClub": never;
	"discover.gamesTable.filterPlaceholder.awayTeam": never;
	"discover.gamesTable.filterPlaceholder.providerTag": never;
	"discover.gamesTable.filterPlaceholder.gameAnalysisStatus": never;
	"discover.gamesTable.filterPlaceholder.owner": never;
	"discover.gamesTable.filterPlaceholder.country": never;
	"discover.gamesTable.filterPlaceholder.requestedProcessingLevel": never;
	"discover.gamesTable.isDiscoverFilter.discover": never;
	"discover.gamesTable.isDiscoverFilter.elite": never;
	"discover.gamesTable.providerTag.option.any": never;
	"discover.gamesTable.providerTag.option.none": never;
	"discover.gamesTable.processingLevel.full": never;
	"discover.gamesTable.processingLevel.limited": never;
	"discover.gamesTable.cellValue.none": never;
	"discover.gamesTable.cellValue.discover": never;
	"discover.gamesTable.cellValue.elite": never;
	"discover.gamesTable.aria.bulkSelectRow": never;
	"discover.gamesTable.aria.bulkSelectAll": never;
	"label.user.maleStatus": never;
	"label.user.femaleStatus": never;
	"videos.table.th.gender": never;
	"game.stats.table.gender": never;
	"label.maleEnable": never;
	"label.femaleEnable": never;
	"myPlayers.topFilters.hideFiltersPanel": never;
	"discover.gamesTable.column.clubManager": never;
	"discover.gamesTable.column.contentManager": never;
	"discover.gamesTable.column.assignee": never;
	"discover.gamesTable.filterPlaceholder.contentManager": never;
	"gamePage.playerGrading.lastTimeGraded": never;
	"ai-player-search.loading-page.searching": never;
	"ai-player-search.loading-page.generating": never;
	"permission.game_create_game": never;
	"permission.game_assignee_selection": never;
	"permission.game_view_sla": never;
	"permission.game_status_edit": never;
	"tooltip.purchase.gender": never;
	"discover.gamesTable.column.gameStatus": never;
	"discover.gamesTable.filter.gameStatus": never;
	"discover.gamesTable.filterPlaceholder.gameStatus": never;
	"discover.gamesTable.column.histories": never;
	"discover.gamesTable.bulkUpdate.title": never;
	"discover.gamesTable.bulkUpdate.closeAria": never;
	"discover.gamesTable.bulkUpdate.selectedCount": {
		count: string;
	};
	"discover.gamesTable.bulkUpdate.hint": never;
	"discover.gamesTable.bulkUpdate.cancel": never;
	"discover.gamesTable.bulkUpdate.apply": never;
	"discover.gamesTable.bulkUpdate.applying": never;
	"discover.gamesTable.bulkUpdate.button": never;
	"discover.gamesTable.bulkUpdate.openTitle": never;
	"discover.gamesTable.bulkUpdate.allFailed": never;
	"gamePage.playerGrading.gradedByScoutsSingular": never;
	"gamePage.playerGrading.gradedByScoutsPlural": {
		count: string;
	};
	"gamePage.playerGrading.teamSheetButtonTooltipGraded": never;
	"gamePage.playerGrading.teamSheetButtonTooltipUngraded": never;
	"myPlayers.notesModal.potentialGrading": never;
	"myPlayers.columns.gradesHeaderTooltip": never;
	"discover.userDetail.tab.permissions": never;
	"discover.userDetail.tab.securityCodes": never;
	"discover.userDetail.tab.guardianApprovals": never;
	"discover.gamesTable.column.owners": never;
	"discover.gamesTable.column.physicalMetricsRequested": never;
	"discover.gamesTable.column.analysisTurnaround": never;
	"discover.gamesTable.bulkUpdate.selectRowsFirstHint": never;
	"discover.gamesTable.bulkUpdate.fieldCountHint": {
		total: string;
		count: string;
	};
	"discover.gamesTable.bulkUpdate.noneEligible": never;
	"discover.gamesTable.bulkUpdate.checkingEligibility": never;
	"discover.gamesTable.bulkUpdate.skipSummary": {
		skip: string;
		apply: string;
	};
	"discover.gamesTable.bulkUpdate.skipConfirm": {
		skip: string;
		apply: string;
	};
	"discover.gamesTable.bulkUpdate.noneEligibleToast": never;
	"discover.gamesTable.bulkUpdate.partialSkipped": {
		total: string;
		updated: string;
		skipped: string;
		fields: string;
	};
	"ai-player-search.example-searches.title": never;
	"ai-player-search.example-searches.try": never;
	"ai-player-search.feedback.title": never;
	"ai-player-search.feedback.like": never;
	"ai-player-search.feedback.dislike": never;
	"discover.gamesTable.column.priority": never;
	"discover.gamesTable.filter.priority": never;
	"discover.gamesTable.filterPlaceholder.priority": never;
	"discover.gamesTable.column.analysisSla": never;
	"discover.gamesTable.cellValue.analysisSla.pending": never;
	"ai-player-search.reasoning.interpretation": never;
	"ai-player-search.reasoning.reasoning": never;
	"ai-player-search.reasoning.title": never;
	"discover.gamesTable.programGame.button": never;
	"discover.gamesTable.programGame.noPermissionHint": never;
	"discover.gamesTable.programGame.modalTitle": never;
	"discover.gamesTable.programGame.closeAria": never;
	"discover.gamesTable.programGame.placeholder.unfilled": never;
	"discover.gamesTable.programGame.placeholder.priority": never;
	"discover.gamesTable.programGame.field.homeClub": never;
	"discover.gamesTable.programGame.field.awayClub": never;
	"discover.gamesTable.programGame.field.type": never;
	"discover.gamesTable.programGame.field.date": never;
	"discover.gamesTable.programGame.field.kickOff": never;
	"discover.gamesTable.programGame.field.isNational": never;
	"discover.gamesTable.programGame.field.ownership": never;
	"discover.gamesTable.programGame.field.teamsheetLinks": never;
	"discover.gamesTable.programGame.field.videoLinks": never;
	"discover.gamesTable.programGame.field.priority": never;
	"discover.gamesTable.programGame.action.addTeamsheetLink": never;
	"discover.gamesTable.programGame.action.addVideoLink": never;
	"discover.gamesTable.programGame.button.cancel": never;
	"discover.gamesTable.programGame.button.enter": never;
	"discover.gamesTable.programGame.boolean.true": never;
	"discover.gamesTable.programGame.boolean.false": never;
	"discover.gamesTable.programGame.error.homeClubRequired": never;
	"discover.gamesTable.programGame.error.awayClubRequired": never;
	"discover.gamesTable.programGame.error.typeRequired": never;
	"discover.gamesTable.programGame.error.dateRequired": never;
	"discover.gamesTable.programGame.error.kickOffRequired": never;
	"discover.gamesTable.programGame.error.isNationalRequired": never;
	"discover.gamesTable.programGame.error.ownershipRequired": never;
	"discover.gamesTable.programGame.error.priorityRequired": never;
	"ai-player-search.search-box.submit-button.label": never;
	"ai-player-search.search-box.edit-note": never;
	"ai-player-search.result-page.subscription-warning": {
		b: (text: string) => any;
	};
	"message.select_gender_options": never;
	"discover.gamesTable.column.slaContent": never;
	"discover.gamesTable.column.slaExpansion": never;
	"discover.gamesTable.column.numberOfContentErrors": never;
	"discover.gamesTable.column.numberOfTaggingErrors": never;
	"discover.gamesTable.filterPlaceholder.assignee": never;
	"discover.gameDetail.toast.updated": never;
	"discover.gameDetail.toast.updateFailed": never;
	"discover.gameDetail.tab.basicData": never;
	"discover.gameDetail.tab.activity": never;
	"discover.gameDetail.tab.video": never;
	"discover.gameDetail.tab.gameAnalysis": never;
	"discover.gameDetail.tab.links": never;
	"discover.gameDetail.tab.teamsheetInfo": never;
	"discover.gameDetail.field.date": never;
	"discover.gameDetail.field.score": never;
	"discover.gameDetail.field.type": never;
	"discover.gameDetail.field.gamePage": never;
	"discover.gameDetail.field.description": never;
	"discover.gameDetail.field.league": never;
	"discover.gameDetail.field.ageCategory": never;
	"discover.gameDetail.field.isDiscover": never;
	"discover.gameDetail.field.isVip": never;
	"discover.gameDetail.field.isHidden": never;
	"discover.gameDetail.field.isHiddenForScout": never;
	"discover.gameDetail.field.startsOnLeft": never;
	"discover.gameDetail.field.homeTeam": never;
	"discover.gameDetail.field.awayTeam": never;
	"discover.gameDetail.field.notSet": never;
	"discover.gameDetail.field.isFrozen": never;
	"discover.gameDetail.field.owners": never;
	"discover.gameDetail.field.contentSla": never;
	"discover.gameDetail.field.expansionSla": never;
	"discover.gameDetail.field.numContentErrors": never;
	"discover.gameDetail.field.numTaggingErrors": never;
	"discover.gameDetail.field.analysisTurnaround": never;
	"discover.gameDetail.field.sla": never;
	"discover.gameDetail.header.countryManager": never;
	"discover.gameDetail.header.contentManager": never;
	"discover.gameDetail.header.assignee": never;
	"discover.gameDetail.header.status": never;
	"discover.gameDetail.header.priority": never;
	"discover.gameDetail.placeholder.none": never;
	"discover.gameDetail.history.noNotes": never;
	"discover.gameDetail.history.title": never;
	"discover.gameDetail.history.subTab.internalNotes": never;
	"discover.gameDetail.history.subTab.logs": never;
	"discover.gameDetail.history.placeholder": never;
	"discover.gameDetail.history.loading": never;
	"discover.gameDetail.history.save": never;
	"discover.gameDetail.history.cancel": never;
	"discover.gameDetail.history.unknownUser": never;
	"discover.gameDetail.history.noteAdded": never;
	"discover.gameDetail.history.noteAddFailed": never;
	"discover.gameDetail.history.noteUpdated": never;
	"discover.gameDetail.history.noteUpdateFailed": never;
	"discover.gameDetail.history.noteDeleted": never;
	"discover.gameDetail.history.noteDeleteFailed": never;
	"discover.gameDetail.history.confirmDelete": never;
	"discover.gameDetail.history.loadingOlder": never;
	"label.tooltip_message_male": never;
	"label.tooltip_message_female": never;
	"discover.gamesTable.programGame.error.homeTeamRequired": never;
	"discover.gamesTable.programGame.error.awayTeamRequired": never;
	"discover.gamesTable.programGame.field.homeTeam": never;
	"discover.gamesTable.programGame.field.awayTeam": never;
	"discover.gameDetail.history.subTab.all": never;
	"discover.gameDetail.history.noLogs": never;
	"discover.gameDetail.history.log.changedStatus": never;
	"discover.gameDetail.history.log.changedPriority": never;
	"discover.gameDetail.history.log.changedUserField": {
		field: string;
	};
	"discover.gameDetail.history.log.to": never;
	"discover.gameDetail.history.log.unassigned": never;
	"discover.gameDetail.history.log.field.clubManagerId": never;
	"discover.gameDetail.history.log.field.contentManagerId": never;
	"discover.gameDetail.history.log.field.assigneeId": never;
	"discover.gameDetail.field.mp4AvailableAt": never;
	"discover.gameDetail.field.streamAvailableAt": never;
	"discover.gameDetail.field.providerTag": never;
	"discover.gameDetail.field.isAnalysisFinished": never;
	"discover.gameDetail.field.homeGameClubName": never;
	"discover.gameDetail.field.homeGameTeamName": never;
	"discover.gameDetail.field.homeClub": never;
	"discover.gameDetail.field.homeTeamLink": never;
	"discover.gameDetail.field.homeShirtColor": never;
	"discover.gameDetail.field.homeShortColor": never;
	"discover.gameDetail.field.awayGameClubName": never;
	"discover.gameDetail.field.awayGameTeamName": never;
	"discover.gameDetail.field.awayClub": never;
	"discover.gameDetail.field.awayTeamLink": never;
	"discover.gameDetail.field.awayShirtColor": never;
	"discover.gameDetail.field.awayShortColor": never;
	"discover.gamesTable.permission.cannotEditAssignee": never;
	"discover.gamesTable.permission.cannotEditGameStatus": never;
	"discover.gamesTable.permission.cannotEditPriority": never;
	"discover.gamesTable.permission.cannotEditGameUploads": never;
	"discover.gameDetail.breadcrumb.games": never;
	"discover.gamesTable.programGame.placeholder.hh": never;
	"discover.gamesTable.programGame.placeholder.mm": never;
	"countries.in.ad": never;
	"countries.in.al": never;
	"countries.in.at": never;
	"countries.in.ax": never;
	"countries.in.ba": never;
	"countries.in.be": never;
	"countries.in.bg": never;
	"countries.in.by": never;
	"countries.in.ch": never;
	"countries.in.cz": never;
	"countries.in.de": never;
	"countries.in.dk": never;
	"countries.in.ee": never;
	"countries.in.es": never;
	"countries.in.fo": never;
	"countries.in.fi": never;
	"countries.in.fr": never;
	"countries.in.gb": never;
	"countries.in.gg": never;
	"countries.in.gi": never;
	"countries.in.gr": never;
	"countries.in.hr": never;
	"countries.in.hu": never;
	"countries.in.ie": never;
	"countries.in.im": never;
	"countries.in.is": never;
	"countries.in.it": never;
	"countries.in.je": never;
	"countries.in.li": never;
	"countries.in.lt": never;
	"countries.in.lu": never;
	"countries.in.lv": never;
	"countries.in.mc": never;
	"countries.in.md": never;
	"countries.in.me": never;
	"countries.in.mk": never;
	"countries.in.mt": never;
	"countries.in.nl": never;
	"countries.in.no": never;
	"countries.in.pl": never;
	"countries.in.pt": never;
	"countries.in.ro": never;
	"countries.in.rs": never;
	"countries.in.ru": never;
	"countries.in.se": never;
	"countries.in.si": never;
	"countries.in.sj": never;
	"countries.in.sk": never;
	"countries.in.sm": never;
	"countries.in.tr": never;
	"countries.in.ua": never;
	"countries.in.va": never;
	"countries.in.ao": never;
	"countries.in.bf": never;
	"countries.in.bi": never;
	"countries.in.bj": never;
	"countries.in.bw": never;
	"countries.in.cd": never;
	"countries.in.cf": never;
	"countries.in.cg": never;
	"countries.in.ci": never;
	"countries.in.cm": never;
	"countries.in.cv": never;
	"countries.in.dj": never;
	"countries.in.dz": never;
	"countries.in.eg": never;
	"countries.in.eh": never;
	"countries.in.er": never;
	"countries.in.et": never;
	"countries.in.ga": never;
	"countries.in.gh": never;
	"countries.in.gm": never;
	"countries.in.gn": never;
	"countries.in.gq": never;
	"countries.in.gw": never;
	"countries.in.ke": never;
	"countries.in.km": never;
	"countries.in.lr": never;
	"countries.in.ls": never;
	"countries.in.ly": never;
	"countries.in.ma": never;
	"countries.in.mg": never;
	"countries.in.ml": never;
	"countries.in.mr": never;
	"countries.in.mu": never;
	"countries.in.mw": never;
	"countries.in.mz": never;
	"countries.in.na": never;
	"countries.in.ne": never;
	"countries.in.ng": never;
	"countries.in.re": never;
	"countries.in.rw": never;
	"countries.in.sc": never;
	"countries.in.sd": never;
	"countries.in.sh": never;
	"countries.in.sl": never;
	"countries.in.sn": never;
	"countries.in.so": never;
	"countries.in.st": never;
	"countries.in.sz": never;
	"countries.in.td": never;
	"countries.in.tg": never;
	"countries.in.tn": never;
	"countries.in.tz": never;
	"countries.in.ug": never;
	"countries.in.yt": never;
	"countries.in.za": never;
	"countries.in.zm": never;
	"countries.in.zw": never;
	"countries.in.ar": never;
	"countries.in.bo": never;
	"countries.in.br": never;
	"countries.in.cl": never;
	"countries.in.co": never;
	"countries.in.ec": never;
	"countries.in.fk": never;
	"countries.in.gf": never;
	"countries.in.gy": never;
	"countries.in.pe": never;
	"countries.in.py": never;
	"countries.in.sr": never;
	"countries.in.uy": never;
	"countries.in.ve": never;
	"countries.in.ag": never;
	"countries.in.ai": never;
	"countries.in.aw": never;
	"countries.in.bb": never;
	"countries.in.bl": never;
	"countries.in.bm": never;
	"countries.in.bs": never;
	"countries.in.bz": never;
	"countries.in.ca": never;
	"countries.in.cr": never;
	"countries.in.cu": {
		"20Cuba-": em;
	};
	"countries.in.dm": never;
	"countries.in.do": never;
	"countries.in.gd": never;
	"countries.in.gl": never;
	"countries.in.gp": never;
	"countries.in.gt": never;
	"countries.in.hn": never;
	"countries.in.ht": never;
	"countries.in.jm": never;
	"countries.in.kn": never;
	"countries.in.ky": never;
	"countries.in.lc": never;
	"countries.in.mf": never;
	"countries.in.mq": never;
	"countries.in.ms": never;
	"countries.in.mx": never;
	"countries.in.ni": never;
	"countries.in.pa": never;
	"countries.in.pm": never;
	"countries.in.pr": never;
	"countries.in.sv": never;
	"countries.in.tc": never;
	"countries.in.tt": never;
	"countries.in.us": never;
	"countries.in.vc": never;
	"countries.in.vg": never;
	"countries.in.vi": never;
	"countries.in.ae": never;
	"countries.in.af": never;
	"countries.in.am": never;
	"countries.in.az": never;
	"countries.in.bd": never;
	"countries.in.bh": never;
	"countries.in.bn": never;
	"countries.in.bt": never;
	"countries.in.cc": never;
	"countries.in.cn": never;
	"countries.in.cx": never;
	"countries.in.cy": never;
	"countries.in.ge": never;
	"countries.in.hk": never;
	"countries.in.id": never;
	"countries.in.il": never;
	"countries.in.in": never;
	"countries.in.io": never;
	"countries.in.iq": never;
	"countries.in.ir": never;
	"countries.in.jo": never;
	"countries.in.jp": never;
	"countries.in.kg": never;
	"countries.in.kh": never;
	"countries.in.kp": never;
	"countries.in.kr": never;
	"countries.in.kw": never;
	"countries.in.kz": never;
	"countries.in.lk": never;
	"countries.in.mm": never;
	"countries.in.mn": never;
	"countries.in.mo": never;
	"countries.in.mv": never;
	"countries.in.my": never;
	"countries.in.np": never;
	"countries.in.om": never;
	"countries.in.ph": never;
	"countries.in.pk": never;
	"countries.in.ps": never;
	"countries.in.qa": never;
	"countries.in.sa": never;
	"countries.in.sg": never;
	"countries.in.sy": never;
	"countries.in.th": never;
	"countries.in.tl": never;
	"countries.in.tm": never;
	"countries.in.tw": never;
	"countries.in.uz": never;
	"countries.in.vn": never;
	"countries.in.ye": never;
	"countries.in.as": never;
	"countries.in.au": never;
	"countries.in.ck": never;
	"countries.in.fj": never;
	"countries.in.fm": never;
	"countries.in.gu": never;
	"countries.in.ki": never;
	"countries.in.mh": never;
	"countries.in.mp": never;
	"countries.in.nc": never;
	"countries.in.nf": never;
	"countries.in.nr": never;
	"countries.in.nu": never;
	"countries.in.nz": never;
	"countries.in.pf": never;
	"countries.in.pg": never;
	"countries.in.pn": never;
	"countries.in.pw": never;
	"countries.in.sb": never;
	"countries.in.tk": never;
	"countries.in.to": never;
	"countries.in.tv": never;
	"countries.in.um": never;
	"countries.in.vu": never;
	"countries.in.wf": never;
	"countries.in.ws": never;
	"countries.in.aq": never;
	"countries.in.bq": never;
	"countries.in.bv": never;
	"countries.in.cw": never;
	"countries.in.tf": never;
	"countries.in.hm": never;
	"countries.in.la": never;
	"countries.in.lb": never;
	"countries.in.sx": never;
	"countries.in.gs": never;
	"countries.in.ss": never;
	"countries.in.tj": never;
	"ai.prompt_cards.top.highest_rated": never;
	"ai.prompt_cards.top.top_5": never;
	"playerProfile.lastGamesFilter.games.1": never;
	"ai-player-search.feedback.success": never;
	"ai-player-search.feedback.error": never;
	"ai-player-search.prompt-card.label": never;
	"ai-player-search.logo.alt": never;
	"ai-player-search.start-page.coming-soon": never;
	"ai-player-search.start-page.go-back": never;
	"ai-player-search.sidebar.actions.unpin": never;
	"ai-player-search.sidebar.actions.ellipsis": never;
	"ai-player-search.sidebar.actions.delete-success": never;
	"ai-player-search.sidebar.actions.delete-error": never;
	"ai-player-search.sidebar.new-search": never;
	"ai-player-search.sidebar.open": never;
	"ai-player-search.sidebar.close": never;
	"discover.validation.base64.decode.error": never;
	"discover.game_history.note.only_internal_editable": never;
	"discover.game_history.note.only_own_editable": never;
	"discover.games.bulk.no_field_applied": never;
	"discover.gamesTable.programGame.error.singleOwnerForNonAdmin": never;
	"discover.gamesTable.programGame.error.invalidClubs": never;
	"discover.gamesTable.programGame.error.invalidHomeTeamForClub": never;
	"discover.gamesTable.programGame.error.invalidAwayTeamForClub": never;
	"discover.gamesTable.programGame.error.invalidMatchType": never;
	"discover.gameDetail.history.log.emptyValue": never;
	"discover.gamesTable.programGame.error.differentClubs": never;
	"discover.gamesTable.columnVisibility.title": never;
	"discover.gamesTable.columnVisibility.label": never;
	"ai-player-search.start-page.error-heading": never;
	"ai-player-search.start-page.error-description": never;
	"ai-player-search.start-page.error-retry-button": never;
	"ai-player-search.result-page.examples.header": never;
	"discover.gameDetail.field.blank": never;
	"discover.game_history.note.invalid_file_ids": never;
	"discover.game.link.required": never;
	"discover.gamesTable.programGame.error.invalidGameOwners": never;
	"discover.gamesTable.filterPlaceholder.clubTeamSearch": never;
	"ai-player-search.loading-page.regenerating.heading": never;
	"ai-player-search.loading-page.regenerating.description": never;
	"label.clips_across_games": never;
	"label.physical_metrics": never;
	"ai-player-search.result-table.add-metrics.button": never;
	"ai-player-search.time-ago.now": never;
	"ai-player-search.time-ago.minutes": {
		count: number;
	};
	"ai-player-search.time-ago.hours": {
		count: number;
	};
	"ai-player-search.time-ago.days": {
		count: number;
	};
	"ai-player-search.time-ago.weeks": {
		count: number;
	};
	"ai-player-search.time-ago.months": {
		count: number;
	};
	"ai-player-search.time-ago.years": {
		count: number;
	};
	"playerProfile.tabs.events": never;
	"ai-player-search.sidebar.no-results.label": never;
	"ai-player-search.sidebar.error.label": never;
	"ai-player-search.sidebar.error.retry": never;
	"game.stats.table.veoLink": never;
	"countries.in.xe": never;
	"countries.in.xi": never;
	"countries.in.xs": never;
	"countries.in.xw": never;
	"countries.in.xk": never;
	"countries.in.xn": never;
	"ai-player-search.no-match-card.gender-limited.title": never;
	"ai-player-search.no-match-card.gender-limited.description": never;
	"gamePage.physicalMetrics.rejectedReason": never;
	"playerProfile.filter.resetFilters": never;
	"playerProfile.filter.ageGroup": never;
	"playerProfile.filter.selectAgeGroup": never;
	"playerProfile.filter.club": never;
	"playerProfile.filter.selectClub": never;
	"playerProfile.filter.position": never;
	"ai-player-search.column-preset.ai-suggested": never;
	"playerProfile.events.list.title": never;
	"playerProfile.events.list.subtitle": never;
	"playerProfile.events.list.keyEventsTitle": never;
	"playerProfile.events.list.keyEventsInfoAria": never;
	"playerProfile.events.list.loading": never;
	"playerProfile.events.list.empty": never;
	"playerProfile.events.list.selectAll": never;
	"playerProfile.events.list.outcome": never;
	"playerProfile.events.list.outcomeAll": never;
	"playerProfile.events.list.outcomeSuccessful": never;
	"playerProfile.events.list.outcomeUnsuccessful": never;
	"playerProfile.events.listItem.playing": never;
	"playerProfile.events.listItem.selectEventAria": never;
	"playerProfile.events.listItem.successfulAria": never;
	"playerProfile.events.listItem.unsuccessfulAria": never;
	"playerProfile.events.details.title": never;
	"playerProfile.events.details.autoPlay": never;
	"playerProfile.events.details.autoPlayAria": never;
	"playerProfile.events.details.previousEvent": never;
	"playerProfile.events.details.nextEvent": never;
	"playerProfile.events.detailsInfo.game": never;
	"playerProfile.events.detailsInfo.date": never;
	"playerProfile.events.detailsInfo.ageCategory": never;
	"playerProfile.events.detailsInfo.league": never;
	"playerProfile.events.detailsInfo.jerseyNumber": never;
	"playerProfile.events.detailsInfo.eventType": never;
	"playerProfile.events.detailsInfo.outcome": never;
	"playerProfile.events.detailsInfo.successful": never;
	"playerProfile.events.detailsInfo.unsuccessful": never;
	"playerProfile.events.detailsInfo.position": never;
	"playerProfile.events.detailsInfo.minute": never;
	"playerProfile.events.detailsInfo.bodyPart": never;
	"playerProfile.events.player.empty": never;
	"playerProfile.events.player.seekBackward": never;
	"playerProfile.events.player.seekForward": never;
	"playerProfile.events.clipDuration.label": never;
	"playerProfile.events.clipDuration.aria": never;
	"playerProfile.events.clipModal.title": never;
	"playerProfile.events.clipModal.saveAsClip": never;
	"playerProfile.events.clipModal.closeAria": never;
	"playerProfile.events.clipModal.nameLabel": never;
	"playerProfile.events.clipModal.namePlaceholder": never;
	"playerProfile.events.clipModal.nameRequired": never;
	"playerProfile.events.clipModal.descriptionLabel": never;
	"playerProfile.events.clipModal.descriptionPlaceholder": never;
	"playerProfile.events.clipModal.createAndSave": never;
	"playerProfile.events.selectionBar.countOne": never;
	"playerProfile.events.selectionBar.count": {
		count: string;
	};
	"playerProfile.events.selectionBar.clear": never;
	"playerProfile.events.sidebar.title": never;
	"playerProfile.events.sidebar.collapseAria": never;
	"playerProfile.events.sidebar.searchPlaceholder": never;
	"playerProfile.events.sidebar.empty": never;
	"playerProfile.events.filters.keyEvents": never;
	"playerProfile.events.filters.keyEventsAria": never;
	"playerProfile.events.filters.keyEventsInfoAria": never;
	"playerProfile.events.container.showSidebar": never;
	"playerProfile.events.container.showSidebarAria": never;
	"playerProfile.events.header.keyEventsBtn": never;
	"playerProfile.shadowTeams.header.button": never;
	"playerProfile.shadowTeams.modal.title": never;
	"playerProfile.shadowTeams.modal.description": never;
	"playerProfile.shadowTeams.modal.searchPlaceholder": never;
	"playerProfile.shadowTeams.modal.loading": never;
	"playerProfile.shadowTeams.modal.emptySearch": never;
	"playerProfile.shadowTeams.modal.empty": never;
	"playerProfile.shadowTeams.modal.createBtn": never;
	"playerProfile.shadowTeams.modal.toastUpdated": never;
	"playerProfile.shadowTeams.modal.back": never;
	"playerProfile.shadowTeams.modal.create": never;
	"playerProfile.shadowTeams.modal.selectPlaceholder": never;
	"playerProfile.shadowTeams.modal.playersCount": {
		count: string;
	};
	"playerProfile.shadowTeams.modal.formationLabel": never;
	"gamePage.physicalMetrics.errorLoadingData": never;
	"header.club_pro.search_team": never;
	"country.selection.scope.discover": never;
	"country.selection.scope.elite": never;
	"ai.key_performers.title": never;
	"ai.game-summary.title": never;
	"ai.game-summary.title-generating": never;
	"ai.game-summary.error.message": never;
	"ai.game-summary.badge.powered-by": never;
	"ai.game-summary.badge.generated-at": never;
	"ai.game-summary.read-more": never;
	"portal.ai-game-summary.subscription.message": {
		b: (text: string) => any;
		br: (text: string) => any;
	};
	"discover.gamesTable.programGame.field.nationalLeague": never;
	"form_add_club_amateur.label.contentManager": never;
	"discover.gamesTable.filterPlaceholder.countryManager": never;
	"ai.feedback-popover.close": never;
	"ai.feedback.like": never;
	"ai.feedback.dislike": never;
	"ai.feedback.title": never;
	"ai-player-search.search-box.result-note": never;
	"ai-player-search.header.demo-badge": never;
	"ai.feedback-popover.cancel": never;
	"ai.feedback-popover.save": never;
	"ai.feedback-popover.textarea.placeholder": never;
	"ai.feedback-popover.feedback-label": never;
	"ai.feedback-popover.note-label": never;
	"ai.feedback-popover.note-description": never;
	"ai.feedback-popover.note-optional": never;
	"discover.gamesTable.programGame.error.nationalLeagueRequired": never;
	"label.sportlogiq_physical": never;
	"gameAnalysis.veoLink.required": never;
	"breadcrumb.backTo./teams": never;
	"game_analysis_physical.validation.game_id_required": never;
	"game_analysis_physical.validation.already_scheduled": never;
	"teamsheet.error.edit_in_progress": never;
	"gameAnalysis.veoLink.missingGameUploadsHint": {
		gameId: string;
	};
	"gameAnalysis.veoLink.gameUploadsLinkLabel": never;
	"gameAnalysis.veoLink.requiredGameUploads": never;
	"country.selection.network.teamsSection": never;
	"country.selection.network.clubsSection": never;
	"club.discover-club": never;
	"country.selection.network.selectLabel": never;
	"country.selection.network.teamsIncluded": never;
	"ai.feedback.success": never;
	"ai.feedback.error": never;
	"playerProfile.tabs.development": never;
	"playerProfile.development.physicalMetrics": never;
	"playerProfile.development.biometrics": never;
	"playerProfile.development.behavioralProfile": never;
	"label.active_team_name": never;
	"token.source.eyeball_admin": never;
	"token.source.clubhouse_admin": never;
	"token.source.team_admin": never;
	"token.source.user": never;
	"token.source.system": never;
	"playerProfileDevelopment.biometrics.summary": never;
	"playerProfileDevelopment.biometrics.circumference": never;
	"playerProfileDevelopment.biometrics.fullBodyMeasurements": never;
	"playerProfile.biometrics.field.estimatedAgeAtPhv": never;
	"playerProfile.biometrics.field.seatedHeight": never;
	"playerProfile.biometrics.field.weight": never;
	"playerProfile.biometrics.field.height": never;
	"playerProfileDevelopment.biometrics.bodyMetricTrend": never;
	"playerProfileDevelopment.biometrics.bodyCompositionChange": never;
	"playerProfileDevelopment.biometrics.scanInfo.recentScan": never;
	"playerProfileDevelopment.biometrics.scanInfo.lastUpdated": {
		date: string;
	};
	"playerProfileDevelopment.biometrics.circumference.upperBody": never;
	"playerProfileDevelopment.biometrics.circumference.lowerBody": never;
	"playerProfile.biometrics.field.wingspan": never;
	"playerProfile.biometrics.field.bodyRoundnessIndex": never;
	"playerProfile.biometrics.field.bmi": never;
	"playerProfile.biometrics.field.chestCircumference": never;
	"playerProfile.biometrics.field.narrowestWaistCircumference": never;
	"playerProfile.biometrics.field.waistCircumference": never;
	"playerProfile.biometrics.field.upperArmCircumferenceLeft": never;
	"playerProfile.biometrics.field.upperArmCircumferenceRight": never;
	"playerProfile.biometrics.field.forearmCircumferenceLeft": never;
	"playerProfile.biometrics.field.forearmCircumferenceRight": never;
	"playerProfile.biometrics.field.wristCircumferenceLeft": never;
	"playerProfile.biometrics.field.wristCircumferenceRight": never;
	"playerProfile.biometrics.field.hipCircumference": never;
	"playerProfile.biometrics.field.midThighCircumferenceLeft": never;
	"playerProfile.biometrics.field.midThighCircumferenceRight": never;
	"playerProfile.biometrics.field.upperThighCircumferenceLeft": never;
	"playerProfile.biometrics.field.upperThighCircumferenceRight": never;
	"playerProfile.biometrics.field.calfCircumferenceLeft": never;
	"playerProfile.biometrics.field.calfCircumferenceRight": never;
	"playerProfile.biometrics.field.waistToHipRatio": never;
	"playerProfile.biometrics.field.predictedAdultHeight": never;
	"playerProfile.biometrics.field.legLengthLeft": never;
	"playerProfile.biometrics.field.legLengthRight": never;
	"playerProfile.biometrics.field.hipBreadth": never;
	"playerProfile.biometrics.field.waistBreadth": never;
	"playerProfile.biometrics.field.transverseChestBreadth": never;
	"playerProfile.biometrics.field.chestDepthAnteriorPosterior": never;
	"playerProfile.events.paymentRequired.title": never;
	"playerProfile.events.paymentRequired.message": never;
	"playerProfile.events.paymentRequired.button": never;
	"token.movement.type.remove_subscription": never;
	"error.no_email": never;
	"playerProfile.events.sidebar.emptyFiltered": never;
	"playerProfile.events.list.emptyFiltered": never;
	"playerProfile.events.player.emptyFiltered": never;
	"playerProfile.events.sidebar.noPlayerEvents": never;
	"playerProfile.events.sidebar.noPlayerEvents2": never;
	"event.v3.type.shot_on_target": never;
	"event.v3.type.shot_inside_pa": never;
	"event.v3.type.shot_outside_pa": never;
	"event.v3.type.assist": never;
	"event.v3.type.shot_blocked": never;
	"ai.game-summary.event.goal": {
		count: number;
	};
	"ai.game-summary.event.assist": {
		count: number;
	};
	"ai.game-summary.event.shot_on_target": {
		count: number;
	};
	"ai.game-summary.event.successful_dribble": {
		count: number;
	};
	"ai.game-summary.event.key_pass": {
		count: number;
	};
	"ai.game-summary.event.pass_accuracy": {
		percentage: string;
	};
	"ai.game-summary.event.tackle_won": {
		count: number;
	};
	"ai.game-summary.event.interception": {
		count: number;
	};
	"ai.game-summary.event.block": {
		count: number;
	};
	"ai.game-summary.event.clearance": {
		count: number;
	};
	"ai.game-summary.event.recovery": {
		count: number;
	};
	"ai.game-summary.event.catch": {
		count: number;
	};
	"ai.game-summary.event.punch": {
		count: number;
	};
	"playerProfile.events.list.previouslySelected": never;
	"app.eyeball.lang.az": never;
	"country.selection.network.title": never;
	"country.selection.network.subtitle": never;
	"label.player.gender.female": never;
	"label.player.gender.male": never;
	"gamePage.physicalMetrics.taggingAnalysisRejected": never;
	"resource.discover_subscription_management": never;
	"resource.team_groups": never;
	"ai.game-summary.title-loading": never;
	"discover.gameDetail.btn.editGame": never;
	"discover.gameDetail.btn.saveChanges": never;
	"gameAnalysis.veoLink.invalidFormat": {
		example: string;
	};
	"gameAnalysis.veoLink.tooltipExample": {
		example: string;
	};
	"gameAnalysis.veoLink.label": never;
	"discover.gameDetail.analysis.sendForAnalysis": never;
	"discover.gameDetail.analysis.title": never;
	"discover.gameDetail.swapHomeAwayMapping.button": never;
	"discover.gameDetail.swapHomeAwayMapping.confirm": never;
	"discover.gameDetail.swapHomeAwayMapping.toast.failed": never;
	"discover.gameDetail.swapHomeAwayMapping.toast.requested": never;
	"gamePage.playerStats.type.totalXg": never;
	"gamePage.playerStats.type.nonPenaltyXg": never;
	"gamePage.playerStats.type.totalXa": never;
	"gamePage.playerStats.type.xgPerShot": never;
	"gamePage.playerStats.type.nonPenaltyXgPlusXaPer90": never;
	"gamePage.playerStats.type.goalsXgRatio": never;
	"gamePage.teamStats.type.totalXg": never;
	"gamePage.teamStats.type.nonPenaltyXg": never;
	"gamePage.teamStats.type.totalXa": never;
	"gamePage.teamStats.type.xgPerShot": never;
	"gamePage.playerStats.type.xgPerShot-2": never;
	"gamePage.teamStats.type.nonPenaltyXgPlusXaPer90": never;
	"gamePage.teamStats.type.goalsXgRatio": never;
	"gamePage.teamStats.description.totalXg": never;
	"gamePage.teamStats.description.nonPenaltyXg": never;
	"gamePage.teamStats.description.totalXa": never;
	"gamePage.teamStats.description.xgPerShot": never;
	"gamePage.teamStats.description.nonPenaltyXgPlusXaPer90": never;
	"gamePage.teamStats.description.goalsXgRatio": never;
	"token.movement.type.remove_shared_analysis": never;
	"gamePage.playerStats.type.throwsRatio": never;
	"gamePage.playerStats.type.averagePassLength": never;
	"gamePage.playerStats.type.launchPercent": never;
	"gamePage.playerStats.type.defensiveActionsOutsidePenaltyArea": never;
	"gamePage.playerStats.type.averageDefensiveActionDistance": never;
	"gamePage.playerStats.type.crossesFaced": never;
	"gamePage.playerStats.type.crossesStoppedRatio": never;
	"gamePage.playerStats.type.savePercent": never;
	"gamePage.playerStats.description.throwsRatio": never;
	"gamePage.playerStats.description.averagePassLength": never;
	"gamePage.playerStats.description.launchPercent": never;
	"gamePage.playerStats.description.defensiveActionsOutsidePenaltyArea": never;
	"gamePage.playerStats.description.averageDefensiveActionDistance": never;
	"gamePage.playerStats.description.crossesFaced": never;
	"gamePage.playerStats.description.crossesStoppedRatio": never;
	"gamePage.playerStats.description.savePercent": never;
	"tag.Tim's": never;
	"tag.Must-watch": never;
	"tag.Market": never;
	"tag.Club": never;
	"tag.Drin": never;
	"tag.Emilio": never;
	"tag.Kieran": never;
	"tag.Nael": never;
	"tag.Trey": never;
	"tag.": never;
	"tag.Performers": never;
	"tag.Ivory": never;
	"tag.Sultan": never;
	"tag.Tim": never;
	"tag.Stat": never;
	"tag.Goals": never;
	"tag.Sierra": never;
	"tag.Team": never;
	"tag.North": never;
	"tag.South": never;
	"tag.Burkina": never;
	"tag.Marko": never;
	"tag.Samet": never;
	"ai.game-summary.badge.early-access": never;
	"playerProfileDevelopment.biometrics.blurred.pendingPlayerScan": never;
	"playerProfileDevelopment.biometrics.blurred.unlockedAfterOneMoreScan": never;
	"admin.video.tabs.setup": never;
	"admin.video.tabs.info": never;
	"admin.video.actions.delete": never;
	"admin.video.info.systemInfo": never;
	"admin.video.info.uploadedBy": never;
	"admin.video.info.uploaded": never;
	"admin.video.info.gameInfo": never;
	"admin.video.info.noLinkedGame": never;
	"admin.video.info.loadingGame": never;
	"admin.video.info.gameId": never;
	"admin.video.info.homeClub": never;
	"admin.video.info.awayClub": never;
	"admin.video.info.date": never;
	"admin.video.info.ageCategory": never;
	"admin.video.info.videoMetadata": never;
	"admin.video.info.videoName": never;
	"admin.video.info.source": never;
	"admin.video.info.resolution": never;
	"admin.video.info.fileSize": never;
	"admin.video.info.bitrate": never;
	"admin.video.info.veoLink": never;
	"admin.video.info.veoCameraId": never;
	"admin.video.info.veoTeam": never;
	"admin.video.info.veoClubhouse": never;
	"admin.video.info.veoGameDate": never;
	"admin.video.actions.editName": never;
	"admin.video.gamePage.videoActions": never;
	"admin.videoUploads.error.alreadyDeleted": never;
	"admin.videoUploads.error.notFound": never;
	"admin.videoUploads.error.generic": never;
	"admin.video.info.gameUnavailable": never;
	"discover.gameDetail.field.swapped": never;
	"game.swapHomeAwayMapping.label": never;
	"game.swapHomeAwayMapping.button": never;
	"game.swapHomeAwayMapping.confirm": never;
	"game.swapHomeAwayMapping.toast.requested": never;
	"ai.badge.early-access": never;
	"game.swapped.label": never;
	"game.swapped.notReported": never;
	"msg.resync_type_invalid": never;
	"msg.resync_keep_mapping_not_allowed_for_swapped_game": never;
	"playerProfileDevelopment.behavioralProfile.nonDiagnosticInsights.title": never;
	"playerProfileDevelopment.behavioralProfile.nonDiagnosticInsights.description": never;
	"playerProfileDevelopment.behavioralSignals.title": never;
	"playerProfileDevelopment.behavioralSignals.view.trend": never;
	"playerProfileDevelopment.behavioralSignals.view.snapshot": never;
	"playerProfileDevelopment.behavioralSignals.period": never;
	"playerProfileDevelopment.behavioralSignals.period.last10Games": never;
	"playerProfileDevelopment.behavioralSignals.period.season": never;
	"playerProfileDevelopment.behavioralSignals.season": never;
	"playerProfileDevelopment.behavioralSignals.selectSeason": never;
	"playerProfileDevelopment.behavioralSignals.selectSeasons": never;
	"playerProfileDevelopment.behavioralSignals.selectedSeasons": {
		seasons: string;
	};
	"playerProfileDevelopment.behavioralSignals.cohort": never;
	"playerProfileDevelopment.behavioralSignals.selectCohort": never;
	"playerProfileDevelopment.behavioralSignals.position": never;
	"playerProfileDevelopment.behavioralSignals.selectPosition": never;
	"playerProfileDevelopment.behavioralSignals.tab.overview": never;
	"playerProfileDevelopment.behavioralSignals.tab.sensitivity": never;
	"playerProfileDevelopment.behavioralSignals.tab.tolerance": never;
	"playerProfileDevelopment.behavioralSignals.tab.recovery": never;
	"playerProfileDevelopment.behavioralSignals.summary": never;
	"playerProfileDevelopment.behavioralSignals.empty.title": never;
	"playerProfileDevelopment.behavioralSignals.empty.description": never;
	"playerProfileDevelopment.behavioralSignals.confidence.high": never;
	"playerProfileDevelopment.behavioralSignals.confidence.medium": never;
	"playerProfileDevelopment.behavioralSignals.confidence.low": never;
	"playerProfileDevelopment.behavioralSignals.confidence.high.tooltip": never;
	"playerProfileDevelopment.behavioralSignals.confidence.medium.tooltip": never;
	"playerProfileDevelopment.behavioralSignals.confidence.low.tooltip": never;
	"playerProfileDevelopment.behavioralSignals.minutes": {
		minutes: string;
	};
	"playerProfileDevelopment.behavioralSignals.games": {
		games: string;
	};
	"playerProfileDevelopment.behavioralSignals.score": {
		score: string;
	};
	"playerProfileDevelopment.behavioralSignals.scoreLabel": never;
	"playerProfileDevelopment.behavioralSignals.trendLabel": never;
	"playerProfileDevelopment.behavioralSignals.vsCohort": never;
	"playerProfileDevelopment.behavioralSignals.trend.improving": {
		percentage: string;
	};
	"playerProfileDevelopment.behavioralSignals.trend.declining": {
		percentage: string;
	};
	"playerProfileDevelopment.behavioralSignals.trend.stable": never;
	"playerProfileDevelopment.behavioralSignals.chart.score": {
		score: string;
	};
	"playerProfileDevelopment.behavioralSignals.legend.average": never;
	"playerProfileDevelopment.behavioralSignals.legend.iqr": never;
	"playerProfileDevelopment.behavioralSignals.legend.iqr.tooltip": never;
	"playerProfileDevelopment.behavioralSignals.pagination.label": {
		from: string;
		to: string;
		total: string;
	};
	"playerProfileDevelopment.behavioralSignals.pagination.previous": never;
	"playerProfileDevelopment.behavioralSignals.pagination.next": never;
	"playerProfile.behavioralSignals.periodFilter.last10Games": never;
	"playerProfile.behavioralSignals.periodFilter.season": never;
	"playerProfile.behavioralSignals.signal.tolerance.name": never;
	"playerProfile.behavioralSignals.signal.sensitivity.name": never;
	"playerProfile.behavioralSignals.signal.recovery.name": never;
	"playerProfileDevelopment.behavioralArchetypes.title": never;
	"playerProfileDevelopment.behavioralArchetypes.disclaimer": never;
	"playerProfileDevelopment.behavioralArchetypes.lastCompleted": {
		date: string;
	};
	"playerProfileDevelopment.behavioralArchetypes.lastCompleted.tooltip": never;
	"playerProfileDevelopment.behavioralArchetypes.summary": never;
	"playerProfileDevelopment.behavioralArchetypes.dominantLabel": never;
	"playerProfileDevelopment.behavioralArchetypes.alignment": never;
	"playerProfileDevelopment.behavioralArchetypes.score": {
		score: string;
	};
	"playerProfileDevelopment.behavioralArchetypes.showDetailedProfile": never;
	"playerProfileDevelopment.behavioralArchetypes.moreDetail": never;
	"playerProfileDevelopment.behavioralArchetypes.showLess": never;
	"playerProfileDevelopment.behavioralArchetypes.observedPatterns": never;
	"playerProfileDevelopment.behavioralArchetypes.developmentFocus": never;
	"admin.video.player.unavailable": never;
	"playerProfile.behavioralSignals.cohortFilter.ageGroup": never;
	"playerProfile.behavioralSignals.cohortFilter.ageGroupPosition": never;
	"playerProfile.behavioralSignals.cohortFilter.position": never;
	"playerProfile.behavioralSignals.chart.matchLabel": {
		number: string;
	};
	"playerProfile.behavioralSignals.chart.lastGamesLabel": {
		count: string;
	};
	"playerProfile.behavioralSignals.signal.sensitivity.description": never;
	"playerProfile.behavioralSignals.signal.tolerance.description": never;
	"playerProfile.behavioralSignals.signal.recovery.description": never;
	"playerProfile.behavioralSignals.band.tolerance.developing.anchor": never;
	"playerProfile.behavioralSignals.band.tolerance.developing.summary": never;
	"playerProfile.behavioralSignals.band.tolerance.developing.combinedHeader": never;
	"playerProfile.behavioralSignals.band.tolerance.developing.combinedSentence": never;
	"playerProfile.behavioralSignals.band.tolerance.moderate.anchor": never;
	"playerProfile.behavioralSignals.band.tolerance.moderate.summary": never;
	"playerProfile.behavioralSignals.band.tolerance.moderate.combinedHeader": never;
	"playerProfile.behavioralSignals.band.tolerance.moderate.combinedSentence": never;
	"playerProfile.behavioralSignals.band.tolerance.established.anchor": never;
	"playerProfile.behavioralSignals.band.tolerance.established.summary": never;
	"playerProfile.behavioralSignals.band.tolerance.established.combinedHeader": never;
	"playerProfile.behavioralSignals.band.tolerance.established.combinedSentence": never;
	"playerProfile.behavioralSignals.band.tolerance.advanced.anchor": never;
	"playerProfile.behavioralSignals.band.tolerance.advanced.summary": never;
	"playerProfile.behavioralSignals.band.tolerance.advanced.combinedHeader": never;
	"playerProfile.behavioralSignals.band.tolerance.advanced.combinedSentence": never;
	"playerProfile.behavioralSignals.band.sensitivity.developing.anchor": never;
	"playerProfile.behavioralSignals.band.sensitivity.developing.summary": never;
	"playerProfile.behavioralSignals.band.sensitivity.developing.combinedHeader": never;
	"playerProfile.behavioralSignals.band.sensitivity.developing.combinedSentence": never;
	"playerProfile.behavioralSignals.band.sensitivity.moderate.anchor": never;
	"playerProfile.behavioralSignals.band.sensitivity.moderate.summary": never;
	"playerProfile.behavioralSignals.band.sensitivity.moderate.combinedHeader": never;
	"playerProfile.behavioralSignals.band.sensitivity.moderate.combinedSentence": never;
	"playerProfile.behavioralSignals.band.sensitivity.established.anchor": never;
	"playerProfile.behavioralSignals.band.sensitivity.established.summary": never;
	"playerProfile.behavioralSignals.band.sensitivity.established.combinedHeader": never;
	"playerProfile.behavioralSignals.band.sensitivity.established.combinedSentence": never;
	"playerProfile.behavioralSignals.band.sensitivity.advanced.anchor": never;
	"playerProfile.behavioralSignals.band.sensitivity.advanced.summary": never;
	"playerProfile.behavioralSignals.band.sensitivity.advanced.combinedHeader": never;
	"playerProfile.behavioralSignals.band.sensitivity.advanced.combinedSentence": never;
	"playerProfile.behavioralSignals.band.recovery.developing.anchor": never;
	"playerProfile.behavioralSignals.band.recovery.developing.summary": never;
	"playerProfile.behavioralSignals.band.recovery.developing.combinedHeader": never;
	"playerProfile.behavioralSignals.band.recovery.developing.combinedSentence": never;
	"playerProfile.behavioralSignals.band.recovery.moderate.anchor": never;
	"playerProfile.behavioralSignals.band.recovery.moderate.summary": never;
	"playerProfile.behavioralSignals.band.recovery.moderate.combinedHeader": never;
	"playerProfile.behavioralSignals.band.recovery.moderate.combinedSentence": never;
	"playerProfile.behavioralSignals.band.recovery.established.anchor": never;
	"playerProfile.behavioralSignals.band.recovery.established.summary": never;
	"playerProfile.behavioralSignals.band.recovery.established.combinedHeader": never;
	"playerProfile.behavioralSignals.band.recovery.established.combinedSentence": never;
	"playerProfile.behavioralSignals.band.recovery.advanced.anchor": never;
	"playerProfile.behavioralSignals.band.recovery.advanced.summary": never;
	"playerProfile.behavioralSignals.band.recovery.advanced.combinedHeader": never;
	"playerProfile.behavioralSignals.band.recovery.advanced.combinedSentence": never;
	"playerProfile.archetype.heartbeat.name": never;
	"playerProfile.archetype.heartbeat.tagline": never;
	"playerProfile.archetype.heartbeat.tag.1": never;
	"playerProfile.archetype.heartbeat.tag.2": never;
	"playerProfile.archetype.heartbeat.tag.3": never;
	"playerProfile.archetype.heartbeat.tag.4": never;
	"playerProfile.archetype.heartbeat.shortDescription": never;
	"playerProfile.archetype.heartbeat.fullDescription": never;
	"playerProfile.archetype.heartbeat.observedPattern.1": never;
	"playerProfile.archetype.heartbeat.observedPattern.2": never;
	"playerProfile.archetype.heartbeat.observedPattern.3": never;
	"playerProfile.archetype.heartbeat.observedPattern.4": never;
	"playerProfile.archetype.heartbeat.developmentFocus": never;
	"playerProfile.archetype.regulator.name": never;
	"playerProfile.archetype.regulator.tagline": never;
	"playerProfile.archetype.regulator.tag.1": never;
	"playerProfile.archetype.regulator.tag.2": never;
	"playerProfile.archetype.regulator.tag.3": never;
	"playerProfile.archetype.regulator.tag.4": never;
	"playerProfile.archetype.regulator.shortDescription": never;
	"playerProfile.archetype.regulator.fullDescription": never;
	"playerProfile.archetype.regulator.observedPattern.1": never;
	"playerProfile.archetype.regulator.observedPattern.2": never;
	"playerProfile.archetype.regulator.observedPattern.3": never;
	"playerProfile.archetype.regulator.observedPattern.4": never;
	"playerProfile.archetype.regulator.developmentFocus": never;
	"playerProfile.archetype.general.name": never;
	"playerProfile.archetype.general.tagline": never;
	"playerProfile.archetype.general.tag.1": never;
	"playerProfile.archetype.general.tag.2": never;
	"playerProfile.archetype.general.tag.3": never;
	"playerProfile.archetype.general.tag.4": never;
	"playerProfile.archetype.general.shortDescription": never;
	"playerProfile.archetype.general.fullDescription": never;
	"playerProfile.archetype.general.observedPattern.1": never;
	"playerProfile.archetype.general.observedPattern.2": never;
	"playerProfile.archetype.general.observedPattern.3": never;
	"playerProfile.archetype.general.observedPattern.4": never;
	"playerProfile.archetype.general.developmentFocus": never;
	"playerProfile.archetype.profileSummary": {
		tagline: string;
		shortDescription: string;
		secondaryArchetypes: string;
	};
	"playerProfile.archetype.secondaryArchetypeJoiner": never;
	"playerProfile.behavioralSignals.periodFilter.allSeasons": never;
	"playerProfile.archetype.title": never;
	"playerProfile.archetype.disclaimer": never;
	"playerProfile.archetype.summaryTitle": never;
	"playerProfile.archetype.completedAtLabel": {
		date: string;
	};
	"playerProfile.archetype.dominantLabel": never;
	"playerProfile.archetype.secondaryLabel": never;
	"playerProfile.archetype.alignmentScoreLabel": never;
	"playerProfile.archetype.observedPatternsTitle": never;
	"playerProfile.archetype.developmentFocusTitle": never;
	"playerProfile.archetype.showDetailedProfile": never;
	"playerProfile.archetype.showMoreDetail": never;
	"playerProfile.archetype.showLess": never;
	"playerProfileDevelopment.physicalMetrics.season": never;
	"playerProfileDevelopment.physicalMetrics.selectSeason": never;
	"playerProfileDevelopment.physicalMetrics.games": {
		games: string;
	};
	"playerProfileDevelopment.physicalMetrics.games.tooltip": never;
	"playerProfileDevelopment.physicalMetrics.minutes": {
		minutes: string;
	};
	"playerProfileDevelopment.physicalMetrics.minutes.tooltip": never;
	"playerProfileDevelopment.physicalMetrics.positions": {
		positions: string;
	};
	"playerProfileDevelopment.physicalMetrics.peakPerformance": never;
	"playerProfileDevelopment.physicalMetrics.highestTopSpeed": never;
	"playerProfileDevelopment.physicalMetrics.averageTopSpeed": never;
	"playerProfileDevelopment.physicalMetrics.averageDistanceCovered": never;
	"playerProfileDevelopment.physicalMetrics.accelerationsDecelerations": never;
	"playerProfileDevelopment.physicalMetrics.accelerationsDecelerations.threshold": never;
	"playerProfileDevelopment.physicalMetrics.vsOpponent": {
		opponent: string;
	};
	"playerProfileDevelopment.physicalMetrics.peakRecordedThisSeason": never;
	"playerProfileDevelopment.physicalMetrics.peakRecordedAllTime": never;
	"playerProfileDevelopment.physicalMetrics.changeVsLastSeason": {
		change: string;
		unit: string;
	};
	"playerProfileDevelopment.physicalMetrics.seasonalAverage": never;
	"playerProfileDevelopment.physicalMetrics.perNinety": never;
	"playerProfileDevelopment.physicalMetrics.movementDistribution": never;
	"playerProfileDevelopment.physicalMetrics.zone.standing": never;
	"playerProfileDevelopment.physicalMetrics.zone.walking": never;
	"playerProfileDevelopment.physicalMetrics.zone.jogging": never;
	"playerProfileDevelopment.physicalMetrics.zone.running": never;
	"playerProfileDevelopment.physicalMetrics.zone.highSpeedRunning": never;
	"playerProfileDevelopment.physicalMetrics.zone.sprinting": never;
	"playerProfileDevelopment.physicalMetrics.zone.standing.threshold": never;
	"playerProfileDevelopment.physicalMetrics.zone.walking.threshold": never;
	"playerProfileDevelopment.physicalMetrics.zone.jogging.threshold": never;
	"playerProfileDevelopment.physicalMetrics.zone.running.threshold": never;
	"playerProfileDevelopment.physicalMetrics.zone.highSpeedRunning.threshold": never;
	"playerProfileDevelopment.physicalMetrics.zone.sprinting.threshold": never;
	"playerProfileDevelopment.physicalMetrics.documents": never;
	"playerProfileDevelopment.physicalMetrics.documents.empty": never;
	"playerProfileDevelopment.physicalMetrics.documents.multipleMatches": never;
	"playerProfileDevelopment.physicalMetrics.documents.game": {
		homeTeam: string;
		awayTeam: string;
	};
	"playerProfileDevelopment.physicalMetrics.documents.season": {
		season: string;
	};
	"playerProfileDevelopment.physicalMetrics.documents.view": never;
	"playerProfileDevelopment.physicalMetrics.documents.download": never;
	"ai.key_performers.anonymous_player_info": {
		count: number;
	};
	"discover.gamesTable.column.createdAt": never;
	"discover.gamesTable.filter.createdAt": never;
	"discover.gameDetail.field.createdAt": never;
	"discover.gameDetail.field.createdBy": never;
	"app.eyeball.lang.lv": never;
	"admin.videoUploads.error.ingestSourceNotFound": never;
	"gamePage.create.name": never;
	"gamePage.create.name.placeholder": never;
	"gamePage.create.note": never;
	"gamePage.create.note.placeholder": never;
	"gamePage.create.setLength": never;
	"gamePage.create.timestamp": never;
	"gamePage.create.end": never;
	"gamePage.create.time.placeholder": never;
	"event.filter.button.play": {
		count: string;
	};
	"gamePage.exportEvents.title": never;
	"resource.provider_operations": never;
	"header.admin.providerOperations": never;
	"providerOperations.page.title": never;
	"providerOperations.page.intro": never;
	"providerOperations.search.label": never;
	"providerOperations.search.placeholder": never;
	"providerOperations.search.submit": never;
	"providerOperations.noResults": never;
	"providerOperations.column.gameId": never;
	"providerOperations.column.provider": never;
	"providerOperations.column.providerRequestId": never;
	"providerOperations.column.requestType": never;
	"providerOperations.column.status": never;
	"providerOperations.column.lastUpdated": never;
	"providerOperations.column.result": never;
	"providerOperations.column.action": never;
	"providerOperations.action.none": never;
	"providerOperations.result.empty": never;
	"providerOperations.result.providerError": never;
	"providerOperations.result.internalError": never;
	"providerOperations.action.refreshStatus": never;
	"providerOperations.action.processPending": never;
	"providerOperations.action.sync": never;
	"providerOperations.action.failed": never;
	"providerOperations.action.confirm.title": never;
	"providerOperations.action.confirm.processPending": never;
	"providerOperations.action.confirm.sync": never;
	"providerOperations.action.confirm.submit": never;
	"providerOperations.action.confirm.cancel": never;
	"providerOperations.bulk.skipped": never;
	"providerOperations.action.confirm.refreshStatus": never;
	"clipModal.create.name.placeholder": never;
	"clipModal.create.description.placeholder": never;
	"gamePage.message.deleteClip.title": never;
	"playerProfileDevelopment.behavioralSignals.chart.vs": never;
	"country.selection.network.showAll": never;
	"game.stats.menu.advancedMetrics": never;
	"gamePage.dataInsights.label.xg": never;
	"gamePage.dataInsights.label.xa": never;
	"gamePage.dataInsights.label.xgPointSizeExplanation": never;
	"gamePage.dataInsights.label.xgZoneIntensityExplanation": never;
	"providerOperations.result.triggeredBy": never;
	"providerOperations.result.triggeredAt": never;
	"providerOperations.result.collapseRawResponse": never;
	"playerProfileDevelopment.behavioralSignals.score.unavailable": never;
	"gamePage.ott.disclaimer": {
		b: (text: string) => any;
	};
	"playerProfileDevelopment.behavioralSignals.typicalRange.above": never;
	"playerProfileDevelopment.behavioralSignals.typicalRange.typical": never;
	"playerProfileDevelopment.behavioralSignals.typicalRange.below": never;
	"playerProfileDevelopment.behavioralSignals.ageCategory": never;
	"gamePage.header.home": never;
	"playerProfileDevelopment.behavioralSignals.limitedDataMessage": never;
	"playerProfileDevelopment.physicalMetrics.empty.description": never;
	"playerProfile.behavioralSignals.cohortFilter.ageGroupWithCategory": {
		ageCategory: string;
	};
	"playerProfile.behavioralSignals.cohortFilter.ageGroupPositionWithCategory": {
		ageCategory: string;
	};
	"playerProfileDevelopment.physicalMetrics.peakPerformance.empty": never;
	"playerProfileDevelopment.physicalMetrics.movementDistribution.empty": never;
	"providerOperations.search.failed": never;
	"providerOperations.search.queryRequired": never;
	"providerOperations.action.unavailable": never;
	"providerOperations.action.requestsRequired": never;
	"providerOperations.action.invalid": never;
	"providerOperations.result.expandRawResponse": never;
	"playerProfile.recruitment.title": never;
	"playerProfile.recruitment.gpa": never;
	"playerProfile.recruitment.sat": never;
	"playerProfile.recruitment.graduationYear": never;
	"playerProfile.recruitment.toefl": never;
	"playerProfile.recruitment.ielts": never;
	"playerProfile.recruitment.status": never;
	"playerProfile.recruitment.status.committed": never;
	"playerProfile.recruitment.status.uncommitted": never;
	"playerProfile.recruitment.status.tooltip": never;
	"providerOperations.action.requestNotFound": never;
	"providerOperations.action.unsupportedProvider": never;
	"providerOperations.action.invalidRequestId": never;
	"my_eyeball.search.count.clubs": never;
	"playerProfileDevelopment.biometrics.bodyCompositionChange.selectScans": never;
	"playerProfileDevelopment.biometrics.bodyMetricTrend.selectMetric": never;
	"playerProfileDevelopment.biometrics.bodyMetricTrend.pagination.label": {
		page: string;
		pageCount: string;
	};
	"playerProfileDevelopment.biometrics.bodyMetricTrend.pagination.older": never;
	"playerProfileDevelopment.biometrics.bodyMetricTrend.pagination.newer": never;
	"app.player.profile.gender.Male": never;
	"app.player.profile.gender.Female": never;
	"my_eyeball.search.count.teams": never;
	"myGames.title": never;
	"teamClubPage.tab.games": never;
	"globalSearch.filter.content_type.matches": never;
	"globalSearch.filter.content_type.players": never;
	"filter.resultCount.clubs": never;
	"app.eyeball.lang.cs": never;
	"gamePage.dataInsights.label.lowXg": never;
	"gamePage.dataInsights.label.highXg": never;
	"providerOperations.action.sync.failed": never;
	"providerOperations.action.sync.unavailable": never;
	"providerOperations.action.sync.success": never;
	"providerOperations.action.processPending.taggingIncomplete": never;
	"providerOperations.action.processPending.notPending": never;
	"providerOperations.action.processPending.notFound": never;
	"providerOperations.action.processPending.success": never;
	"providerOperations.action.refreshStatus.locked": never;
	"providerOperations.action.providerFailed": never;
	"providerOperations.action.bulkLimitExceeded": never;
	"providerOperations.bulk.providerRequestIds": never;
	"playerProfile.performance.advanced": never;
	"playerProfile.performance.xg": never;
	"playerProfile.performance.xa": never;
	"playerProfile.performance.npxg": never;
	"playerProfile.performance.xgPerShot": never;
	"playerProfile.performance.npxgPlusXaPer90": never;
	"playerProfile.performance.goalsXgRatio": never;
	"playerProfile.performance.per90": never;
	"game.stats.menu.advanced": never;
	"game.stats.table.totalXg": never;
	"game.stats.table.totalXa": never;
	"game.stats.table.nonPenaltyXg": never;
	"game.stats.table.nonPenaltyXgPerShot": never;
	"game.stats.table.nonPenaltyXgPlusXaPer90": never;
	"game.stats.table.goalsXgRatio": never;
	"respovision.request.label": never;
	"respovision.request.status": never;
	"respovision.request.status.none": never;
	"respovision.request.status.requested": never;
	"respovision.request.status.processing": never;
	"respovision.request.status.ready": never;
	"respovision.request.status.failed": never;
	"respovision.request.match_id": never;
	"respovision.request.submit": never;
	"respovision.request.submit_success": never;
	"respovision.request.submit_failed": never;
	"respovision.request.not_eligible": never;
	"respovision.request.invalid_payload": never;
	"admin.discover.productSubscription.coachOrPlayerOnly": never;
	"admin.discover.productSubscription.productNotGrantable": never;
	"admin.discover.productSubscription.duplicate": never;
	"admin.discover.productSubscription.endDateBeforeStart": never;
	"admin.discover.productSubscription.purchaseNotEditable": never;
	"permission.club_edit": never;
	"permission.club_edit_tokens": never;
	"permission.team_edit": never;
	"permission.team_edit_tokens": never;
	"permission.team_edit_subscriptions": never;
	"permission.player_edit": never;
	"permission.user_edit": never;
	"permission.user_edit_permissions": never;
	"permission.user_log_in_as": never;
	"permission.user_deactivate": never;
	"permission.user_edit_subscriptions": never;
	"gamePage.header.away": never;
	"label.gamePage.allEventsPlaying": never;
	"permission.user_edit_enterprise": never;
	"providerOperations.search.noResults": never;
	"providerOperations.search.error": never;
	"product.management.leagues_and_tournaments": never;
	"providerOperations.action.running": never;
	"providerOperations.action.providerUnreachable": never;
	"providerOperations.action.processPending.failed": never;
	"providerOperations.action.sync.nothingToSync": never;
	"providerOperations.result.none": never;
	"providerOperations.result.showRawOutput": never;
	"leagues.country_selection.title": never;
	"leagues.country_selection.subtitle": never;
	"leagues.country_selection.search_placeholder": never;
	"leagues.country_selection.your_countries": never;
	"leagues.country_selection.other_countries": never;
	"leagues.country_selection.countries_count": {
		count: number;
	};
	"leagues.country.competitionsCount": {
		count: number;
	};
	"leagues.country.badge.subscribed": never;
	"providerOperations.bulk.title": never;
	"providerOperations.bulk.confirm.title": never;
	"providerOperations.bulk.confirm.action": never;
	"providerOperations.bulk.confirm.run": never;
	"providerOperations.bulk.succeeded": never;
	"providerOperations.bulk.failed": never;
	"prod.text.dynamic.club.23071.biography": never;
	"breadcrumb.backTo.": never;
	"providerOperations.bulk.refreshStatus": never;
	"providerOperations.bulk.eligibleCount": never;
	"providerOperations.bulk.willRun": never;
	"providerOperations.bulk.overLimit": never;
	"leagues.country_selection.no_countries_found": never;
	"leagues.filters.season": never;
	"leagues.filters.all_seasons": never;
	"leagues.filters.age_group": never;
	"leagues.filters.clear": never;
	"leagues.list.tier.national": never;
	"leagues.list.tier.regional": never;
	"leagues.list.tier.district": never;
	"leagues.list.tier.other": never;
	"leagues.list.competitions_count": {
		count: number;
	};
	"gamePage.header.editDetails": never;
	"gamePage.header.saveDetails": never;
	"leagues.list.no_competitions": never;
	"cups.list.title": never;
	"cups.list.no_competitions": never;
	"cups.search.placeholder": never;
	"friendlies.search.placeholder": never;
	"friendlies.list.no_competitions": never;
	"leagues.search.placeholder": never;
	"competition.type.domestic_league": never;
	"competition.type.domestic_cup": never;
	"competition.type.club_tournament": never;
	"competition.type.national_team_tournament": never;
	"competition.tier.national": never;
	"competition.tier.regional": never;
	"competition.tier.district": never;
	"cups.games.no_games": never;
	"friendlies.layout.columns": never;
	"friendlies.layout.grid": never;
	"competition.overview.filters.season": never;
	"competition.overview.filters.phase": never;
	"competition.overview.filters.group": never;
	"competition.overview.filters.all_seasons": never;
	"competition.overview.filters.all_phases": never;
	"competition.overview.filters.all_groups": never;
	"competition.overview.type.domestic_league": never;
	"competition.overview.type.domestic_cup": never;
	"competition.overview.type.club_tournament": never;
	"competition.overview.type.national_team_tournament": never;
	"competition.overview.tier.national": never;
	"competition.overview.tier.regional": never;
	"competition.overview.tier.district": never;
	"competition.overview.teams.title": never;
	"competition.overview.teams.enrolled": {
		count: number;
	};
	"competition.overview.teams.search_placeholder": never;
	"competition.overview.teams.show_all": {
		count: string;
	};
	"competition.overview.teams.no_teams": never;
	"competition.overview.games.title": never;
	"competition.overview.games.matches": {
		count: number;
	};
	"competition.overview.games.no_games": never;
	"header.club_pro.leagues": never;
	"pagination.totalResults": {
		count: number;
	};
	"ai.scout_search.prompt_cards.compare_players": never;
	"ai.scout_search.prompt_cards.demo.attacking_midfielders_under_18": never;
	"ai.scout_search.prompt_cards.demo.best_strikers_africa": never;
	"ai.scout_search.prompt_cards.demo.centre_backs_highest_tackle": never;
	"ai.scout_search.prompt_cards.demo.creative_midfielders": never;
	"ai.scout_search.prompt_cards.demo.goalkeepers_over_170": never;
	"ai.scout_search.prompt_cards.demo.midfielders_after_2009": never;
	"ai.scout_search.prompt_cards.demo.rating_above_8": never;
	"ai.scout_search.prompt_cards.demo.top_3_strikers": never;
	"ai.scout_search.prompt_cards.demo.top_goals_per_90": never;
	"ai.scout_search.prompt_cards.demo.wingers_take_on_distribution": never;
	"ai.scout_search.prompt_cards.high_rated_strikers": never;
	"ai.scout_search.prompt_cards.high_rated_u17_attacking_midfielders": never;
	"ai.scout_search.prompt_cards.similar_players": never;
	"ai.scout_search.prompt_cards.top_central_midfielders": never;
	"ai.scout_search.prompt_cards.top_left_backs": never;
	"ai.scout_search.prompt_cards.top_u15_centre_backs": never;
	"ai.scout_search.prompt_cards.top_u18_strikers": never;
	"gamePage.teamStats.type.longBallShare": never;
	"gamePage.playerStats.type.nonPenaltyGoal": never;
	"gamePage.teamStats.type.shotCreatingAction": never;
	"gamePage.playerStats.type.shotCreatingAction": never;
	"gamePage.teamStats.type.passIntoFinalThird": never;
	"gamePage.teamStats.type.passIntoPenaltyArea": never;
	"gamePage.playerStats.type.passIntoPenaltyArea": never;
	"gamePage.playerStats.type.switchOfPlay": never;
	"gamePage.teamStats.type.progressivePass": never;
	"gamePage.playerStats.type.progressivePass": never;
	"gamePage.teamStats.type.deepCompletion": never;
	"gamePage.playerStats.type.deepCompletion": never;
	"gamePage.teamStats.type.progressivePassSuccess": never;
	"gamePage.playerStats.type.progressivePassSuccess": never;
	"gamePage.playerStats.type.progressivePassRatio": never;
	"token.movement.type.remove_analysis": never;
	"token.movement.type.add_analysis_refund": never;
	"gamePage.playerStats.description.passIntoPenaltyArea": never;
	"gamePage.playerStats.description.switchOfPlay": never;
	"gamePage.playerStats.description.progressivePass": never;
	"gamePage.playerStats.description.deepCompletion": never;
	"game.stats.table.passesIntoPenaltyArea": never;
	"game.stats.table.switchesOfPlay": never;
	"game.stats.table.progressivePasses": never;
	"game.stats.table.deepCompletions": never;
	"game.stats.table.nonPenaltyGoals": never;
	"game.stats.table.shotCreatingActions": never;
	"gamePage.playerStats.description.nonPenaltyGoal": never;
	"gamePage.playerStats.description.shotCreatingAction": never;
	"providerOperations.bulk.finishingPreviousRun": never;
	"respovision.request.status.loading": never;
	"respovision.request.status.load_failed": never;
	"respovision.request.status_load_failed": never;
	"respovision.request.retry": never;
	"respovision.request.confirm": never;
	"respovision.request.status.none.tooltip": never;
	"respovision.request.submit.tooltip": never;
	"respovision.request.submit.disabled.pending.tooltip": never;
	"respovision.request.submit.disabled.loading.tooltip": never;
	"respovision.request.submit.disabled.load_failed.tooltip": never;
	"respovision.request.submit.disabled.not_eligible.tooltip": never;
	"respovision.request.submit.disabled.unknown.tooltip": never;
	"respovision.request.external_api_error": never;
	"respovision.request.invalid_json_response": never;
	"respovision.request.lambda_payload_missing": never;
	"respovision.request.match_id_missing": never;
	"respovision.request.sqs_publish_failed": never;
	"respovision.request.submit_missing_match_id": never;
	"respovision.request.token_missing": never;
	"header.club_pro.tournaments": never;
	"tournaments.page.title": never;
	"tournaments.search.placeholder": never;
	"tournaments.list.type.national_team_tournament": never;
	"tournaments.list.type.club_tournament": never;
	"tournaments.list.tournaments_count": {
		count: number;
	};
	"tournaments.list.no_tournaments": never;
	"tournaments.card.subscribed": never;
	"tournaments.card.locked": never;
	"tournaments.card.international": never;
	"portal.player-synopsis.subscription.message": {
		b: (text: string) => any;
		br: (text: string) => any;
	};
	"resource.competitions": never;
	"teamClubPage.filter.season": never;
	"teamClubPage.filter.all_seasons": never;
	"teamClubPage.filter.competition": never;
	"teamClubPage.filter.all_competitions": never;
	"teamClubPage.filter.period": never;
	"discover.gameDetail.field.competitionEdition": never;
	"discover.gameDetail.field.competition": never;
	"app.eyeball.lang.hr": never;
	"leagues.subheader.leagues": never;
	"leagues.subheader.friendlies": never;
	"leagues.subheader.cups": never;
	"ai.player-synopsis.tag.early-access": never;
	"gamePage.stats.category.advancedMetrics": never;
	"ai.player-synopsis.title": never;
	"ai.player-synopsis.title-generating": never;
	"ai.player-synopsis.error.not-enough-minutes": never;
	"ai.player-synopsis.error.general": never;
	"ai.player-synopsis.tag.generated-at": {
		generatedAt: string;
	};
	"ai.player-synopsis.tag.career-disclaimer": never;
	"ai.player-synopsis.career-disclaimer": never;
}

export type Key = keyof Keys;

export enum Locale {
	PT = "pt",
	LV = "lv",
	IT = "it",
	HR = "hr",
	FR = "fr",
	ES = "es",
	EN = "en",
	DE = "de",
	CS = "cs",
	AZ = "az",
}
